export const translations = {
  he: {
    // Navbar
    nav: {
      explore: "קהילה",
      pricing: "תמחור",
      aboutUs: "מי אנחנו",
      gallery: "הגלריה שלי",
      login: "התחברות",
      signup: "הרשמה",
      tryFree: "התחילו בחינם",
      logout: "התנתק",
      logoutSuccess: "התנתקת בהצלחה",
      myProfile: "הפרופיל שלי",
      upgradePlan: "שדרג חבילה",
      managePlan: "ניהול חבילה",
      createNow: "צור עכשיו",
      createNowFree: "התחילו עכשיו בחינם",
      startNow: "התחילו עכשיו",
      profile: "פרופיל",
      selectLanguage: "בחר שפה",
      credits: "קרדיטים",
      remaining: "נותרו",
      plan: "תוכנית",
      defaultUser: "משתמש",
      menu: "תפריט",
      lightMode: "מצב יום",
      darkMode: "מצב לילה",
      admin: "ניהול",
      inviteFriends: "הזמינו חבר",
      myBot: "הבוט שלי",
      betaSection: "B2B",
      devEnvironment: "סביבת פיתוח",
      devModelsLabel: "מודלים",
      devModelsCheap: "זול",
      devModelsNormal: "רגיל",
    },
    // Landing Page
    landing: {
      // Hero
      heroTagline: ".דמיינו. צרו. שתפו",
      heroTitle: "סטודיו הקריאייטיב שלך",
      heroSubtitle: "הדרך המהירה להפוך כל רעיון לתמונות, סרטונים ואנימציות מדהימות. בלי ניסיון נדרש.",
      startFree: "התחילו ליצור בחינם",
      seeHowItWorks: "איך זה עובד?",
      heroBadge: "100 קרדיטים חינם, בלי כרטיס אשראי",
      heroMicrocopyCredits: "100 קרדיטים חינם",
      heroMicrocopyNoCard: "ללא כרטיס אשראי",
      // Trust Badges
      trustBadgeNoWatermarks: "ללא סימני מים",
      trustBadge4K: "איכות עד 4K",
      trustBadgeCommercial: "התוצרים שייכים לכם",
      trustBadgeSpeed: "פחות מ 60 שניות",
      // Hero title split (accent word rendered in brand gradient)
      heroTitlePrefix: "סטודיו ה",
      heroTitleAccent: "קריאייטיב",
      heroTitleSuffix: " שלך",
      // Hero scroll cue
      heroScrollHint: "גלו את הכלים",
      // Social proof strip (numbers live in constants; only labels are translated)
      socialImagesLabel: "תמונות שנוצרו",
      socialCreatorsLabel: "יוצרים פעילים",
      socialSpeedLabel: "ממוצע יצירה",
      // Section eyebrows (small uppercase label above each H2)
      eyebrowProcess: "התהליך",
      eyebrowTestimonials: "המלצות",
      eyebrowPricing: "תמחור",
      eyebrowFaq: "שאלות נפוצות",
      // How It Works
      howItWorksTitle: "איך זה עובד",
      howItWorksSubtitle:
        "יצרנו טכנולוגיה חדשנית שמבוססת על הכלים המתקדמים בעולם, כדי להעניק לכם חוויה פשוטה ויחודית ותוצרים ברמת סטודיו אמיתי. במקום לבזבז כסף על צלמים, ציוד יקר וזמן יקר, תקבלו אצלנו את הכל בלחיצת כפתור ובמחיר נגיש. אל תשארו מאחור! התחילו עכשיו!",
      // Testimonials / Social Proof
      testimonialsTitle: "הם כבר יוצרים עם TodoAI",
      testimonialsSubtitle: "הצטרפו ל-1,000+ אנשים ועסקים שכבר שדרגו את הנראות שלהם",
      testimonial1Quote: "לא חשבתי שזה באמת יעבוד, אבל התמונות הראשונות שיצרתי לחנות פשוט הפתיעו אותי. עכשיו אני לא מעלה מוצר בלי זה.",
      testimonial1Name: "מיכל כ.",
      testimonial1Role: "בעלת חנות אונליין",
      testimonial2Quote: "חבר שלח לי לינק ואמר ״תנסה.״ מאז אני משתמש בזה לכל דבר - פוסטים, מתנות, ברכות. פשוט ממכר.",
      testimonial2Name: "אורי ש.",
      testimonial2Role: "יוצר תוכן",
      testimonial3Quote: "אני מעלה סטוריז לסטודיו כמעט כל יום. פעם לקח לי לפחות שעה, היום זה עניין של דקות.",
      testimonial3Name: "נועה ד.",
      testimonial3Role: "בעלת סטודיו ליוגה",
      testimonial4Quote: "שלחתי תמונה של הפיצה שלנו וקיבלתי תמונת פרסומת שנראית כאילו צלם מקצועי צילם אותה. לקוחות חשבו ששכרנו סוכנות.",
      testimonial4Name: "דני ר.",
      testimonial4Role: "מנהל מסעדה",
      testimonial5Quote: "היה לי רעיון להזמנה לחתונה אבל אפס כישרון בעיצוב. אחרי כמה ניסיונות קיבלתי בדיוק מה שדמיינתי. שמחה שגיליתי את זה.",
      testimonial5Name: "רונית א.",
      testimonial5Role: "לקוחה פרטית",
      testimonial6Quote: "יש לנו מאות מוצרים ולצלם כל אחד זה סיפור שלם. עכשיו מעלים תמונה פשוטה ומקבלים קטלוג שלם. חוסך לנו המון.",
      testimonial6Name: "יוסי מ.",
      testimonial6Role: "בעל חנות רהיטים",
      // Community Gallery
      galleryTitle: "נוצר עם TodoAI",
      gallerySubtitle: "תוצאות אמיתיות ממשתמשים אמיתיים",
      galleryCta: "גלו את הגלריה המלאה",
      galleryEmpty: "עדיין אין יצירות בגלריה.",
      galleryImageAlt: "יצירה מהקהילה",
      // Pricing Preview
      pricingTitle: "תמחור פשוט ושקוף",
      pricingSubtitle: "התחילו בחינם. שדרגו כשמתחשק.",
      pricingFreeHighlight: "100 קרדיטים בחינם, ללא כרטיס אשראי",
      pricingFreeLabel: "חינם",
      pricingTokens: "טוקנים",
      pricingMonth: "לחודש",
      pricingCompareAll: "השוו את כל התוכניות",
      pricingFreeCta: "התחילו בחינם",
      pricingPaidCta: "בחרו תוכנית",
      // FAQ
      faqTitle: "שאלות? יש לנו תשובות.",
      faq1Q: "?אני לא מעצב/ת ולא אדם טכנולוגי. אני באמת יכול/ה להשתמש בזה",
      faq1A: "בהחלט. מעלים תמונה, והבינה המלאכותית עושה את העבודה היצירתית. בלי תוכנות עיצוב, בלי הגדרות מסובכות, בלי עקומת למידה. אם אתם יודעים לצרף תמונה להודעה, אתם יודעים להשתמש ב-TodoAI.",
      faq2Q: "?מה הקאטצ' בתוכנית החינמית",
      faq2A: "אין קאטצ'. מקבלים 100 טוקנים, גישה לכל הפיצ'רים, כל מודלי הבינה המלאכותית, איכות 4K, ואפס סימני מים. לא צריך כרטיס אשראי כדי להתחיל. אנחנו רוצים שתנסו ותראו את התוצאות בעצמכם לפני שמחליטים לשלם.",
      faq3Q: "?מה אפשר ליצור עם TodoAI",
      faq3A: "כמעט כל דבר ויזואלי! צרו תמונות מתיאורי טקסט, הפכו תמונות לסרטונים, הנפישו תמונות סטילס, צרו צילומי מוצר, וגלו רעיונות קריאייטיביים עם הצ'אט שלנו. בין אם זה תוכן לרשתות, אמנות אישית או ויזואלים לעסק, אנחנו כאן בשבילכם.",
      faq4Q: "?אפשר להשתמש במה שיוצרים למטרות מסחריות",
      faq4A: "!100%. כל מה שיוצרים ב-TodoAI שייך לכם. זכויות מסחריות מלאות. להשתמש ברשתות חברתיות, בפרסומות, באתר, בדפוס, או בכל מקום שצריך.",
      faq5Q: "?אני נעול/ה בחוזה? אפשר לבטל בכל עת",
      faq5A: "בלי חוזים, בלי התחייבויות. אפשר לבטל את המנוי בכל רגע בלחיצה אחת, וממשיכים ליהנות מהגישה עד סוף תקופת החיוב. לתוכנית החינמית אפילו לא צריך כרטיס אשראי.",
      // Final CTA
      finalCtaTitle: "היצירה הראשונה עלינו.",
      finalCtaSubtitle: "חינם להתחיל. ללא כרטיס אשראי. ללא ניסיון נדרש.",
      finalCtaButton: "התחילו ליצור בחינם",
      finalCtaTrust: "100 קרדיטים חינם כלולים. ביטול בכל עת.",
    },
    // Footer
    footer: {
      description: "צרו תמונות, סרטונים ואנימציות מדהימות עם AI. TodoAI הוא הדרך המהירה ביותר להגשים את הרעיונות שלכם. בלי צורך בניסיון עיצובי.",
      create: "יצירה",
      images: "תמונות",
      imageGenerator: "יצירת תמונה",
      adsCreator: "סטודיו מוצר",
      imageDirector: "סוכן תמונות",
      profilePhoto: "תמונות תדמית",
      productCreative: "קרייטיב למוצר",
      videos: "סרטונים",
      framesToVideo: "פריימים לוידאו",
      textToVideo: "טקסט לוידאו",
      talkingAvatar: "דמות מדברת",
      discover: "גלו עוד",
      explore: "קהילה",
      pricing: "מחירים",
      contact: "צור קשר",
      legal: "משפטי",
      privacy: "מדיניות פרטיות",
      terms: "תנאי שימוש",
      accessibility: "הצהרת נגישות",
      support: "תמיכה",
      help: "עזרה",
      suggestFeature: "הציעו רעיון",
      copyright: "© 2026 TodoAI Technologies Inc.",
      manageCookies: "ניהול עוגיות",
      agencyCta: "צריכים הרצאות, סדנאות או אוטומציות AI מותאמות לעסק? בקרו ב-TodoAI",
    },
    // Cookie Consent
    cookieConsent: {
      bannerTitle: "אנחנו משתמשים בעוגיות",
      bannerDescription: "אנחנו משתמשים בעוגיות כדי לשפר את חוויית השימוש שלך ולנתח את השימוש באתר. תוכל לבחור אילו עוגיות לאפשר.",
      acceptAll: "אישור הכל",
      rejectAll: "דחייה",
      customize: "התאמה אישית",
      learnMore: "מדיניות פרטיות",
      preferenceCenterTitle: "הגדרות עוגיות",
      preferenceCenterDescription: "בחר אילו עוגיות ברצונך לאפשר. עוגיות חיוניות נדרשות לתפקוד האתר ואינן ניתנות לביטול.",
      essentialTitle: "עוגיות חיוניות",
      essentialDescription: "נדרשות לתפקוד האתר — אימות, ניהול הפעלות והעדפות שפה.",
      essentialBadge: "נדרש",
      analyticsTitle: "עוגיות אנליטיקה",
      analyticsDescription: "עוזרות לנו להבין כיצד המבקרים משתמשים באתר, כולל צפיות בדפים, שימוש בתכונות וניתוח ביצועים.",
      savePreferences: "שמירת העדפות",
      cancel: "ביטול",
    },
    // Sidebar
    sidebar: {
      overview: "סקירה כללית",
      creativeStudio: "סטודיו ליצירה",
      upgradePlan: "שדרוג תוכנית",
      supportInfo: "תמיכה ומידע",
      helpCenter: "מרכז עזרה",
      apiDocs: "תיעוד API",
    },
    // Generate Page
    generate: {
      title: "סטודיו ליצירה",
      createImage: "צור תמונה",
      editImage: "ערוך תמונה",
      createVideo: "צור סרטון",
      uploadImage: "העלה תמונה",
      uploadImageDesc: "גרור לכאן או לחץ לבחירת קובץ",
      supportedFormats: "PNG, JPG, WEBP עד 10MB",
      changeImage: "החלף תמונה",
      prompt: "פרומפט",
      promptPlaceholder: "תארו את הוויזואל שתרצו ליצור...",
      customizePrompt: "התאמה אישית",
      autoPromptTitle: "אין צורך לכתוב פרומפט",
      autoPromptSubtitle: "אנחנו נעשה את הקסם פשוט העלו תמונת מוצר",
      aspectRatio: "יחס גובה-רוחב",
      resolution: "רזולוציה",
      createAd: "צור מודעה",
      generatedImages: "תמונות שנוצרו",
      clickToOpen: "לחץ לפתיחה",
      uploadRequired: "יש להעלות תמונה",
      uploadRequiredDesc: "יש להעלות את התמונה הרצויה למקום המיועד",
      imagesReady: "התמונות מוכנות! 🎉",
      imagesReadyDesc: "4 תמונות חדשות נוספו לגלריה שלך",
      noCredits: "נגמרו לך הקרדיטים",
      sound: "סאונד",
      firstFrame: "פריים ראשון",
      endFrame: "פריים אחרון",
      videoModel: "מודל סרטון",
      uploadFirstFrame: "העלה תמונה ראשונה",
      uploadEndFrame: "העלה תמונה אחרונה",
      uploadSingleImage: "העלה תמונה",
      createVideoBtn: "צור סרטון",
      videoReady: "הסרטון מוכן! 🎉",
      videoReadyDesc: "הסרטון נוסף לגלריה שלך",
      // Additional keys for Generate page
      creativeStudio: "סטודיו קריאייטיב",
      newAdCreation: "יצירת מודעה חדשה",
      upgradePlan: "שדרוג חבילה",
      imagesTab: "תמונות",
      editTab: "עריכה",
      videosTab: "סרטונים",
      marketingStudioTab: "סטודיו שיווק",
      trendsTab: "טרנדים",
      dragImageHere: "גרור תמונה לכאן",
      dragOrClick: "גרור תמונה לכאן או לחץ להעלאה",
      dragOrClickShort: "גרור או לחץ",
      upTo10mb: "עד 10MB",
      yourCreations: "היצירות שלכם",
      yourVideos: "הסרטונים שלכם",
      processing: "מעבד...",
      creatingVideo: "יוצר סרטון...",
      // Inline "all set" card shown after a flow's last step (FlowReadyCta)
      allReadyTitle: "הכל מוכן!",
      allReadyHint: "לחצו על הכפתור כדי להתחיל ביצירה",
      selectStyle: "🎨 בחר סגנון",
      flowlyMagic: "TodoAI מייצר קסם...",
      aiProcessing: "ה-AI שלנו מעבד כעת 4 וריאציות שונות עבורך.",
      generatedImagesTitle: "📸 התמונות שנוצרו",
      clickCreateAd: "לחץ על \"צור מודעה\" כדי ליצור תמונות",
      selectModel: "בחר מודל:",
      framesToVideo: "פריימים לוידאו",
      textToVideo: "טקסט לוידאו",
      talkingAvatar: "דמות מדברת",
      imageGeneratorDesc: "צרו תמונות מתיאור טקסט",
      adsCreatorDesc: "מתמונת מוצר לויזואל מקצועי",
      imageDirectorDesc: "שפרו תמונות דרך שיחה",
      profilePhotoDesc: "תמונות תדמית מקצועיות לפרופיל",
      productCreativeDesc: "המערכת יוצרת ויזואל מקצועי למוצר שלכם — בלי לכתוב פרומפט",
      framesToVideoDesc: "הנפשה בין פריימים",
      textToVideoDesc: "תארו סצנה, קבלו סרטון",
      talkingAvatarDesc: "מתמונה אחת — סרטון של דמות מדברת",
      baseballTrendDesc: "תמונה אחת ← סרטון שידור-חי ויראלי",
      noModelsAvailable: "אין מודלים זמינים",
      bestModelForFlow: "המודל הטוב ביותר לתהליך הזה",
      firstFrameLabel: "תמונה ראשונה (First Frame)",
      endFrameLabel: "תמונה אחרונה (End Frame)",
      endFrameOptional: "End Frame (אופציונלי)",
      sourceImage: "תמונת מקור",
      uploadForAnimation: "העלה תמונה להנפשה לסרטון",
      soundEnabled: "SOUND מופעל",
      addSound: "הוסף SOUND",
      soundAlwaysOn: "SOUND מובנה",
      animationInstructions: "הוראות הנפשה",
      model: "מודל",
      describeMotion: "תאר את התנועה הרצויה",
      enhancePrompt: "שפר פרומט",
      videoPromptPlaceholder: "לדוגמה: המוצר מסתובב לאט, זום אין חלק, חלקיקים נוצצים ברקע...",
      rotate360: "🔄 סיבוב 360°",
      slowZoomIn: "🔍 זום אין איטי",
      dynamicBackground: "🌊 רקע דינמי",
      sparklingParticles: "✨ חלקיקים נוצצים",
      waveEffect: "〰️ אפקט גלים",
      cinematicMotion: "🎬 תנועה סינמטית",
      creatingVideoTitle: "יוצר סרטון...",
      modelProcessing: "מעבד את התמונה",
      video: "סרטון",
      imageSelected: "תמונה נבחרה",
      change: "החלף",
      insertImageHint: "יש להכניס תמונה לאזור המסומן",
      fiveSeconds: "5ש׳",
      tenSeconds: "10ש׳",
      fourSeconds: "4ש׳",
      eightSeconds: "8ש׳",
      twelveSeconds: "12ש׳",
      soraPromptPlaceholder: "תאר את הסרטון שברצונך ליצור בפירוט",
      backgroundColor: "צבע רקע",
      darkGray: "אפור כהה",
      white: "לבן",
      auto: "אוטו׳",
      animateBetweenFrames: "הנפשה בין שתי התמונות",
      fastAnimationPlaceholder: "הנפשה מהירה מהתמונה הראשונה לתמונה האחרונה",
      generationFailed: "שגיאה ביצירת התמונות",
      generationFailedDesc: "אירעה שגיאה בעת יצירת התמונות. נסה שוב.",
      failedRefunded: "נכשל - קרידיטים הוחזרו",
      generationFailedWithRefund: "היצירה נכשלה. הקרדיטים הוחזרו.",
      generationInProgress: "יש יצירה בתהליך",
      parallelProRequired: "יצירה במקביל זמינה במסלול PRO",
      progressPreparing: "מכין...",
      progressGenerating: "מייצר...",
      progressEnhancing: "משפר...",
      progressAlmostReady: "כמעט מוכן...",
      progressDone: "סיום!",
      previewInProgress: "בייצור, אנא המתן",
      contentFlagged: "תוכן נחסם",
      contentFlaggedDesc: "התוכן נחסם על ידי מסנן הבטיחות. הקרדיטים הוחזרו.",
      staleGenerationCleaned: "חלק מהיצירות פג תוקפן וסומנו כנכשלו",
      promptImproved: "הפרומט שופר!",
      promptImprovedDesc: "הפרומט הורחב והופך למקצועי יותר",
      enhanceFailed: "שגיאה בשיפור",
      tryAgain: "נסה שוב",
      enhanceError: "אירעה שגיאה בשיפור הפרומט",
      improving: "משפר...",
      recommended: "מומלץ",
      new: "חדש",
      animateBetweenImages: "🔀 הנפשה בין תמונות",
      creationInstructions: "הוראות יצירה",
      noCreationsYet: "אין יצירות עדיין",
      startCreating: "העלו תמונה והתחילו ליצור",
      noVideosYet: "אין סרטונים עדיין",
      startCreatingVideos: "העלו תמונה והתחילו ליצור סרטונים",
      modelHighDemand: "מודל זה חווה ביקוש גבוה. יצירה עשויה לקחת זמן רב יותר או להיכשל זמנית, קרדיטים יוחזרו",
      quantity: "כמות",
      swapFrames: "החלף פריימים",
      selectProvider: "בחר ספק",
      providerOpenAI: "OpenAI",
      providerGemini: "Google Gemini",
      providerKling: "Kling AI",
      providerSora: "Sora (OpenAI)",
      providerBFL: "FLUX",
      perImage: "לתמונה",
      perVideo: "לסרטון",
    },
    // Image Generator Page
    imageGenerator: {
      title: "יצירת תמונה",
      editPromptPlaceholder: "תאר את התמונה שתרצה ליצור...",
      editImage: "צור תמונה",
      editedImages: "תמונות שנוצרו",
      imageReady: "התמונה מוכנה! 🎉",
      imageReadyDesc: "התמונה שנוצרה נוספה לגלריה שלך",
      originalImage: "תמונת מקור",
      uploadForEdit: "העלה תמונת מקור",
      replace: "החלף",
      uploadImage: "העלה תמונה",
      uploadWithAI: "העלה תמונה ליצירה עם AI",
      editResults: "תוצאות היצירה",
      editInstructions: "הוראות יצירה",
      whatToChange: "מה תרצה ליצור?",
      promptPlaceholder: "לדוגמה: שנה את הרקע לחוף ים, הוסף שקיעה, הפוך לסגנון רטרו...",
      improvePrompt: "שפר פרומט",
      improving: "משפר...",
      promptImproved: "הפרומט שופר!",
      promptImprovedDesc: "הפרומט הורחב והופך למקצועי יותר",
      enhanceFailed: "שגיאה בשיפור",
      tryAgain: "נסה שוב",
      enhanceError: "אירעה שגיאה בשיפור הפרומט",
      enterEditInstructions: "נא להזין הוראות יצירה",
      enterEditInstructionsDesc: "ספר לנו מה תרצה ליצור",
      pleaseUploadImage: "נא להעלות תמונה",
      pleaseUploadImageDesc: "העלה תמונת מקור",
      editCompleted: "היצירה הושלמה!",
      editCompletedDesc: "התמונה שלך נוצרה",
      editFailed: "היצירה נכשלה",
      editFailedDesc: "אירעה שגיאה בעת יצירת התמונה",
      processingImage: "יוצר תמונה...",
      aiEditing: "ה-AI שלנו יוצר את התמונה לפי ההוראות",
      download: "הורדה",
      moreEditing: "צור עוד",
      editingImage: "יוצר תמונה...",
      quickStudioBg: "🎨 רקע סטודיו",
      quickDramaticLight: "💡 תאורה דרמטית",
      quickMinimalist: "✨ מינימליסטי",
      quickBlackWhite: "🖤 שחור-לבן",
      quickShadows: "🌑 הוסף צללים",
      yourCreations: "היצירות שלכם",
      clickToOpen: "לחץ לפתיחה",
      editImageBtn: "צור תמונה",
      noEditsYet: "אין עריכות עדיין",
      startEditing: "העלו תמונה והתחילו לערוך",
      referenceImages: "תמונות ייחוס",
      addReferenceHint: "הוסיפו תמונות סגנון או הקשר (אופציונלי)",
    },
    // Profile Photo Page
    profilePhoto: {
      title: "תמונות תדמית",
      subtitle: "צרו תמונות מקצועיות בסגנון לינקדאין מהפנים שלכם",
      heroBadge: "AI Headshot Generator",
      heroTitle: "תמונת פרופיל מקצועית בקליק",
      heroSubtitle: "העלו תמונות פנים, בחרו סגנון, וקבלו תמונת תדמית בסגנון לינקדאין מותאמת אישית לכם.",
      heroUploadTitle: "גררו תמונות לכאן או לחצו להעלאה",
      heroUploadHint: "2–3 תמונות פנים מזוויות שונות לתוצאה הטובה ביותר",
      uploadFormats: "JPG, PNG · עד 10MB לתמונה",
      beforeLabel: "לפני",
      afterLabel: "אחרי",
      afterPlaceholder: "התמונה שלך",
      createNowCta: "צור עכשיו",
      guideModalTitle: "טיפ קטן וחשוב",
      guideModalBody:
        "וודאו שהעליתם תמונה ברורה ובאיכות טובה שבה הפנים שלכם גלויים בבירור מול המצלמה מקרוב — התמונה משפיעה ישירות על איכות התוצאה.",
      guideImageCaption: "ככה לצלם",
      guideModalCta: "הבנתי",
      genderQuestion: "שלב 2 · בחרו את המגדר",
      genderMale: "גבר",
      genderFemale: "אישה",
      pickPreset: "שלב 3 · בחרו סגנון",
      pickPresetHint: "כל סגנון יוצר מראה ובגדים שונים — לחצו לבחירה",
      uploadTitle: "שלב 1 · העלו 2–3 תמונות פנים",
      uploadHint: "להוצאת תוצאות מצוינות העלו 3 תמונות מזוויות שונות",
      minUploadsHint: "הוסיפו עוד תמונה אחת — נדרשות לפחות 2 כדי ליצור.",
      uploadAdd: "הוסיפו תמונה",
      removePhoto: "הסר",
      generateBtn: "צור תמונות תדמית",
      generating: "יוצר...",
      missingGender: "בחרו מגדר",
      missingPreset: "בחרו סגנון",
      missingUpload: "העלו לפחות 2 תמונות",
      results: "התוצאות שלכם",
      noResults: "לחצו 'צור' כדי לקבל תמונות חדשות",
      generationFailed: "היצירה נכשלה",
      generationFailedDesc: "אירעה שגיאה. הקרדיטים הוחזרו אוטומטית.",
      invalidImage: "לא הצלחנו לקרוא את התמונה. נסו תמונה ברורה בפורמט JPG או PNG עד 10MB.",
      linkCopied: "הקישור הועתק",
      downloadAria: "הורדה",
      hairPickerTitle: "שלב 4 · התאמת תסרוקת",
      hairPickerHint: "כברירת מחדל נשמור על השיער שלכם כמו בתמונה. אפשר גם לבחור תסרוקת חדשה",
      hairKeepTitle: "השאר את השיער כמו בתמונה",
      hairKeepSubtitle: "בלי לשנות צבע, אורך או תסרוקת",
      hairDescribeTitle: "תאר תסרוקת חדשה",
      hairDescribeSubtitle: "חייב להיות דמיון לתמונה המקורית",
      hairDescriptionLabel: "תיאור התסרוקת",
      hairDescriptionPlaceholder: "לדוגמה: קוקו אסוף עם פס שיער קדימה",
      customCardSubtitle: "עיצוב אישי",
      customTitle: "עצבו את הסגנון שלכם",
      customExplanation:
        "בחרו בעצמכם את רקע התמונה ואת הלבוש — הם ישולבו ישירות בתמונה שתיווצר.",
      customBackgroundLabel: "רקע התמונה",
      customBackgroundPlaceholder: "לדוגמה: רקע סטודיו אפור רך",
      customClothingLabel: "סגנון הלבוש",
      customClothingPlaceholder: "לדוגמה: חליפה כחולה כהה עם חולצה לבנה",
      customChipsHint: "או בחרו הצעה מהירה:",
      customBackgroundChips: [
        "רקע סטודיו אפור רך",
        "משרד מודרני מטושטש",
        "רקע לבן נקי",
        "גרדיאנט אפור כהה",
        "קיר בז' חמים",
      ],
      customClothingChips: [
        "חליפה כחולה כהה עם עניבה",
        "בלייזר אלגנט מעל חולצה לבנה",
        "סוודר סרוג כהה",
        "חליפה שחורה קלאסית",
        "חולצת פולו נקייה",
      ],
      customContinue: "המשך",
      presets: {
        customStyle: "סגנון אישי",
        maleCorporateSuit: "חליפה עסקית",
        maleBusinessCasual: "אלגנט-יומיומי",
        maleTechStartup: "סטארטאפ",
        maleClassicPortrait: "פורטרט קלאסי",
        femaleCorporateSuit: "חליפה עסקית",
        femaleBusinessCasual: "אלגנט-יומיומי",
        femaleTechStartup: "סטארטאפ",
        femaleClassicPortrait: "פורטרט קלאסי",
      },
    },
    landingFlows: {
      title: "בחרו פלואו והתחילו עכשיו",
      imagesSectionTitle: "תמונות סטודיו",
      videosSectionTitle: "סרטונים ואנימציות בלחיצת כפתור",
      beforeLabel: "לפני",
      afterLabel: "אחרי",
      tryCta: "נסה עכשיו",
      flows: {
        profilePhoto: {
          name: "תמונות תדמית",
          description: "תמונה מקצועית בסגנון לינקדאין, מהפנים שלך, בלחיצה",
        },
        productStudio: {
          name: "סטודיו מוצר",
          description: "4 תמונות סטודיו מקצועיות עם רקעים נקיים, מתמונה אחת",
        },
        productCreative: {
          name: "קרייטיב למוצר",
          description: "פרסומת מוכנה עם רקע נקי ואלמנטים דינמיים סביב המוצר",
        },
        baseballTrend: {
          name: "טרנד הבייסבול",
          description: "תמונה אחת ← סרטון בסגנון \"שידור חי\" שתפס אותך ביציע",
        },
        talkingAvatar: {
          name: "דמות מדברת",
          description: "מתמונה אחת לסרטון של דמות מדברת עם ליפסינק אוטומטי",
        },
      },
    },
    productCreative: {
      title: "קרייטיב למוצר",
      subtitle: "המערכת יוצרת לכם ויזואל מקצועי למוצר — ללא צורך בכתיבת פרומפט",
      heroTitle: "ויזואל מקצועי למוצר — בלחיצה אחת",
      heroSubtitle: "העלו תמונת מוצר, והמערכת יוצרת עבורכם את הוויזואל המקצועי — בלי לכתוב פרומפט, בלי הגדרות. רקע נקי, אלמנטים דינמיים, אווירה קולנועית.",
      heroUploadTitle: "גררו תמונת מוצר לכאן או לחצו להעלאה",
      heroUploadHint: "1–3 תמונות מאותו מוצר לתוצאה הטובה ביותר",
      uploadFormats: "JPG, PNG · עד 10MB לתמונה",
      beforeLabel: "המוצר",
      afterLabel: "הקרייטיב",
      afterPlaceholder: "התמונה שלך",
      createNowCta: "צור עכשיו",
      firstUploadTipTitle: "טיפ לתוצאה מקצועית",
      firstUploadTipDesc: "העלו תמונה ברורה של המוצר על רקע נקי. ככל שהמוצר חד יותר, התוצאה תהיה טובה יותר.",
      uploadTitle: "שלב 1 · העלו 1–3 תמונות מוצר",
      uploadHint: "להוצאת תוצאות מצוינות העלו תמונות בזוויות שונות",
      uploadAdd: "הוסיפו תמונה",
      removePhoto: "הסר",
      stylePickerTitle: "שלב 2 · בחרו סגנון יצירתי",
      stylePickerHint: "תנו למערכת להחליט, או כתבו בעצמכם איך אתם רוצים שזה ייראה",
      styleAutoTitle: "תן למערכת לבחור",
      styleAutoSubtitle: "המערכת תחליט על הרקע והאלמנטים הכי מתאימים למוצר שלכם",
      styleManualTitle: "בחר אלמנטים בעצמך",
      styleManualSubtitle: "כתבו מה אתם רוצים שיהיה ברקע ויעוף סביב המוצר",
      customDirectionLabel: "תיאור הרקע והאלמנטים",
      customDirectionPlaceholder: "לדוגמה: רקע ים כחול עם קונכיות, אצות וטיפות מים מתעופפות סביב הבקבוק",
      generateBtn: "צור קרייטיב",
      generating: "יוצר...",
      results: "הקרייטיבים שלך",
      noResults: "לחצו 'צור' כדי לקבל קרייטיבים חדשים",
      generationFailed: "היצירה נכשלה",
      generationFailedDesc: "אירעה שגיאה. הקרדיטים הוחזרו אוטומטית.",
      linkCopied: "הקישור הועתק",
      downloadAria: "הורדה",
    },
    talkingAvatar: {
      title: "דמות מדברת",
      subtitle: "מתמונה אחת לסרטון של דמות מדברת — בסגנון שבחרתם",
      heroTitle: "הפכו תמונה לסרטון מדבר",
      heroSubtitle: "העלו תמונה של אדם או חפץ, בחרו סגנון, כתבו מה היא תגיד — והמערכת מייצרת סרטון מדבר עם ליפסינק אוטומטי.",
      heroUploadTitle: "גררו תמונה לכאן או לחצו להעלאה",
      heroUploadHint: "תמונה ברורה של אדם או חפץ — תמונה אחת מספיקה",
      uploadFormats: "JPG, PNG · עד 10MB",
      beforeLabel: "התמונה",
      afterLabel: "הסרטון",
      afterPlaceholder: "הסרטון שלך",
      createNowCta: "צור עכשיו",
      // Step-number prefix — numbers are computed at render time because the
      // path length changes with the step-2 image mode (source skips 4 steps).
      stepPrefix: "שלב {n} · ",
      // Upload-guide popup — shown once after the first upload (twin of
      // profilePhoto.guideModal*).
      guideModalTitle: "טיפ קטן וחשוב",
      guideModalBody: "העלו תמונה ברורה שבה הדמות קרובה למצלמה — עיניים ופה גלויים. ככה הליפסינק יוצא הכי טוב; תמונה מרחוק תעבוד פחות טוב. אדם, חיה או דמות מצוירת — הכל הולך.",
      guideImageCaption: "ככה זה צריך להיראות",
      guideModalCta: "הבנתי",
      // Step 2 — Image mode (use the uploaded photo vs. design a new one)
      imageModeTitle: "שלב 2 · איזו תמונה תדבר בסרטון?",
      imageModeHint: "אפשר להשתמש בתמונה שהעליתם בדיוק כמו שהיא, או לתת ל-AI לעצב ממנה תמונה חדשה",
      imageModeSourceTitle: "התמונה שהעליתי",
      imageModeSourceSubtitle: "ממשיכים ישר לבחירת מה הדמות תגיד — בלי עיצוב מחדש",
      imageModeGenerateTitle: "תמונה חדשה ומעוצבת",
      imageModeGenerateSubtitle: "בוחרים סגנון ורקע, ה-AI יוצר גרסה חדשה — ואז היא תדבר",
      // Style (generate path)
      stylePickerTitle: "בחרו סגנון",
      stylePickerHint: "ריאליסטי שומר על הסגנון המקורי של התמונה; מצוייר הופך את הסצנה ל-3D מסוגנן",
      styleRealisticTitle: "ריאליסטי",
      styleRealisticSubtitle: "נצמד לסגנון של תמונת המקור",
      styleCartoonTitle: "מצוייר (Pixar)",
      styleCartoonSubtitle: "סגנון תלת-ממדי מסוגנן",
      // Background description (generate path — drives the preview prompt)
      backgroundStepTitle: "תיאור הרקע והקומפוזיציה",
      backgroundStepHint: "הטקסט הזה ישפיע על איך התמונה תיווצר — הרקע, הסביבה, הקומפוזיציה.",
      backgroundPresetsLabel: "תיאורים מהירים",
      backgroundPresetOfficeLabel: "רקע של משרד",
      backgroundPresetOfficeText: "רקע של משרד מודרני, חלונות גדולים, אור טבעי",
      backgroundPresetForestLabel: "רקע של יער",
      backgroundPresetForestText: "רקע של יער עם עצים ירוקים ואור שמש רך",
      backgroundPresetHomeLabel: "רקע של בית",
      backgroundPresetHomeText: "רקע של בית מעוצב, סלון חמים ואור נעים",
      backgroundPresetKitchenLabel: "רקע של מטבח",
      backgroundPresetKitchenText: "רקע של מטבח מודרני עם אור טבעי",
      previewHistoryTitle: "תמונות שיצרת בעבר",
      previewHistoryHint: "אפשר לבחור גם תמונה ישנה שיצרת ולהפוך אותה לסרטון",
      previewHistoryShowMore: "הצג עוד",
      previewHistoryDialogTitle: "ההיסטוריה של תצוגות הדמות",
      createCharactersCta: "צור 2 דמויות",
      advancedToggleShow: "הוראות מתקדמות",
      advancedToggleHide: "הסתר הוראות מתקדמות",
      advancedCompositionLabel: "קומפוזיציה (פוזה, אביזרים, מסגור)",
      advancedCompositionPlaceholder: "לדוגמה: יושב על כיסא משרדי, מחזיק כוס קפה, מצולם מהמותניים ומעלה",
      advancedCompositionHint: "פרטו פוזה (יושב/עומד), אביזרים (מה הוא מחזיק), זווית מצלמה — הכל ישולב בפרומפט.",
      // Source image preview
      sourcePhotoLabel: "תמונת המקור שלך",
      replaceImageCta: "החלף תמונה",
      // Preview pair (generate path)
      previewPickerTitle: "בחרו תמונה לעבוד איתה",
      previewPickerHint: "צרו 2 דמויות ובחרו את המועדפת — היא תהפוך לסרטון מדבר",
      previewRegenerateCta: "צור 2 נוספות",
      previewGenerating: "יוצר 2 תמונות...",
      previewFailedDesc: "אירעה שגיאה ביצירת התמונות. הקרדיטים הוחזרו.",
      previewDownloadAria: "הורד תמונה",
      // Dialogue (background moved out)
      dialogueTitle: "מה הדמות תגיד?",
      dialogueHint: "עד 60 מילים. הטקסט יומר לדיבור עם ליפסינק.",
      dialogueLabel: "טקסט הדיבור",
      dialoguePlaceholder: "שלום, אני המוצר החדש שלכם — אנחנו עומדים לשנות את כללי המשחק.",
      // Step 6 — Motion / action (Kling Avatar positivePrompt)
      motionToggleShow: "תנועה / פעולה (אופציונלי)",
      motionToggleHide: "הסתר תנועה / פעולה",
      motionLabel: "תיאור התנועה במהלך הדיבור",
      motionPlaceholder: "לדוגמה: מנפנף ביד בברכה, מחייך, מטה את הראש קלות",
      motionHint: "תאר תנועה/הבעה/ג'סטה שהדמות תבצע בזמן הדיבור. הפנים יישארו מול המצלמה לליפסינק.",
      backgroundLabel: "תיאור הרקע",
      backgroundPlaceholder: "סטודיו לבן עם תאורה רכה",
      wordCountLabel: "{count} / {max} מילים",
      minWordsHint: "כתבו לפחות {min} מילים כדי שיהיה מספיק אודיו לליפסינק.",
      // Voice picker (text path)
      voicePickerTitle: "בחרו קול",
      voicePickerHint: "כל הקולות תומכים גם בעברית",
      voicesLoading: "טוען קולות...",
      voiceLanguageEn: "אנגלית",
      voiceLanguageHe: "עברית",
      voiceLanguageMulti: "רב-לשוני",
      voiceGenderMale: "גבר",
      voiceGenderFemale: "אישה",
      voices: {
        rachel: "Rachel",
        domi: "Domi",
        antoni: "Antoni",
        josh: "Josh",
        sarah: "שרה",
        george: "ג'ורג'",
        bella: "בלה",
        jessica: "ג'סיקה",
        brian: "בריאן",
        liam: "ליאם",
        stevie: "סטיבי",
        gappu: "גאפו",
        littleDude: "ליטל דוד",
        minnie: "מיני",
        miffy: "מיפי",
      },
      voiceCategories: {
        sarah: "הסברה ופרזנטציות",
        bella: "סיפורים ותוכן רגוע",
        jessica: "שיווק ורשתות חברתיות",
        george: "קריינות וסיפורים",
        brian: "קריינות ופרסומות",
        liam: "תוכן דינמי ואנרגטי",
        stevie: "דמות מצוירת אנרגטית",
        gappu: "דמות ילדים מצחיקה",
        littleDude: "דמות מצוירת מגניבה",
        minnie: "דמות מצוירת חדה",
        miffy: "דמות מצוירת קופצנית",
      },
      // Voice filter — a "Categories" toggle that reveals 3 category buttons.
      voiceFilterToggle: "קטגוריות",
      voiceFilterAll: "הכל",
      voiceMoreAria: "עוד קולות",
      voiceCategoryNames: {
        narration: "קריינות וסיפורים",
        marketing: "שיווק ופרסום",
        cartoon: "דמויות מצוירות",
      },
      previewPlayAria: "השמע דוגמית",
      cloneVoiceCta: "צרו קול מותאם משלכם",
      cloneVoiceHint: "הקליטו 30-60 שניות. אחרי הקלון תוכלו לבחור את הקול שלכם בכל סרטון.",
      cloneVoiceProOnly: "זמין למנויי Pro ומעלה",
      cloneVoiceBadge: "פיצ'ר מומלץ",
      uploadVoiceCta: "יש לכם כבר קובץ קול? העלו אותו",
      uploadVoiceHint: "MP3, WAV או M4A — חוסך לכם את שלב ההקלטה",
      clonedVoiceBadge: "הקול שלך",
      clonedVoiceDelete: "מחק את הקול המותאם",
      cloneModalTitle: "צור קול מותאם",
      cloneModalDescription: "הקליטו דקה של דיבור רציף בעברית בקול ברור (ללא רעשי רקע) ובחרו שם שיופיע בבחירת הקולות.",
      cloneModalNameLabel: "שם הקול",
      cloneModalNamePlaceholder: "לדוגמה: הקול שלי",
      cloneModalGenderLabel: "מגדר הקול",
      cloneModalUploadCta: "העלו קובץ אודיו",
      cloneModalRecordCta: "התחילו הקלטה",
      cloneModalStopCta: "סיימו הקלטה",
      cloneModalSubmit: "צור קול",
      cloneModalCancel: "ביטול",
      cloneModalUploading: "מעלה...",
      cloneModalCloning: "יוצר קלון... זה לוקח עד דקה",
      cloneModalRecordingHint: "הקלטה: {seconds} שניות (מומלץ לפחות 30)",
      cloneModalUploadHint: "{filename} ({size} KB) — לחצו 'צור קול' להמשך",
      cloneSuccessToast: "הקול שלך מוכן ✨",
      cloneErrorToast: "יצירת הקלון נכשלה",
      cloneDeleteConfirm: "למחוק את הקול המותאם? לא ניתן לבטל פעולה זו.",
      // BYO-audio (Bring Your Own audio) — user's pre-recorded voice goes
      // straight to lip-sync, skipping TTS entirely.
      userAudioCta: "השתמשו בהקלטה שלכם",
      userAudioCtaHint: "במקום שה-AI ידבר — תקליטו או תעלו אודיו והדמות תדבר אותו ישירות",
      userAudioModalTitle: "השתמשו בהקלטה משלכם",
      userAudioModalDescription: "מקליטים עד {max} שניות (או מעלים קובץ אודיו), והדמות בתמונה תדבר אותו. מדלגים על שלב הדיאלוג הכתוב — מה שהקלטתם זה מה שהדמות תאמר, בקול שלכם.",
      userAudioRecordCta: "התחילו הקלטה",
      userAudioStopCta: "סיימו הקלטה",
      userAudioUploadCta: "העלו קובץ אודיו",
      userAudioReplaceCta: "החליפו הקלטה",
      userAudioSubmit: "השתמשו בהקלטה",
      userAudioSubmitting: "מעלה...",
      userAudioCancel: "ביטול",
      userAudioRecordingHint: "מקליט: {seconds} / {max} שניות",
      userAudioDurationLabel: "{seconds} שניות",
      userAudioErrorMic: "לא הצלחנו להפעיל את המיקרופון. בדקו הרשאות בדפדפן.",
      userAudioErrorRead: "לא הצלחנו לקרוא את הקובץ. נסו קובץ אחר.",
      userAudioErrorTooLong: "הקובץ ארוך מ-{max} שניות. נסו קובץ קצר יותר.",
      userAudioErrorTooShort: "האודיו קצר מדי. צריך לפחות {min} שניות של דיבור.",
      userAudioErrorUnsupportedRecord: "הדפדפן הזה לא תומך בהקלטה בפורמט נתמך. אנא העלו קובץ MP3, WAV או M4A במקום.",
      userAudioErrorUnsupportedFormat: "פורמט הקובץ לא נתמך. אנא בחרו MP3, WAV, M4A או AAC.",
      userAudioActiveLabel: "ההקלטה שלכם תישלח כפי שהיא — אין צורך בטקסט לדיבוב.",
      userAudioActiveClear: "הסירו הקלטה",
      // Step-6 two-path picker — user chooses between TTS (write a script,
      // pick a voice) OR BYO audio (own recording, no voice picker).
      dialogueModeChooseTitle: "איך הדמות תדבר?",
      dialogueModeChooseHint: "בחרו אחת מהאפשרויות — בחירת הקול תיפתח רק אם בחרתם בטקסט.",
      dialogueModeText: "אני אכתוב טקסט",
      dialogueModeTextHint: "ה-AI יקריא את הטקסט בקול שתבחרו בשלב הבא.",
      dialogueModeAudio: "אני אשתמש בהקלטה שלי",
      dialogueModeAudioHint: "מקליטים או מעלים קובץ אודיו — הדמות תדבר בקול שלכם בדיוק. אין צורך בבחירת קול.",
      dialogueModeSwitch: "החלפת מסלול",
      dialogueModeActiveTextLabel: "מסלול: טקסט לדיבוב",
      dialogueModeActiveAudioLabel: "מסלול: ההקלטה שלכם",
      // Word-limit upgrade modal
      wordLimitModalTitle: "הגעת למגבלת המילים",
      wordLimitModalBodyUpgrade: "תוכנית ה-Free מאפשרת עד {current} מילים בכל סרטון. שדרגי ל-Pro לעד {upgrade} מילים.",
      wordLimitModalBodyHardCap: "מקסימום {current} מילים בכל סרטון.",
      wordLimitModalUpgradeCta: "שדרגו ל-Pro",
      wordLimitModalCloseCta: "הבנתי",
      heroMuteAria: "השתק",
      heroUnmuteAria: "הפעל סאונד",
      // Tier picker
      tierPickerTitle: "איכות הסרטון",
      tierStandardTitle: "Standard",
      tierStandardSubtitle: "720p — ערך טוב לכסף",
      tierProTitle: "Pro",
      tierProSubtitle: "איכות גבוהה יותר, יקר יותר",
      // CTA + status
      generateBtn: "צור סרטון",
      generating: "יוצר את הסרטון...",
      results: "הסרטונים שלך",
      noResults: "אין סרטונים עדיין",
      generationFailed: "היצירה נכשלה",
      generationFailedDesc: "אירעה שגיאה. הקרדיטים הוחזרו אוטומטית.",
    },
    // Baseball Trend (Trends tab — "caught on live TV" video flow)
    baseballTrend: {
      title: "Baseball Trend Guide",
      subtitle: "תמונה אחת שלך ← סרטון בסגנון \"שידור חי\" שתפס אותך ביציע",
      heroTitle: "תפסו אותך במצלמה ביציע — בלחיצה",
      heroSubtitle: "העלו תמונה אחת ברורה. בוחרים סצנה (משחק/הופעה), והמערכת יוצרת לכם סרטון קצר וויראלי.",
      heroBeforeLabel: "לפני",
      heroAfterLabel: "אחרי",
      uploadTitle: "שלב 1 · העלאת תמונה",
      uploadHint: "תמונה ברורה אחת — פנים מוארות, ללא משקפי שמש, איכות גבוהה",
      uploadDropTitle: "גררו תמונה לכאן או לחצו להעלאה",
      uploadFormats: "JPG, PNG · עד 10MB",
      removePhoto: "הסר",
      presetTitle: "שלב 2 · בחרו אווירה",
      presetHint: "כל סגנון מחליף את הרקע, הקהל והבגדים בתמונה",
      actionTitle: "שלב 6 · תיאור תנועת הסרטון",
      actionHint: "בחרו בין התנהגות טבעית מומלצת לבין תיאור התנועה שלכם",
      aspectRatioTitle: "שלב 4 · יחס גובה-רוחב",
      aspectRatioHint: "אותו יחס נשמר גם לתצוגות וגם לסרטון הסופי",
      aspectRatioLandscape: "רוחב — שידור טלוויזיה",
      aspectRatioPortrait: "אנכי — מובייל / סטוריז",
      actionRecommendedBadge: "מומלץ",
      actionDefaultTitle: "ברירת מחדל",
      actionDefaultSubtitle: "התנהגות טבעית של אוהד ביציע — מסתכל לצדדים, חיוך קל, פוזה רגועה",
      actionCustomTitle: "תיאור משלכם",
      actionCustomSubtitle: "כתבו במילים שלכם איך הדמות תזוז ותגיב בסרטון",
      actionPlaceholder: "לדוגמה: מסתכלת בהפתעה למצלמה ומחייכת, מנפנפת בידיים בעידוד",
      durationTitle: "אורך הסרטון",
      durationFiveSec: "5 שניות",
      durationTenSec: "10 שניות",
      generateBtn: "צור סרטון",
      generating: "יוצר את הסרטון...",
      results: "הסרטונים שלך",
      noResults: "לחצו 'צור' כדי לקבל סרטון חדש",
      generationFailed: "היצירה נכשלה",
      generationFailedDesc: "אירעה שגיאה. הקרדיטים הוחזרו אוטומטית.",
      missingUpload: "העלו תמונה",
      missingPreset: "בחרו אווירה",
      missingPreview: "צרו ובחרו תמונה",
      linkCopied: "הקישור הועתק",
      downloadAria: "הורדה",
      // Step 3 — Wardrobe / props
      wardrobeTitle: "שלב 3 · בגדים ופריטים",
      wardrobeHint: "המערכת תלביש את הדמות לפי האווירה. אפשר גם להגדיר משהו ספציפי.",
      wardrobeDefaultTitle: "התאם לאווירה",
      wardrobeDefaultSubtitle: "בגד מתאים לפריסט — לא יילקח מהתמונה שהעלית",
      wardrobeCustomTitle: "התאמה אישית",
      wardrobeCustomSubtitle: "כתבו מה תלבש או תחזיק (כובע, שלט אהדה, וכד')",
      wardrobePlaceholder: "כובע מצחייה אדום, ביד שלט עם שם הקבוצה",
      // Step 4 — Preview pair
      previewTitle: "שלב 5 · בחירת תמונה",
      previewHint: "צרו 2 תמונות ובחרו את המועדפת — היא תהפוך לסרטון",
      previewGenerateBtn: "צור 2 תצוגות",
      previewRegenerate: "צור מחדש 2 תצוגות",
      previewDownloadAria: "הורד תמונה",
      previewHistoryTitle: "תמונות שיצרת בעבר",
      previewHistoryHint: "אפשר לבחור גם תמונה ישנה שיצרת ולעבור איתה לסרטון",
      previewHistoryShowMore: "הצג עוד",
      previewHistoryDialogTitle: "ההיסטוריה של תצוגות הבייסבול",
      presets: {
        baseball: "משחק בייסבול",
        soccer: "משחק כדורגל",
        concert: "הופעה בלייב",
        basketball: "משחק כדורסל",
      },
    },
    // Product Studio (4 product photos in one click)
    productStudio: {
      heroBadge: "AI Product Studio",
      heroTitle: "תמונות מוצר מקצועיות בלחיצה אחת",
      heroSubtitle: "העלו תמונת מוצר אחת. ה-AI יוצר 4 תמונות סטודיו מקצועיות.",
      heroBeforeLabel: "לפני",
      heroAfterLabel: "× 4 אחרי",
      uploadTitle: "שלב 1 · העלאת תמונת מוצר",
      uploadHint: "תמונה ברורה ומוארת היטב לתוצאה הטובה ביותר",
      uploadCta: "גררו תמונה לכאן או לחצו להעלאה",
      uploadFormats: "JPG, PNG · עד 10MB",
      changePhoto: "החלף תמונה",
      addMorePhotos: "הוסיפו תמונות לשיפור התוצאות",
      addMorePhotosHint: "(יש להוסיף תמונות ברורות של המוצר)",
      afterPlaceholder: "התמונות שלך",
      createNowCta: "צור עכשיו",
      pickPreset: "שלב 2 · בחרו סגנון",
      moreStyles: "עוד סגנונות",
      customBackgroundLabel: "עיצוב רקע משלכם",
      customBackgroundPlaceholder: "לדוגמה: שיש לבן עם רפלקציות, אור בוקר רך, רקע מינימליסטי…",
      customBackgroundHelp: "תארו במילים את הסביבה שתרצו — נמקם את המוצר בדיוק בה.",
      customBackgroundQuickIdeas: "רעיונות מהירים",
      quickBackgrounds: {
        marble: "שיש לבן",
        wood: "רצפת עץ",
        beach: "חוף ים",
        modernLiving: "סלון מודרני",
        cafe: "בית קפה",
        kitchen: "מטבח טבעי",
      },
      pickPresetHint: "כל סגנון נותן ל-AI כיוון ויזואלי שונה",
      advancedCard: "התאמה אישית",
      advancedCardDesc: "הגדרות מתקדמות (פרומפט, תמונות עזר, מודל)",
      advancedTitle: "הגדרות מתקדמות",
      advancedDesc: "כתבו פרומפט מותאם או הוסיפו תמונות עזר",
      generateBtn: "צור 4 תמונות סטודיו",
      firstUploadTipTitle: "טיפ לתוצאה הכי טובה",
      firstUploadTipDesc: "העלו תמונה ברורה של המוצר על רקע נקי. ככל שהתמונה איכותית יותר, התוצאות יהיו מקצועיות יותר.",
      presets: {
        cleanWhiteName: "רקע סטודיו נקי",
        cleanWhiteDesc: "רקע לבן נקי, תאורה אחידה, מראה קומרשיאלי",
        dramaticLightName: "תאורה דרמטית",
        dramaticLightDesc: "צללים עמוקים, מצב רוח קולנועי, פרימיום",
        minimalistName: "מינימליסטי",
        minimalistDesc: "פלטה ניטרלית, חלל נשימה, מראה מודרני",
        blackWhiteName: "שחור-לבן",
        blackWhiteDesc: "ניגוד גבוה, אדיטוריאל, חסר זמן",
        lifestyleName: "לייפסטייל",
        lifestyleDesc: "סביבה אמיתית, אור זהוב, קמפיין מגזין",
      },
    },
    // Gallery Page
    gallery: {
      title: "גלריה",
      search: "חיפוש...",
      new: "חדש",
      viewProject: "צפה בפרויקט",
      myGallery: "הגלריה שלי",
      allMediaDescription: "כל התמונות והסרטונים שיצרת במקום אחד",
      all: "הכל",
      images: "תמונות",
      videos: "סרטונים",
      favorites: "מועדפים",
      clickToOpen: "לחץ לפתיחה",
      video: "סרטון",
      image: "תמונה",
      adsCreator: "סטודיו מוצר",
      imageDirector: "Image Director",
      startCreation: "התחל יצירה",
      noImages: "אין תמונות",
      createNew: "צור תמונות חדשות בסטודיו",
      clearFailed: "נקה נכשלים",
    },
    // Pricing Page
    pricing: {
      title: "בחר את המסלול שלך",
      subtitle: "התחל בחינם, שדרג בכל זמן.",
      popular: "פופולרי",
      perMonth: "לחודש",
      tokens: "טוקנים",
      tokensPerMonth: "טוקנים לחודש",
      variations: "וריאציות ליצירה",
      styles: "סגנונות",
      allStyles: "כל הסגנונות פתוחים",
      quality: "איכות",
      customPrompts: "פרומפטים מותאמים אישית",
      noWatermark: "ללא סימן מים",
      fullEditor: "עורך מלא (Full Editor)",
      brandKit: "Brand Kit",
      batchUpload: "העלאה בכמויות (Batch)",
      prioritySupport: "תמיכה בעדיפות",
      notIncluded: "לא כלול",
      pageTitle: "מחירים פשוטים",
      pageSubtitle: "בחר את התוכנית המתאימה לצרכים שלך. ללא התחייבות, בטל מתי שתרצה.",
      addTokensBtn: "הוסף טוקנים",
      purchasesClosed: "הרכישות סגורות — השירות נסגר.",
      purchasesClosedNotice: "אנחנו נסגרים. רכישות חדשות ומנויים חדשים סגורים. מנויים קיימים שומרים על הגישה שלהם עד 10 ביולי 2026 וללא חיובים נוספים.",
      monthly: "חודשי",
      annual: "שנתי",
      discount20: "20% הנחה",
      creditsPerImage: "10 קרדיטים = תמונה אחת",
      popularChoice: "הבחירה של המותגים",
      monthLabel: "/ לחודש",
      freeLabel: "חינם",
      billedAnnually: "מחויב שנתי: {symbol}{total}",
      savePercent: "חיסכון {percent}%",
      approxImagesRange: " {min}–{max} תמונות",
      approxShortVideosRange: " {min}–{max} סרטונים קצרים",
      annualSuffix: "(שנתי)",
      currentPlan: "המסלול הנוכחי",
      activeUntilDate: "פעיל עד {date}",
      resubscribe: "הירשם מחדש",
      addTokensDialogTitle: "הוסף טוקנים",
      addTokensDialogDesc: "טוקנים נוספים תקפים ל-2 חודשים ומתווספים לחבילה הקיימת שלך",
      tokensLabel: "טוקנים",
      extraTokens: "טוקנים נוספים",
      publicContent: "התוכן שלך ציבורי",
      privateContent: "התוכן שלך פרטי",
      upgradeTo: "שדרג ל-{plan}",
      downgradeTo: "שנמך ל-{plan}",
      alreadyOnPlan: "אתה כבר במסלול הזה",
      alreadyScheduled: "שינוי המסלול הזה כבר מתוזמן",
      confirmDowngradeTitle: "שינוי מסלול",
      confirmDowngradeMessage: "המסלול שלך ישתנה מ-{from} ל-{to} ב-{date}. תמשיך ליהנות מהמסלול הנוכחי עד אז.",
      confirmDowngradeYes: "כן, תזמן שינוי",
      confirmDowngradeNo: "ביטול",
      confirmDowngradeNewPrice: "החל מ-{date}, החיוב יהיה {symbol}{price}/{period}",
      confirmDowngradeTimelineTitle: "ציר זמן שינוי המסלול",
      confirmDowngradeTodayLabel: "היום",
      confirmDowngradeScheduledLabel: "מתוזמן",
      confirmDowngradeCurrentContinues: "{plan} ממשיך עד סוף תקופת החיוב הנוכחית",
      confirmDowngradeStartingPlan: "החל מ-{date} — {plan}",
      confirmDowngradeNoCharge: "ללא חיוב היום",
      confirmDowngradeFreePrice: "ללא חיוב",
      confirmDowngradeExplanation: "לא ניגבה תשלום היום. {currentPlan} ({currentPrice}) נשאר פעיל עד {date}, ואז תעבור/י אוטומטית ל-{newPlan} ({newPrice}).",
      downgradeScheduledSuccess: "שינוי המסלול תוזמן בהצלחה",
      confirmDowngradeToFreeMessage: "אתה עובר מ-{from} ל-FREE. התוכנית הנוכחית שלך תישאר פעילה עד {date}.",
      scheduledChangeNotice: "המסלול ישתנה ל-{plan} ({period}) ב-{date}",
      scheduledBadge: "המסלול הבא · {date}",
      cancelScheduledChange: "בטל שינוי מתוזמן",
      cancelScheduledChangeSuccess: "השינוי המתוזמן בוטל",
      cancelScheduledTitle: "לבטל את השינוי המתוזמן?",
      cancelScheduledMessage: "תישאר במסלול {plan} ({period}) הנוכחי. השינוי המתוזמן ל-{newPlan} ({newPeriod}) יבוטל.",
      cancelScheduledConfirm: "כן, בטל שינוי",
      cancelScheduledDismiss: "השאר שינוי מתוזמן",
      keepThisPlan: "השאר מסלול זה",
      alreadyDowngradingToFree: "אתה כבר עובר לתוכנית החינמית בסוף תקופת החיוב",
      confirmUpgradeTitle: "שדרוג ל-{plan}",
      confirmUpgradeProrated: "תשלום של {symbol}{amount} היום עבור {days} הימים הנותרים במחזור הנוכחי.",
      confirmUpgradeRecurring: "החל מהמחזור הבא, החיוב יהיה {symbol}{fullPrice}/{period}.",
      confirmUpgradeYes: "שדרג",
      confirmUpgradeNo: "ביטול",
      confirmUpgradeTodayLabel: "תשלום היום",
      confirmUpgradeDaysContext: "עבור {days} ימים נותרים",
      confirmUpgradeNextCycleLabel: "החל מ-{date}",
      reactivateTitle: "הפעלת המסלול מחדש?",
      reactivateDescription: "המסלול שלך יופעל מחדש ללא חיוב נוסף. תמשיך במחזור החיוב הנוכחי.",
      reactivateYes: "הפעל מחדש",
      reactivateNo: "ביטול",
      reactivationSuccess: "המנוי שלך הופעל מחדש!",
      reactivateChangeTitle: "מעבר ל-{plan}?",
      reactivateChangeDescription: "ללא חיוב נוסף כרגע. החיוב החדש יתחיל ב-{date}.",
      reactivateChangeYes: "אשר מעבר",
      periodMonth: "חודש",
      periodYear: "שנה",
      goToStudio: "עבור לסטודיו",
      couponPlaceholder: "הזן קוד קופון",
      couponApply: "החל",
      couponHave: "יש לך קוד קופון?",
      couponValidPercentMonthly: "{percent}% הנחה על החודש הראשון",
      couponValidPercentAnnual: "{percent}% הנחה על השנה הראשונה",
      couponValidAmountMonthly: "₪{amount} הנחה על החודש הראשון",
      couponValidAmountAnnual: "₪{amount} הנחה על השנה הראשונה",
      couponInvalid: "קוד קופון לא תקין",
      couponError: "שגיאה באימות הקופון",
      couponRemove: "הסר",
      couponThenPrice: "לאחר מכן: {symbol}{price}/{period}",
      couponMonthlyOnly: "קופונים תקפים למנויים חודשיים בלבד",
    },
    // Profile Page
    profile: {
      title: "הפרופיל שלי",
      displayName: "שם תצוגה",
      email: "אימייל",
      plan: "תוכנית",
      credits: "קרדיטים",
      saveChanges: "שמור שינויים",
      saving: "שומר...",
      saved: "נשמר בהצלחה",
      hello: "שלום",
      studioReady: "הסטודיו שלך מוכן ליצירה.",
      newCreation: "יצירה חדשה",
      creditBalance: "יתרת קרדיטים",
      monthlyCreations: "יצירות החודש",
      startCreating: "התחל ליצור!",
      subscriptionType: "סוג מנוי",
      upgradeToMore: "שדרג לתוכניות נוספות",
      activeSubscription: "מנוי פעיל",
      editProfile: "ערוך פרופיל",
      upgradePlan: "שדרג חבילה",
      managePlan: "ניהול חבילה",
      addTokens: "הוסף טוקנים",
      clickToChangeImage: "לחץ להחלפת תמונה",
      uploadingImage: "מעלה תמונה...",
      profileUpdated: "הפרופיל עודכן בהצלחה!",
      profileUpdateError: "שגיאה בעדכון הפרופיל",
      loginRequired: "יש להתחבר כדי לצפות בפרופיל",
      imageFileOnly: "יש להעלות קובץ תמונה בלבד",
      maxFileSize: "גודל הקובץ המקסימלי הוא 5MB",
      recommended: "מומלץ",
      tokens: "טוקנים",
      validityPeriod: "תקף ל-2 חודשים • ללא הגבלת זמן שימוש חודשי",
      sameAsYourPlan: "זהה לכמות הטוקנים בתוכנית {plan} שלך",
      tokensRemainPeriod: "הטוקנים נשארים בחשבון עד 2 חודשים",
      canPurchaseMultiple: "ניתן לרכוש מספר פעמים",
      purchaseTokens: "רכוש {count} טוקנים",
      paymentImmediate: "התשלום מתבצע באופן מיידי • ניתן לבטל בכל עת",
      loggedOutSuccess: "התנתקת בהצלחה",
      marketingNudgeTitle: "הצטרפו לרשימת התפוצה שלנו",
      marketingNudgeSubtitle: "קבלו במייל הנחות בלעדיות, טיפים ועדכוני מוצר.",
      marketingNudgeCta: "💎 הוסיפו אותי להנחות",
      dangerZoneTitle: "אזור מסוכן",
      dangerZoneSubtitle: "פעולות בלתי הפיכות",
      deleteAccountTitle: "מחיקת חשבון",
      deleteAccountSubtitle: "מחק לצמיתות את החשבון, היצירות, והקבצים שהעלית. הפעולה אינה הפיכה.",
      deleteAccountButton: "מחק את החשבון שלי",
      deleteAccountDialogDescription: "פעולה זו תמחק לצמיתות את החשבון שלך, את כל היצירות שיצרת, ואת כל הקבצים שהעלית. דגימות הקול יוסרו מהאחסון שלנו ומ-ElevenLabs. הקלד DELETE MY ACCOUNT למטה כדי לאשר.",
      deleteAccountConfirmLabel: "הקלד DELETE MY ACCOUNT כדי לאשר",
      deleteAccountCancel: "ביטול",
      deleteAccountSuccess: "החשבון שלך נמחק.",
      deleteAccountError: "לא הצלחנו למחוק את החשבון. נסה שוב או פנה לתמיכה.",
      darkMode: "מצב לילה",
      darkModeDesc: "שנה את ערכת הצבעים של האתר",
      editProfileDesc: "שנה שם ותמונה",
      preferences: "העדפות",
      account: "חשבון",
      usageTitle: "שימוש",
      usageCreditsUsed: "קרדיטים שנוצלו",
      usageImages: "תמונות",
      usageVideos: "סרטונים",
      usageThisMonth: "החודש",
      usageEmpty: "אין שימוש עדיין",
      usageEmptySubtitle: "התחל ליצור כדי לראות סטטיסטיקות כאן",
      manageSubscription: "ניהול מנוי",
      cancelledActiveUntil: "פעיל עד {date}",
      planActiveUntil: "תוכנית {plan} פעילה עד {date}",
      cancelled: "בוטל",
      resubscribe: "הירשם מחדש",
      tabUsage: "שימוש",
      tabBilling: "חיוב",
      billingPlan: "תוכנית",
      billingPeriod: "תקופת חיוב",
      billingMonthly: "חודשי",
      billingAnnual: "שנתי",
      billingPrice: "מחיר",
      billingNextRenewal: "חידוש הבא",
      billingCreditsIncluded: "קרדיטים כלולים",
      billingPerMonth: "לחודש",
      billingPerYear: "לשנה",
      billingChangePlan: "שנה תוכנית",
      billingCancelPlan: "ביטול מנוי",
      billingFreePlan: "תוכנית חינמית",
      billingPaymentHistory: "היסטוריית תשלומים",
      billingNoPayments: "אין תשלומים עדיין",
      billingNoPaymentsSubtitle: "התשלומים שלך יופיעו כאן",
      billingDate: "תאריך",
      billingType: "סוג",
      billingAmount: "סכום",
      billingStatus: "סטטוס",
      billingSubscription: "מנוי",
      billingTokenPack: "חבילת טוקנים",
      billingTokens: "{count} טוקנים",
      billingStatusCompleted: "הושלם",
      billingStatusPending: "ממתין",
      billingStatusFailed: "נכשל",
      billingStatusExpired: "פג תוקף",
      billingCreditHistory: "היסטוריית קרדיטים",
      billingNoCreditHistory: "אין היסטוריית קרדיטים",
      billingNoCreditHistorySubtitle: "שימוש בקרדיטים יופיע כאן",
      billingOperation: "פעולה",
      billingCredits: "קרדיטים",
      billingBalanceAfter: "יתרה",
      billingOpImageGenerate: "יצירת תמונה",
      billingOpImageEdit: "עריכת תמונה",
      billingOpVideoGenerate: "יצירת וידאו",
      billingOpDirectorGenerate: "יצירת דירקטור",
      billingOpTokenPurchase: "רכישת טוקנים",
      billingOpRefund: "החזר",
      billingOpSubscription: "מנוי",
      billingOpSignupBonus: "בונוס הרשמה",
      billingOpTokenPack: "חבילת קרדיטים",
      billingOpReferralBonus: "בונוס הזמנת חבר",
      billingOpReferralReward: "תגמול הזמנת חבר",
      billingOpCreditsRefresh: "חידוש קרדיטים",
      billingOpPlanDowngrade: "מעבר לחבילה נמוכה",
      billingOpOther: "אחר",
      billingCancelledUntil: "בוטל — פעיל עד {date}",
      billingDiscountBadge: "{percent}% הנחה על החיוב הבא",
      activityTitle: "היסטוריית פעילות",
      activityNoEvents: "אין פעילות עדיין",
      activityNoEventsSubtitle: "פעולות מנוי יופיעו כאן",
      eventSubscriptionCreated: "מנוי ל-{plan} ({period})",
      eventSubscriptionUpgraded: "שדרוג ל-{plan} ({period})",
      eventSubscriptionRenewed: "מנוי חודש",
      eventSubscriptionCancelled: "מנוי בוטל",
      eventSubscriptionExpired: "מנוי פג תוקף",
      eventSubscriptionReactivated: "מנוי הופעל מחדש",
      eventSubscriptionDowngraded: "שונמך ל-{plan} ({period})",
      eventSubscriptionDowngradedToFree: "שונמך למסלול חינמי",
      eventDowngradeScheduled: "שינוי ל-{plan} ({period}) תוזמן",
      eventDowngradeScheduleCancelled: "שינוי מתוזמן בוטל",
      eventTokenPackPurchased: "נרכשו {tokens} טוקנים",
      eventCreditsRefreshed: "קרדיטים חודשיים רוענו",
      eventDiscountApplied: "הנחה של {percent}% הופעלה",
      eventDiscountRestored: "תקופת הנחה הסתיימה",
    },
    cancellation: {
      cancelSubscription: "ביטול מנוי",
      whyCancelling: "נשמח לדעת למה",
      whyCancellingSubtitle: "התשובה שלך תעזור לנו להשתפר",
      weHaveAnOffer: "לפני שאת/ה עוזב/ת...",
      confirmCancellation: "אישור ביטול",

      reasonTooExpensive: "יקר מדי עבורי",
      reasonNotUsing: "לא משתמש/ת מספיק כרגע",
      reasonMissingFeatures: "חסרות תכונות שאני צריך/ה",
      reasonSwitching: "עובר/ת לכלי אחר",
      reasonQuality: "האיכות לא מספיק טובה",
      reasonComplicated: "מסובך מדי לשימוש",
      reasonOther: "אחר",
      otherPlaceholder: "ספרו לנו עוד...",
      feedbackPlaceholder: "משהו נוסף שתרצו לשתף?",

      offerDiscount: "קבלו 40% הנחה על החודש הבא",
      offerDiscountDesc: "נשמח שתישארו — הנה מחיר מיוחד רק בשבילכם.",
      offerNotUsing: "אנחנו כל הזמן משתפרים — תמיד אפשר לחזור!",
      offerFeatures: "תכונות חדשות בדרך. הישארו כדי להיות הראשונים לנסות!",
      offerSupport: "צריכים עזרה? נשמח לשמוע מכם.",
      offerGoodbye: "אנחנו מבינים. תודה שניסית את TodoAI.",
      offerQuality: "שדרוגי איכות משמעותיים בדרך!",
      acceptOffer: "קבל הצעה",
      cancelAnyway: "בטל בכל זאת",
      keepSubscription: "השאר את המנוי",

      whatYouLose: "הנה מה שתפסידו",
      creditsRemaining: "{n} קרדיטים שנותרו",
      imagesGenerated: "{n} תמונות שנוצרו החודש",
      videosGenerated: "{n} סרטונים שנוצרו החודש",
      accessUntil: "גישה עד {date}",
      switchToFree: "לאחר מכן, תעברו לחבילה החינמית",
      confirmCancel: "אישור ביטול",

      whatsappCta: "דברו איתנו בוואטסאפ — נשמח לעזור",
      whatsappButton: "שלחו לנו הודעה בוואטסאפ",
      whatsappMsgTooExpensive: "היי, חשבתי לבטל את המנוי כי זה יקר לי. אשמח לשמוע מה אפשר לעשות",
      whatsappMsgNotUsing: "היי, חשבתי לבטל את המנוי כי אני לא משתמש/ת מספיק כרגע. אשמח לשמוע מה אפשר לעשות",
      whatsappMsgFeatures: "היי, חשבתי לבטל את המנוי כי חסרות לי תכונות. אשמח לשמוע אם משהו מתוכנן",
      whatsappMsgSwitching: "היי, חשבתי לעבור לכלי אחר. אשמח לשמוע מה מיוחד אצלכם",
      whatsappMsgQuality: "היי, חשבתי לבטל את המנוי כי האיכות לא הספיקה לי. אשמח לשמוע על שיפורים",
      whatsappMsgComplicated: "היי, חשבתי לבטל את המנוי כי זה מסובך לי לשימוש. אשמח לקבל עזרה",

      subscriptionCancelled: "המנוי בוטל",
      discountApplied: "ההנחה הופעלה!",
      cancelError: "שגיאה בביטול המנוי",
      discountError: "שגיאה בהפעלת ההנחה",
      continueButton: "המשך",
    },
    // Dashboard Page
    dashboard: {
      resultsGallery: "גלריית תוצאות",
      resultsDescription: "תוצאות אמיתיות של לקוחות שלנו — ראו איך מוצרים פשוטים הופכים לתמונות מקצועיות",
      before: "לפני",
      after: "אחרי",
      createdBy: "נוצר על ידי",
      wantToCreate: "רוצים ליצור תוצאות כאלה בעצמכם?",
      startCreatingNow: "התחל ליצור עכשיו",
      categoryAll: "הכל",
      categorySkincare: "טיפוח",
      categoryFashion: "אופנה",
      categoryTech: "טכנולוגיה",
      categoryAccessories: "אביזרים",
    },
    // Auth Pages
    auth: {
      loginTitle: "התחברות",
      signupTitle: "הרשמה",
      email: "אימייל",
      password: "סיסמה",
      passwordReqLength: "לפחות 8 תווים",
      passwordReqUppercase: "אות גדולה אחת",
      passwordReqLowercase: "אות קטנה אחת",
      passwordReqDigit: "ספרה אחת",
      passwordReqSymbol: "סימן מיוחד אחד",
      loginButton: "התחבר",
      signupButton: "הירשם",
      noAccount: "אין לך חשבון?",
      hasAccount: "יש לך חשבון?",
      createAccount: "צור חשבון",
      loginHere: "התחבר כאן",
      welcomeBack: "ברוכים השבים",
      continueToCreate: "התחברו כדי להמשיך ליצור",
      continueWithGoogle: "המשך עם Google",
      or: "או",
      forgotPassword: "שכחתי סיסמה",
      sending: "שולח...",
      loggingIn: "מתחבר...",
      noAccountQuestion: "אין לכם חשבון?",
      hasAccountQuestion: "כבר יש לכם חשבון?",
      createNewAccount: "צור חשבון חדש",
      startCreatingFree: "התחילו ליצור תמונות מדהימות בחינם",
      yourName: "השם שלך",
      creatingAccount: "יוצר חשבון...",
      passwordMinLength: "הסיסמה לא עומדת בכל הדרישות",
      signupSuccess: "נרשמת בהצלחה!",
      welcomeToFlowly: "!ברוכים הבאים ל-TodoAI",
      loginSuccess: "התחברת בהצלחה!",
      loginError: "שגיאה בהתחברות",
      signupError: "שגיאה בהרשמה",
      googleLoginError: "שגיאה בהתחברות עם Google",
      googleSignupError: "שגיאה בהרשמה עם Google",
      invalidCredentials: "אימייל או סיסמה שגויים",
      enterEmailForReset: "נא להזין אימייל",
      enterEmailDescription: "הזינו את כתובת האימייל שלכם כדי לאפס את הסיסמה",
      resetEmailSent: "נשלח אימייל לאיפוס סיסמה",
      checkInbox: "בדקו את תיבת הדואר שלכם",
      resetEmailError: "שגיאה בשליחת איפוס סיסמה",
      checkYourEmail: "בדוק את האימייל שלך",
      verificationEmailSentDescription: "שלחנו לך אימייל עם קישור אימות. לחץ על הקישור כדי להפעיל את החשבון.",
      verifyEmailTitle: "אמת את כתובת האימייל שלך",
      verifyEmailDescription: "שלחנו קישור אימות ל",
      resendVerificationEmail: "שלח מחדש אימייל אימות",
      resendingEmail: "שולח...",
      verificationResent: "אימייל אימות נשלח!",
      resendError: "שגיאה בשליחת אימייל",
      checkSpamFolder: "לא קיבלת? בדוק את תיקיית הספאם.",
      emailNotConfirmed: "האימייל לא אומת",
      pleaseVerifyFirst: "יש לאמת את כתובת האימייל לפני ההתחברות. בדוק את תיבת הדואר שלך.",
      resendIn: "שלח שוב בעוד {seconds} שניות",
      marketingConsent: "שלחו לי בדוא״ל הנחות והצעות מיוחדות.",
      marketingPromptDecline: "אולי בפעם אחרת",
    },
    // Common
    common: {
      loading: "טוען...",
      error: "שגיאה",
      success: "הצלחה",
      cancel: "ביטול",
      save: "שמור",
      delete: "מחק",
      edit: "ערוך",
      close: "סגור",
      back: "חזור",
      next: "הבא",
      submit: "שלח",
      download: "הורדה",
      rateLimited: "לאט לאט! אנא המתינו רגע ונסו שוב.",
      connectionLost: "החיבור נקטע. נסו שוב בעוד רגע.",
      generationTimeout: "היצירה אורכת יותר מדי ברזולוציה הזו — נסו רזולוציה נמוכה יותר (2K).",
      serviceWindingDown: "השירות נסגר — היצירה זמינה למנויים פעילים בלבד.",
      windDownBannerText: "אנחנו עוברים! TodoAI נסגר — הכירו את האפליקציה החדשה שלנו.",
      windDownBannerSubscriberNote: "מנויים שומרים על גישה מלאה עד 10 ביולי 2026, ללא חיובים נוספים.",
      windDownBannerCta: "לצפייה ב‑makepodcast.app",
      downloadError: "ההורדה נכשלה. אנא נסו שוב.",
      downloadSuccess: "הקובץ הורד בהצלחה",
      loginRequired: "יש להתחבר כדי להמשיך",
      convertingHeic: "ממיר תמונת אייפון (HEIC)...",
      convertingHeicSuccess: "התמונה הומרה בהצלחה",
      convertingHeicError: "לא הצלחנו להמיר את התמונה. נסו תמונה אחרת או JPEG.",
      uploadErrorTitle: "לא הצלחנו לעבד את הקובץ",
      uploadErrorBody:
        "ייתכן שהתמונה בפורמט שאינו נתמך או שהקובץ פגום. נסו להעלות תמונה בפורמט JPG, PNG או WebP.",
      uploadErrorButton: "הבנתי",
      share: "שיתוף",
      linkCopied: "הקישור הועתק",
      shareError: "השיתוף נכשל. אנא נסו שוב.",
    },
    // Todo Bot chatbot
    chatbot: {
      buttonLabel: "צריכים עזרה?",
      panelTitle: "Todo Bot",
      panelSubtitle: "כאן בשבילך",
      welcomeMessage: "היי, אני Todo Bot 🙂 איך אפשר לעזור היום?",
      inputPlaceholder: "כתבו לי על מה לעזור...",
      send: "שלח",
      close: "סגור",
      error: "משהו השתבש, אנא נסו שוב.",
      anonymousLimitTitle: "רוצה להמשיך לדבר איתי?",
      anonymousLimitDescription: "כדי להמשיך בשיחה צריך להירשם (חינם, ומקבלים גם קרדיטים מתנה).",
      signupCta: "להרשמה",
      escalateWhatsapp: "פתחו צ׳אט בוואטסאפ",
      escalateEmail: "שלחו אימייל לתמיכה",
      sessionLimitTitle: "הגעתם למקסימום ההודעות לסשן הזה",
      sessionLimitDescription: "כדי להמשיך לקבל עזרה, צרו איתנו קשר בוואטסאפ — נציג אנושי יחזור אליכם.",
      aiDisclaimer:
        "את/ה מתקשר/ת עם AI גנרטיבי. בהמשך, אתה מסכים להודעה המשפטית ומאשר שהבנת את מדיניות הפרטיות והעוגיות.",
      reopenHint: "יש לך שיחה פתוחה",
    },
    // Bot Builder — custom AI chatbot per user, embeddable on their own site
    botBuilder: {
      navLabel: "הבוט שלי",
      pageTitle: "בנו את הבוט שלכם",
      pageSubtitle: "בוט תמיכה ומידע מותאם אישית לאתר שלכם, מבוסס על תוכן האתר.",
      proRequiredTitle: "דרוש מנוי Pro או Creator",
      proRequiredDescription: "בניית בוט מותאם זמינה למנויים בתשלום בלבד.",
      proRequiredCta: "צפו במסלולים",
      // Create form
      createTitle: "בואו ניצור את הבוט שלכם",
      createDescription: "מלאו את הפרטים, ואנחנו ניצור עבורכם בוט שמכיר את העסק שלכם.",
      nameLabel: "שם הבוט",
      namePlaceholder: "לדוגמה: עוזר העסק של אביחי",
      sourceUrlLabel: "כתובת האתר שלכם",
      sourceUrlPlaceholder: "https://mybusiness.com",
      sourceUrlHint: "נסרוק את דף הבית ונשלוף ממנו מידע על העסק",
      allowedDomainLabel: "דומיין להטמעה",
      allowedDomainPlaceholder: "mybusiness.com",
      allowedDomainHint: "הבוט יעבוד רק כשמטמיעים אותו בדומיין הזה (אבטחה)",
      styleSampleLabel: "איך הבוט שלכם ידבר? (אופציונלי, עד 30 מילים)",
      styleSamplePlaceholder: "דוגמה: היי! ברוכים הבאים, איך אפשר לעזור היום?",
      styleSampleHint: "נשתמש בדוגמה הזו כסגנון הדיבור של הבוט",
      // Voice presets — chips above the textarea; click to auto-fill.
      stylePresetsLabel: "או בחרו פריסט מוכן:",
      stylePresetFriendlyName: "חברי וקליל",
      stylePresetFriendlyText: "דיבור חברי וקליל, פותח בשלום חם, משתמש בשפה יומיומית ונגישה. מוסיף אימוג׳י מדי פעם.",
      stylePresetProfessionalName: "מקצועי ורשמי",
      stylePresetProfessionalText: "טון מקצועי ומכובד, משפטים ברורים ומדויקים, ללא סלנג וללא אימוג׳ים. פנייה בלשון רבים.",
      stylePresetEnergeticName: "אנרגטי ונלהב",
      stylePresetEnergeticText: "מלא אנרגיה והתלהבות! משפטים קצרים, סימני קריאה ואימוג׳ים בולטים. כיף ומזמין.",
      extraInfoLabel: "מידע נוסף שכדאי שהבוט ידע (אופציונלי)",
      extraInfoPlaceholder: "למשל: שעות פעילות, מוצרים מיוחדים, נושאים שאסור לבוט לדבר עליהם...",
      createCost: "עלות יצירה: {cost} קרדיטים",
      createCta: "צרו לי בוט",
      creating: "יוצר את הבוט... זה לוקח עד דקה",
      cancelCta: "ביטול",
      createSuccess: "הבוט שלכם מוכן ✨",
      createErrorTitle: "יצירת הבוט נכשלה",
      // Edit form — same shape as create, but the source URL is locked.
      editTitle: "ערכו את הבוט שלכם",
      editDescription: "אפשר לעדכן את הטקסטים והדומיין. כתובת האתר שנסרקה לא ניתנת לשינוי (לרענון מידע, מחקו את הבוט וצרו חדש).",
      editCta: "שמרו שינויים",
      editSaving: "שומר...",
      editSuccess: "הבוט עודכן ✨",
      editErrorTitle: "עדכון הבוט נכשל",
      editBackCta: "חזרה",
      sourceUrlLockedHint: "כתובת האתר לא ניתנת לשינוי אחרי יצירת הבוט",
      // Manage panel
      managePanelTitle: "הבוט שלכם",
      manageEditCta: "ערכו",
      manageDeleteCta: "מחקו",
      manageDeleteConfirm: "למחוק את הבוט? לא ניתן לבטל פעולה זו.",
      // Styled in-app delete confirmation (replaced the native window.confirm).
      deleteConfirmTitle: "למחוק את הבוט?",
      deleteConfirmDescription: "הבוט, כל המידע שלמדנו על האתר, וקוד ההטמעה יימחקו לצמיתות. יתרת הקרדיטים של הבוט תוחזר ליתרה הראשית שלכם.",
      deleteConfirmCancel: "ביטול",
      deleteConfirmCta: "כן, מחקו את הבוט",
      // Localized error messages mapped from server error codes/strings via
      // mapBotServerError (see useBotBuilder).
      errorInvalidDomain: "כתובת הדומיין לא תקינה. השתמשו בפורמט example.com (בלי https://, בלי נתיב, בלי פורט).",
      errorAlreadyHaveBot: "כבר יש לכם בוט פעיל. ערכו אותו או מחקו אותו לפני שיוצרים חדש.",
      manageStatusActive: "פעיל",
      // Per-message pricing banner — replaces the old pack counter.
      managePricingHint: "כל הודעת AI עולה 1 קרדיט מהיתרה שלכם",
      manageCreditBalance: "{credits} קרדיטים",
      manageTopUpCta: "קנו קרדיטים",
      managePreviewTitle: "תצוגה מקדימה",
      managePreviewHint: "בדקו את הבוט כאן. בדיקות פנימיות לא חוסכות קרדיטים.",
      manageEmbedTitle: "הטמעה באתר",
      manageEmbedHint: "בחרו את שיטת ההטמעה והדביקו את הקוד באתר שלכם:",
      // Embed type tabs — owner picks one (server doesn't care, same endpoint).
      manageEmbedTabFloating: "בועה צפה",
      manageEmbedTabIframe: "iframe מוטמע",
      // Install help — opened from the "?" button next to each Copy button.
      manageEmbedInstallHelpCta: "איך מתקינים?",
      installHelpTitle: "איך להתקין את הקוד באתר שלכם",
      installHelpIntro: "יש לכם שתי דרכים להוסיף את הקוד לאתר — בעזרת AI או ידנית.",
      installHelpTabAi: "עם AI",
      installHelpTabManual: "ידנית",
      // AI approach — paste the snippet to a code assistant.
      installHelpAiIntro: "הדרך הכי מהירה: תנו ל־AI לעשות את זה בשבילכם. עובד עם Claude Code, Cursor, ChatGPT, או כל עוזר קוד אחר.",
      installHelpAiStep1: "פתחו את העוזר AI שלכם (Claude Code / Cursor / ChatGPT).",
      installHelpAiStep2: "הצמידו לעוזר את ההנחיה שמתחת ואת קוד האתר שלכם.",
      installHelpAiStep3: "תנו לו להוסיף את הקוד באתר ולשמור.",
      installHelpAiPromptLabel: "ההנחיה להעתקה (תחליפו {snippet} בקוד שהעתקתם):",
      installHelpAiPrompt: "הוסף את התג הזה ממש לפני הסגירה של </body> בקובץ ה־HTML הראשי של האתר שלי:\n\n{snippet}\n\nאל תשנה שום דבר אחר באתר — רק תוסיף את התג הזה במקום הנכון.",
      // Manual approach — per-platform short steps.
      installHelpManualIntro: "אם אתם מעדיפים להדביק לבד, בחרו את הפלטפורמה של האתר:",
      installHelpPlatformWordpress: "WordPress",
      installHelpPlatformWordpressSteps: "התקינו את התוסף 'Insert Headers and Footers' → Settings → WPCode → הדביקו את הקוד בשדה 'Body' → Save.",
      installHelpPlatformWix: "Wix",
      installHelpPlatformWixSteps: "Settings → Custom Code → Add Custom Code → הדביקו את הקוד → Place Code in: Body - end → Apply to: All pages → Add Code.",
      installHelpPlatformShopify: "Shopify",
      installHelpPlatformShopifySteps: "Online Store → Themes → Edit Code → theme.liquid → הדביקו את הקוד ממש לפני </body> → Save.",
      installHelpPlatformWebflow: "Webflow",
      installHelpPlatformWebflowSteps: "Project Settings → Custom Code → Footer Code → הדביקו את הקוד → Save Changes → Publish.",
      installHelpPlatformHtml: "אתר HTML רגיל",
      installHelpPlatformHtmlSteps: "פתחו את ה־HTML של הדף, הדביקו את הקוד ממש לפני </body>, ושמרו את הקובץ. העלו לשרת.",
      // Discreet attribution shown on every embedded chat panel.
      embedAttribution: "Created with TodoAi",
      manageEmbedFloatingHint: "כפתור צ׳אט קטן בפינה הימנית-תחתונה שנפתח לחלון צ׳אט בלחיצה. מומלץ לרוב האתרים.",
      manageEmbedIframeHint: "חלון צ׳אט קבוע במקום שתבחרו בעמוד. מתאים לדפי תמיכה ו־FAQ.",
      manageEmbedCopyCta: "העתקת קוד",
      manageEmbedCopied: "הקוד הועתק",
      manageZeroBalanceWarning: "נגמרו לכם הקרדיטים. הבוט לא יענה למבקרים עד שתטענו עוד.",
      manageDeleted: "הבוט נמחק",
      // Shown when the bot had a non-zero wallet at delete time — the
      // remaining balance is automatically refunded to the user's main
      // credits (see migration 20260525000001).
      manageDeletedWithRefund: "הבוט נמחק • {amount} קרדיטים הוחזרו ליתרה הראשית ✨",
      manageDeleteFailed: "מחיקת הבוט נכשלה",
      // Bot Wallet — deposit credits from main balance into the bot's
      // prepaid wallet. 1:1, non-refundable. See migration 20260524000006.
      depositSectionTitle: "טעינת הבוט",
      depositSectionHint: "הפקידו קרדיטים מהיתרה הראשית כדי שהבוט יוכל לענות למבקרים. כל תשובה צורכת קרדיט אחד מיתרת הבוט.",
      depositNonRefundable: "ההפקדה אינה ניתנת להחזרה",
      depositSuccess: "נטענו {amount} קרדיטים לבוט ✨",
      depositInsufficientToast: "אין מספיק קרדיטים ביתרה הראשית. נעביר אותך לרכישת חבילת קרדיטים.",
      depositErrorTitle: "ההפקדה נכשלה",
      depositInProgress: "מפקיד...",
      depositConfirmTitle: "להפקיד {amount} קרדיטים לבוט?",
      depositConfirmDescription: "הקרדיטים יעברו מהיתרה הראשית ליתרת הבוט באופן חד-כיווני ולא יחזרו אחורה.",
      depositConfirmCta: "כן, הפקידו",
      depositConfirmCancel: "ביטול",
      // Balance banner on the manage panel
      balanceLabel: "יתרת הבוט",
      balanceMessagesRemaining: "~{count} הודעות נוספות",
      balanceLowWarning: "היתרה אוזלת",
      balanceEmptyWarning: "הבוט מושבת — אין יתרה",
      // Locked-embed CTA when the wallet is empty
      embedLockedTitle: "הבוט מושבת",
      embedLockedDescription: "הפקידו קרדיטים כדי שהבוט יחזור לעבוד ותוכלו להעתיק את קוד ההטמעה.",
      // Embed page (visitor-side)
      embedHeader: "צריכים עזרה?",
      embedInputPlaceholder: "כתבו את השאלה שלכם...",
      embedSend: "שלח",
      embedUnavailable: "הבוט כרגע לא זמין",
      embedUnavailableHint: "פנו אלינו ישירות לעוד עזרה.",
      embedError: "משהו השתבש. אנא נסו שוב.",
      // Shown to the visitor when the bot owner's plan no longer permits
      // embed (e.g. they downgraded). Kept generic to not leak business info.
      embedOwnerUpgradeRequired: "השירות הזה זמני לא פעיל. נסו שוב מאוחר יותר.",
      // Shown to the owner inside the manage panel when their plan doesn't
      // permit embedding. They can still create + preview, but the embed
      // code section is hidden behind this upsell.
      embedProRequiredTitle: "הטמעה באתר זמינה למנויי Pro",
      embedProRequiredDescription: "יצירה ובדיקה של הבוט פתוחים לכולם. כדי להטמיע את הבוט באתר שלכם נדרש מנוי Pro או Creator.",
      embedProRequiredCta: "שדרגו ל-Pro",
    },
    // Pricing Modal
    pricingModal: {
      title: "אל תעצרו עכשיו! 🚀",
      description: "אל תאבדו את הקצב — הוסיפו טוקנים או שדרגו והמשיכו ליצור",
      paidDescription: "נגמרו לך הקרדיטים. הוסף טוקנים או שדרג את התוכנית שלך.",
      viewPlans: "צפה במסלולים",
      starterRequiredTitle: "פיצ'ר זמין למנויי Starter+",
      starterRequiredDescription: "כדי להשתמש בשכפול קולי או בהעלאת קובץ קול, צריך מנוי Starter ומעלה.",
    },
    // WhatsApp community
    community: {
      eyebrow: "הקהילה שלנו",
      title: "הצטרפו לקהילת הוואטסאפ שלנו 💬",
      description: "קבוצה שקטה לטיפים והנחות בלעדיות.",
      quietNote: "קבוצה שקטה, בלי ספאם, רק ערך אמיתי.",
      joinButton: "להצטרפות לקהילה",
      modalTitle: "היצירה הראשונה שלכם מוכנה!",
      modalDismiss: "אולי מאוחר יותר",
      footerLink: "קהילת וואטסאפ",
      reportButton: "דווחו לנו",
      reportPrefill: "היי, נתקלתי בתקלה ב-Todo AI:",
    },
    // Payment Result Page
    paymentResult: {
      verifying: "מאמת תשלום...",
      verifyingDesc: "אנחנו בודקים את התשלום שלך. זה ייקח רגע.",
      successTitle: "התשלום הצליח!",
      successWelcome: "ברוכים הבאים לתוכנית",
      tokensAdded: "טוקנים נוספו לחשבון",
      startCreating: "התחל ליצור",
      failedTitle: "התשלום נכשל",
      cardDeclined: "הכרטיס שלך נדחה. נסה כרטיס אחר.",
      insufficientFunds: "אין מספיק יתרה בכרטיס. נסה כרטיס אחר.",
      expiredCard: "תוקף הכרטיס פג. השתמש בכרטיס תקף.",
      defaultError: "התשלום נכשל. נסה שוב או פנה לתמיכה.",
      tryAgain: "נסה שוב",
      processing: "מעבד תשלום...",
    },
    checkout: {
      heading: "השלמת רכישה",
      backToPricing: "חזרה למחירים",
      iframeTitle: "טופס תשלום מאובטח",
      loadingPayment: "טוען טופס תשלום מאובטח...",
      fallbackMessage: "טופס התשלום לא נטען? אפשר לפתוח אותו בלשונית חדשה.",
      openInNewTab: "פתח בלשונית חדשה",
      mobileSummaryTrigger: "פרטי הזמנה",
      summaryTitle: "סיכום הזמנה",
      summaryItem: "פריט",
      summaryBilling: "תקופת חיוב",
      summaryCoupon: "קופון",
      summaryTotal: "סה״כ לתשלום",
      summaryDueToday: "לתשלום היום",
      billingMonthly: "חודשי",
      billingAnnual: "שנתי",
      tokensItemLabel: "{count} טוקנים",
      timelineTitle: "ציר זמן החיוב",
      timelineToday: "היום",
      timelineLater: "בהמשך",
      timelineNextBilling: "החיוב הבא",
      timelineFirstMonth: "חודש ראשון בהנחה של {discount}",
      timelineFirstYear: "שנה ראשונה בהנחה של {discount}",
      timelineFromNextMonth: "מהחודש הבא ואילך",
      timelineFromNextYear: "מהשנה הבאה ואילך",
      timelineForRemainingDays: "עבור {days} ימים שנותרו במחזור הנוכחי",
      timelineStartingDate: "החל מ-{date}",
      prorationBreakdownTitle: "איך חישבנו את זה?",
      prorationCreditApplied: "זיכוי על {days} ימים שנותרו ב-{plan} ({price})",
      prorationNewPlanForDays: "{plan} עבור {days} ימים",
      prorationDifference: "הפרש לתשלום היום",
      whatYouGetTitle: "מה תקבלו",
      benefitMonthlyTokens: "{count} טוקנים בחודש",
      benefitApproxImagesPerMonth: "≈ {min}–{max} תמונות בחודש",
      benefitApproxVideosPerMonth: "≈ {min}–{max} סרטונים קצרים בחודש",
      benefitApproxImagesOneTime: "≈ {min}–{max} תמונות",
      benefitApproxVideosOneTime: "≈ {min}–{max} סרטונים קצרים",
      benefitSecurePayment: "תשלום מאובטח דרך PayPlus (PCI-DSS)",
      benefitTokensCount: "{count} טוקנים מתווספים מיד לחשבון",
      benefitTokensValidity: "תקפים ל-2 חודשים ומתווספים לחבילה הקיימת שלך",
      benefitTokensInstant: "זמינים מיד אחרי השלמת התשלום",
      faqTitle: "שאלות נפוצות",
      faq: {
        secure: {
          q: "האם התשלום מאובטח?",
          a: "כן. הטופס נטען ישירות מ-PayPlus, חברת סליקה מורשית בישראל, בתקן PCI-DSS. פרטי הכרטיס לא עוברים דרך השרתים שלנו.",
        },
        cancel: {
          q: "האם אפשר לבטל מנוי?",
          a: "כן. אפשר לבטל את המנוי בכל עת מעמוד הפרופיל; ההטבות יישארו פעילות עד סוף תקופת החיוב הנוכחית.",
        },
        support: {
          q: "צריכים עזרה?",
          a: "אנחנו כאן. שלחו לנו הודעה ב{link} ונחזור אליכם תוך יום עסקים.",
          linkText: "וואטסאפ",
        },
      },
    },
    // Image Upload Guide
    imageUploadGuide: {
      buttonText: "איזו תמונה להעלות?",
      mainTitle: "כדי לקבל תוצאות טובות – חשוב להעלות תמונה נכונה של המוצר",
      notSuitable: "❌ לא מתאים",
      suitable: "✅ מתאים",
      notSuitableItems: [
        "תאורה חלשה או צללים",
        "המוצר לא מצולם בשלמותו",
        "קימוטים, פגמים או לכלוך",
        "טקסט קטן או מטושטש",
      ],
      suitableItems: [
        "תמונה ברורה עם תאורה אחידה",
        "המוצר מצולם בשלמותו",
        "צבעים מדויקים",
        "טקסט חד וברור (אם קיים)",
      ],
      notSuitableCaption: "צילום כזה עלול לפגוע באיכות התוצאה",
      suitableCaption: "כך המערכת יכולה להפיק תוצאות מדויקות",
      disclaimer1: "* התמונות נוצרות באמצעות בינה מלאכותית ועלולות לכלול אי־דיוקים קלים",
      disclaimer2: "* במוצרים עם הרבה כיתוב בעברית ייתכן עיוות קל בטקסט, במיוחד כאשר הוא קטן או צפוף",
      notSuitablePhoto: "צילום לא מתאים",
      properlyPhotographed: "מוצר מצולם נכון",
      optionalBadge: "אופציונאלי",
      profileSideView: "תמונת פרופיל/צד",
      notSuitableShort: "תאורה בעייתית|מוצר חלקי|טקסט לא חד",
      suitableShort: "תאורה אחידה|מוצר שלם|צבעים מדויקים",
      profilePointsList: "תוצאות מדויקות יותר|פחות הזיות|אופציונלי",
      aiDisclaimer: "* אפליקציה זו מבוססת בינה מלאכותית ועלולה לטעות",
      hebrewTextDisclaimer: "* טקסט בעברית עלול לצאת מעט מעוות כאשר הוא לא ברור או מרובה",
    },
    // How It Works
    howItWorks: {
      trigger: "איך זה עובד?",
      gotIt: "הבנתי",
      imageGenerator: {
        headline: "מרעיון לתמונה בשניות",
        step1Title: "העלאת תמונה",
        step1Desc: "העלו תמונה שברצונכם לערוך",
        step2Title: "תארו את השינוי",
        step2Desc: "ספרו ל-AI מה לשנות — רקע, צבעים, אלמנטים",
        step3Title: "קבלו את התוצאה",
        step3Desc: "ה-AI יוצר את התמונה הערוכה בשניות",
      },
      textToVideo: {
        headline: "מקונספט לווידאו בשניות",
        step1Title: "תארו את הסצנה",
        step1Desc: "כתבו פרומפט שמתאר את הווידאו שאתם רוצים",
        step2Title: "הוסיפו רפרנס",
        step2Desc: "אופציונלי — העלו תמונה להנחיית הסגנון",
        step3Title: "קבלו את הווידאו",
        step3Desc: "ה-AI יוצר את הווידאו שלכם בשניות",
      },
      framesToVideo: {
        headline: "מפריימים לתנועה בשניות",
        step1Title: "העלו התחלה וסוף",
        step1Desc: "העלו את הפריים הראשון והאחרון של הווידאו",
        step2Title: "תארו את התנועה",
        step2Desc: "ספרו ל-AI איך להנפיש בין הפריימים",
        step3Title: "קבלו את הווידאו",
        step3Desc: "ה-AI יוצר את סרטון המעבר",
      },
      productCatalog: {
        headline: "מתמונה אחת לקטלוג שלם",
        step1Title: "העלו את המוצר",
        step1Desc: "תמונה ברורה ומוארת היטב של המוצר שלכם",
        step2Title: "קבלו את הקטלוג",
        step2Desc: "ה-AI יוצר זוויות וגרסאות מקצועיות",
      },
      directorChat: {
        headline: "יצירת תמונות דרך שיחה",
        step1Title: "התחילו שיחה",
        step1Desc: "שוחחו עם ה-AI על התמונה שאתם רוצים",
        step2Title: "ה-AI מייצר אפשרויות",
        step2Desc: "קבלו מספר אפשרויות תמונה לבחירה",
        step3Title: "שפרו ושכללו",
        step3Desc: "בקשו שינויים עד שזה מושלם",
      },
    },
    // Lightbox
    lightbox: {
      backToStudio: "חזרה לסטודיו",
      options: "אפשרויות",
      editImage: "ערוך תמונה",
      regenerate: "צור מחדש",
      regenerateDisabled: "לא נעשה שימוש בתמונת מקור — לא ניתן ליצור מחדש",
      animate: "הנפשה",
      download: "הורדה",
      share: "שיתוף",
      imageDetails: "פרטי התמונה",
      videoDetails: "פרטי הסרטון",
      creationDate: "תאריך יצירה",
      sourceImage: "תמונת מקור",
      prompt: "פרומפט",
      resolution: "איכות",
      clickToUseSource: "לחץ להשתמש",
      clickToUseImage: "לחץ להשתמש בתמונה זו",
      aspectRatio: "יחס תמונה",
      pipeline: "סוג יצירה",
      pipelineAd: "מודעה",
      pipelineEdit: "עריכה",
      pipelineDirector: "Image Director",
      pipelineTextToVideo: "טקסט לווידאו",
      pipelineFramesToVideo: "פריימים לווידאו",
      model: "מודל",
      duration: "משך",
      secondsShort: "ש׳",
      showMore: "הצג עוד",
      showLess: "הצג פחות",
      fullscreen: "מסך מלא",
      advancedSettings: "הגדרות מתקדמות",
    },
    // Not Found Page
    notFound: {
      title: "404",
      message: "אופס! הדף לא נמצא",
      returnHome: "חזרה לדף הבית",
    },
    // Public share page (/s/:id) — opened when someone clicks a branded share link
    share: {
      loading: "טוען יצירה...",
      ctaLine1: "נוצר ב-TodoAI",
      ctaLine2: "תיצרו משלכם — חינם",
      ctaButton: "התחילו ליצור",
      notFoundTitle: "היצירה הזו כבר לא זמינה",
      notFoundBody: "ייתכן שהיוצר/ת הסירו אותה, או שהקישור שגוי.",
      goHome: "כניסה ל-TodoAI",
    },
    // Credits Display
    creditsDisplay: {
      credits: "קרדיטים",
    },
    // Photo Guidelines
    photoGuidelines: {
      title: "איך לצלם את המוצר",
      subtitle: "לתוצאות מיטביות",
      frontView: "צילום חזיתי וישר",
      cameraHeight: "מצלמה בגובה המוצר",
      frontViewTitle: "צילום חזיתי וישר",
      frontViewDesc: "המוצר מול המצלמה בצורה אופקית, לא בזווית מלמעלה/מלמטה",
      cameraHeightTitle: "מצלמה בגובה המוצר",
      cameraHeightDesc: "עדשה בקו ישר מול מרכז המוצר למניעת עיוותים",
      goodExample: "דוגמה טובה",
      howToPhoto: "איך לצלם נכון?",
      howToPhotoTitle: "איך לצלם מוצר נכון?",
      correctPhoto: "צילום נכון",
      evenLighting: "תאורה אחידה ומדויקת",
      completeProduct: "מוצר שלם ונראה",
      accurateColors: "צבעים מדויקים",
      cleanBackground: "רקע נקי",
      incorrectPhoto: "צילום לא מתאים",
      poorLighting: "תאורה בעייתית/צללים",
      partialProduct: "מוצר חתוך/חלקי",
      unclearText: "טקסט לא חד",
      distractingBg: "רקע מבלבל",
      tip: "💡 טיפ: צלם את המוצר על רקע לבן או נייטרלי עם תאורה טבעית לתוצאות הטובות ביותר.",
      moreAccurate: "תוצאות מדוייקות יותר",
      lessHallucinations: "פחות הזיות",
      optional: "אופציונלי",
    },
    // Image Delete
    imageDelete: {
      deleteFailed: "שגיאה במחיקה",
      imageDeleted: "התמונה נמחקה",
      removedFromGalleries: "התמונה הוסרה מכל הגלריות",
      deleteError: "אירעה שגיאה במחיקה",
    },
    // Mask Canvas
    maskCanvas: {
      title: "צייר על התמונה",
      brush: "טוש",
      eraser: "מחק",
      brushSize: "גודל",
      clear: "נקה",
      confirm: "אשר",
      instructions: "צייר על האזור שברצונך לערוך. בסיום לחץ \"אשר\" והמסכה תשמש כהוראה לעריכה.",
    },
    // Image Director Chat
    director: {
      pageTitle: "Image Director Chat",
      subtitle: "ספר לי מה אתה רוצה — אני אייצר לך תמונות סטודיו",
      greeting: "שלום! אני הסוכן הקריאייטיבי שלך 🎨 תאר בקצרה מה תרצה ליצור — אני אשאל כמה שאלות קצרות כדי להבין בדיוק מה אתה מחפש.",
      newChat: "שיחה חדשה",
      conversationHistory: "היסטוריית שיחות",
      useReferenceImages: "השתמש בתמונות רפרנס",
      referenceOn: "פעיל",
      referenceOff: "כבוי",
      referenceAck: "תודה שהכנסת את התמונה 🙏 התמונה תשמש בשביל רפרנס בלבד.",
      quantity: "כמות:",
      quality: "איכות:",
      ratio: "יחס:",
      inProgress: "בתהליך:",
      generateBtn: "צור {count} תמונות ({cost} קרדיטים)",
      helperKeepAnswering: "המשך לענות על השאלות או לחץ 'צור תמונות' כדי ליצור עכשיו",
      helperModifyPrompt: "אפשר לשנות את הפרומט על ידי כתיבת הודעה נוספת, או ללחוץ 'צור תמונות'",
      allAgentImages: "כל התמונות מהסוכן",
      processing: "בתהליך...",
      clickToOpen: "לחץ לפתיחה",
      noImagesYet: "עדיין לא נוצרו תמונות עם הסוכן",
      startCreating: "התחל שיחה עם הסוכן כדי ליצור תמונות",
      error: "שגיאה",
      aiCommError: "אירעה שגיאה בתקשורת עם ה-AI",
      oneMoreStep: "עוד רגע",
      oneMoreStepDesc: "כתוב תיאור קצר וענה לפחות על שאלה אחת—ואז לחץ 'צור תמונות'.",
      proRequired: "נדרש מנוי PRO",
      proRequiredDesc: "איכות 4K זמינה רק למנויי PRO",
      generationInProgress: "יש יצירה בתהליך",
      maxConcurrent: "מקסימום 4 יצירות במקביל",
      parallelPro: "זמין ב-PRO ליצור במקביל",
      imagesCreated: "התמונות נוצרו!",
      imagesCreatedDesc: "נוצרו {count} תמונות בהצלחה",
      generationFailed: "יצירה נכשלה",
      generationFailedDesc: "אירעה שגיאה ביצירת התמונות",
      failedRefunded: "נכשל - קרידיטים הוחזרו",
      generationFailedWithRefund: "היצירה נכשלה. הקרדיטים הוחזרו.",
      viewingHistory: "צפייה בהיסטוריה - לחץ 'שיחה חדשה' להמשיך",
      describePlaceholder: "תאר את התמונה שאתה רוצה ליצור...",
      referenceCount: "תמונות רפרנס",
      generate: "יצירה",
      promptReady: "הפרומפט מוכן! לחצו על יצירה כדי ליצור את התמונות",
      promptNotReady: "ענו על השאלות כדי להכין את הפרומפט",
      defaultTitle: "צ׳אט Image Director",
    },
    // Explore Page
    explore: {
      title: "קהילה",
      subtitle: "תוצאות אמיתיות מהקהילה שלנו — קבלו השראה ליצירה הבאה שלכם",
      tabImages: "תמונות",
      tabVideos: "סרטונים",
      filterAll: "הכל",
      filterAds: "מודעות",
      filterEdits: "עריכות",
      ctaTitle: "רוצים ליצור תוצאות כאלה?",
      ctaSubtitle: "התחילו ליצור בחינם עכשיו",
      ctaButton: "התחל ליצור",
      noImagesTitle: "אין תמונות עדיין",
      noImagesSubtitle: "היה הראשון ליצור!",
      noVideosTitle: "אין סרטונים עדיין",
      noVideosSubtitle: "היה הראשון ליצור סרטון!",
      badgeEdit: "עריכה",
      badgeAd: "מודעה",
      badgeVideo: "סרטון",
      privacyBannerTitle: "התוכן שלך מוצג כאן",
      privacyBannerSubtitle: "בתוכנית החינמית, היצירות שלך מופיעות בגלריה הקהילתית. שדרג לפרטיות מלאה.",
      privacyBannerUpgrade: "שדרג לפרטיות",
    },
    // Lightbox Delete
    lightboxDelete: {
      deleteBtn: "מחק",
      confirmTitle: "האם למחוק את התמונה?",
      confirmDesc: "פעולה זו תמחק את התמונה לצמיתות מכל הגלריות. לא ניתן לבטל פעולה זו.",
      cancel: "ביטול",
    },
    // Dual Reference Upload
    dualReferenceUpload: {
      title: "העלה תמונות מוצר",
      detectedRatio: "זוהה יחס:",
      uploadProduct: "העלה תמונת מוצר",
      dragOrClick: "לחץ או גרור תמונה לכאן",
      mainImage: "תמונה ראשית",
      addMore: "הוסף תמונות נוספות לשיפור הדיוק (עד 5)",
    },
    // PRO Feature Modal
    proModal: {
      title: "פיצ'ר זה הוא למנויי PRO בלבד",
      description: "שדרג לתוכנית PRO כדי לקבל גישה לאיכות 4K וכל היתרונות הנוספים",
      upgrade: "שדרג ל-PRO",
      notNow: "לא עכשיו",
    },
    // Chat Input Bar
    chatInput: {
      placeholder: "תאר מה תרצה ליצור...",
      addReference: "הוסף תמונת רפרנס",
      dropToAttach: "שחרר לצירוף תמונה",
      fileTooLarge: "הקובץ גדול מדי",
      fileTooLargeDesc: "גודל קובץ מקסימלי הוא 10 MB",
    },
    // History Panel
    historyPanel: {
      title: "היסטוריית שיחות",
      loading: "טוען...",
      empty: "אין עדיין היסטוריית שיחות",
      untitled: "שיחה ללא כותרת",
      resume: "המשך",
    },
    // Agent Mode Selector
    agentMode: {
      prompt: "מה תרצה לעשות?",
      newCharactersTitle: "ליצור דמויות חדשות",
      newCharactersDesc: "ללא רפרנס — הדמויות יהיו חדשות לגמרי",
      referenceTitle: "להשתמש בתמונת רפרנס",
      referenceDesc: "מוצר/פנים — לשמירת עקביות",
    },
    // Scroll to Bottom Button
    scrollButton: {
      newMessages: "{count} הודעות חדשות",
      backToBottom: "חזור למטה",
    },
    // Contact Page
    contact: {
      title: "צור קשר",
      subtitle: "יש לך שאלה? נשמח לעזור! מלא את הטופס ונחזור אליך בהקדם.",
      fullName: "שם מלא",
      namePlaceholder: "הכנס את שמך",
      email: "אימייל",
      messageLabel: "הודעה",
      messagePlaceholder: "ספר לנו במה נוכל לעזור...",
      sending: "שולח...",
      sendMessage: "שלח הודעה",
      emailLabel: "אימייל",
      responseTime: "זמני מענה",
      responseHours: "א׳-ה׳, 09:00-18:00",
      faqTitle: "שאלות נפוצות",
      faqSubtitle: "לפני שאתה פונה, אולי התשובה כבר נמצאת אצלנו",
      faqButton: "לשאלות נפוצות",
      successToast: "ההודעה נשלחה בהצלחה",
      successDesc: "נחזור אליך בהקדם האפשרי",
    },
    // Help Page
    help: {
      title: "מרכז העזרה",
      subtitle: "מצאו תשובות לשאלות הנפוצות ביותר. לא מצאתם את מה שחיפשתם? צרו איתנו קשר.",
      stillNeedHelp: "עדיין צריכים עזרה?",
      teamHere: "הצוות שלנו כאן בשבילכם. נשמח לעזור בכל שאלה או בעיה.",
      sendMessageBtn: "שלחו הודעה",
      // Categories
      catAll: "הכל",
      catGettingStarted: "התחלה מהירה",
      catImages: "יצירת תמונות",
      catVideos: "יצירת סרטונים",
      catEditing: "עריכת תמונות",
      catCredits: "קרדיטים ותשלום",
      catAccount: "חשבון",
      catTechnical: "טכני",
      // FAQ questions
      // Getting Started
      faq1Q: "?איך מתחילים להשתמש ב-TodoAI",
      faq1A: "נרשמים לחשבון חינמי — בלי כרטיס אשראי. מעלים תמונה של המוצר ובוחרים מה ליצור: תמונת מודעה, צילום סטודיו או סרטון קצר. הבינה המלאכותית עושה את השאר ומספקת תוצאות תוך פחות מדקה.",
      faq2Q: "?צריך ידע טכני או ניסיון בעיצוב",
      faq2A: "בכלל לא. TodoAI נבנתה לבעלי עסקים, לא למעצבים. אם אתם יודעים להעלות תמונה, אתם יודעים להשתמש בפלטפורמה. בלי תוכנות להתקין, בלי הדרכות לצפות — פשוט מעלים ויוצרים.",
      faq3Q: "?אילו סוגי קבצים וגדלים אפשר להעלות",
      faq3A: "אנחנו תומכים בפורמטים PNG, JPG ו-WEBP עד 10 MB. לתוצאות הכי טובות, השתמשו בתמונה ברורה עם תאורה טובה. תמונה מסמארטפון בתאורה טובה עובדת מעולה.",
      faq4Q: "?TodoAI זמין בעברית",
      faq4A: "!כן! כל הממשק תומך בעברית עם פריסה מלאה מימין לשמאל. אפשר לעבור בין אנגלית לעברית בכל רגע מהתפריט.",
      // Image Creation
      faq5Q: "?כמה זמן לוקח ליצור תמונה",
      faq5A: "רוב התמונות מוכנות תוך 20-30 שניות. יוצר המודעות נותן 4 וריאציות בכל יצירה כדי שתוכלו לבחור את הטובה ביותר. רזולוציות גבוהות יותר עשויות לקחת כמה שניות נוספות.",
      faq6Q: "?מה זה יחס גובה-רוחב ואיזה לבחור",
      faq6A: "יחס גובה-רוחב זה הצורה של התמונה. 1:1 לפוסטים באינסטגרם, 9:16 לסטוריז ורילס, 16:9 לבאנרים וכותרות באתר. לא בטוחים? בחרו 'אוטומטי' והמערכת תבחר את ההתאמה הטובה ביותר.",
      faq7Q: "?מה ההבדל בין הרזולוציות",
      faq7A: "HD עובד טוב לרשתות חברתיות. 2K הוא בחירה מצוינת לכל דבר — איכות חדה עם עיבוד מהיר. 4K אידיאלי להדפסה או שימוש בפורמט גדול. כל התוכניות, כולל החינמית, כוללות גישה ל-4K.",
      // Video Creation
      faq8Q: "?מה ההבדל בין Kling 2.6 ל-Kling 2.5 Turbo",
      faq8A: "Kling 2.6 מייצר סרטון מתמונה אחת עם תנועה טבעית ואפקטי סאונד אופציונליים. Kling 2.5 Turbo נותן יותר שליטה על ידי הגדרת תמונת התחלה וסיום למעברים מדויקים.",
      faq9Q: "?אפשר להוסיף סאונד או מוזיקה לסרטונים",
      faq9A: "ב-Kling 2.6 יש אפשרות Sound מובנית שמוסיפה אפקטי סאונד סביבתיים ודיבור באנגלית לסרטון. למוזיקת רקע או קריינות, אפשר להוסיף אודיו אחרי ההורדה בכל אפליקציית עריכת וידאו.",
      faq10Q: "?מה יכול להיות אורך הסרטונים",
      faq10A: "אפשר ליצור סרטונים של 5 או 10 שניות. קליפים קצרים עובדים הכי טוב למודעות ברשתות חברתיות, טיזרים של מוצרים ותוכן לאינסטגרם/טיקטוק.",
      // Editing
      faq11Q: "?מה אפשר לעשות עם עורך התמונות",
      faq11A: "העורך מאפשר לשנות רקעים, להוסיף או להסיר אובייקטים, לכוונן צבעים ולהחיל אפקטים יצירתיים — הכל מונע בינה מלאכותית. לדוגמה, אפשר להחליף רקע לבן רגיל לסצנת לייפסטייל תוך שניות. פשוט תארו את השינוי שאתם רוצים.",
      faq12Q: "?יש טיפים לכתיבת הוראות עריכה טובות",
      faq12A: "היו ספציפיים. במקום 'תשפרו את זה', נסו 'שנו את הרקע לשולחן עץ עם תאורה טבעית רכה'. ככל שהתיאור ברור יותר, כך התוצאה תהיה קרובה יותר למה שדמיינתם.",
      // Tokens & Pricing
      faq13Q: "?כמה טוקנים עולה כל פעולה",
      faq13A: "עלות הטוקנים תלויה במודל וברזולוציה שבוחרים. תמונות עולות בדרך כלל בין 4 ל-25 טוקנים. סרטונים נעים בין כ-20 טוקנים לקליפ קצר ועד כמה מאות לאפשרויות ארוכות ואיכותיות יותר. תמיד תראו את העלות המדויקת לפני שמאשרים יצירה.",
      faq14Q: "?מה קורה כשנגמרים הטוקנים",
      faq14A: "אפשר לשדרג תוכנית לעוד טוקנים חודשיים, או לרכוש חבילות טוקנים חד-פעמיות כדי להמשיך ליצור.",
      faq15Q: "?הטוקנים מתחדשים כל חודש",
      faq15A: "!כן! בתוכניות Starter, Pro ו-Creator הטוקנים מתחדשים בכל מחזור חיוב. טוקנים שלא נוצלו לא עוברים לחודש הבא. אפשר גם לקנות חבילות טוקנים בכל זמן לחיזוק חד-פעמי.",
      faq16Q: "?מה קורה אם יצירה נכשלת? מפסידים טוקנים",
      faq16A: "לא. אם יצירה נכשלת מכל סיבה, הטוקנים מוחזרים אוטומטית. משלמים רק על תוצאות שבאמת מקבלים.",
      // Account
      faq17Q: "?איך מעדכנים פרטי חשבון",
      faq17A: "היכנסו לעמוד הפרופיל מהתפריט. שם תוכלו לעדכן שם תצוגה, תמונת פרופיל ופרטי חשבון נוספים.",
      faq18Q: "?איך מבטלים מנוי",
      faq18A: "אפשר לבטל בכל רגע דרך הגדרות החשבון — בלי מכשולים. אחרי הביטול, ממשיכים ליהנות מגישה מלאה עד סוף תקופת החיוב הנוכחית.",
      // Technical
      faq19Q: "?למה תמונת הבינה המלאכותית נראית שונה מהתמונה המקורית",
      faq19A: "הבינה המלאכותית מפרשת את התמונה באופן יצירתי במקום להעתיק אותה פיקסל-פיקסל. לתוצאות קרובות יותר למקור, העלו תמונה באיכות גבוהה עם תאורה טובה ורקע נקי. הוספת תיאור מפורט גם עוזרת לכוון את הבינה המלאכותית.",
      faq20Q: "?טקסט בעברית בתמונה שלי נראה מעוות — מה אפשר לעשות",
      faq20A: "מודלים של בינה מלאכותית לפעמים מתקשים עם טקסט קטן או צפוף בעברית. לתוצאות הטובות ביותר, השתמשו בתמונות עם טקסט גדול וברור — או הוסיפו טקסט אחרי היצירה באמצעות עורך התמונות.",
      faq21Q: "?איזו איכות ורזולוציה אקבל בתמונות",
      faq21A: "כל התוכניות — כולל החינמית — מאפשרות ליצור תמונות ברזולוציה עד 4K ללא סימני מים. גודל הפלט המדויק תלוי ביחס הגובה-רוחב וברזולוציה שבוחרים לפני היצירה.",
    },
    // Terms of Service
    terms: {
      title: "תנאי שימוש",
      lastUpdated: "עודכן לאחרונה: פברואר 2026",
      section1Title: "1. הסכמה לתנאים",
      section1Content: "בגישה או שימוש בשירותי TodoAI (\"השירות\"), אתה מסכים להיות כפוף לתנאי שימוש אלה. אם אינך מסכים לתנאים אלה, אנא הימנע משימוש בשירות. עליך להיות בן 18 לפחות כדי להשתמש בשירות. בשימוש בשירות אתה מצהיר ומאשר שאתה בן 18 או יותר ושיש לך את הסמכות החוקית להתקשר בתנאים אלה.",
      section2Title: "2. תיאור השירות",
      section2Content: "TodoAI מספקת פלטפורמה מבוססת בינה מלאכותית ליצירת תמונות, סרטונים, שדרוג רזולוציה ועריכת תוכן ויזואלי. השירות משתמש בספקי בינה מלאכותית צד שלישי (כולל אך לא רק OpenAI, Kling AI ו-NanoBanana) לעיבוד תוכן. התכונות, הדגמים הזמינים והיכולות עשויים להשתנות מעת לעת.",
      section3Title: "3. חשבון משתמש",
      section3Content: "עליך לספק מידע מדויק ועדכני בעת יצירת חשבון. אתה אחראי באופן בלעדי לשמירה על סודיות פרטי הגישה שלך ולכל הפעילות המתרחשת תחת החשבון שלך. עליך להודיע ל-TodoAI באופן מיידי על כל שימוש לא מורשה בחשבונך. TodoAI אינה אחראית לכל אובדן או נזק הנובע משימוש לא מורשה בחשבונך.",
      section4Title: "4. קרדיטים ותשלומים",
      section4Content: "השימוש בשירות מחייב קרדיטים. כל הרכישות הינן סופיות — קרדיטים שנרכשו אינם ניתנים להחזר, להעברה או להמרה למזומן. המחירים עשויים להשתנות מעת לעת; שינויים יחולו על רכישות עתידיות בלבד. קרדיטים שלא נוצלו אינם צוברים ריבית ועשויים לפוג בהתאם לתנאי החבילה. TodoAI אינה אחראית לכשלי תשלום הנובעים מספק התשלום שלך.",
      section5Title: "5. זכויות קניין רוחני",
      section5Content: "בכפוף לציות לתנאים אלה, אתה שומר על הזכויות בתוכן שנוצר באמצעות השירות לשימוש אישי ומסחרי. עם זאת, TodoAI שומרת על כל הזכויות בפלטפורמה, בטכנולוגיה, במודלים, באלגוריתמים ובקוד המקור. TodoAI רשאית להשתמש בתוכן אנונימי ומצרפי לצורך שיפור השירות, אימון מודלים ושיווק, ללא זיהוי אישי שלך. אתה מצהיר שיש לך את כל הזכויות הנדרשות בתוכן שאתה מעלה לשירות.",
      section6Title: "6. הסתייגות בנוגע לתוכן שנוצר על ידי AI",
      section6Content: "תוכן שנוצר באמצעות בינה מלאכותית מסופק \"כמות שהוא\" ללא כל אחריות לדיוק, איכות או התאמה. תוצרי AI עלולים לכלול תוצאות בלתי צפויות, אי-דיוקים, או תוכן שעלול להידמות לאנשים אמיתיים, מותגים או חומר המוגן בזכויות יוצרים. אתה האחראי הבלעדי לבדיקה, אימות ושימוש חוקי בכל תוכן שנוצר. TodoAI אינה אחראית לכל תביעה הנובעת מהשימוש שלך בתוכן שנוצר על ידי AI.",
      section7Title: "7. שימוש אסור",
      section7Content: "אסור להשתמש בשירות ליצירת תוכן: בלתי חוקי, מזיק, מאיים, פוגעני, מטריד, משמיץ או גזעני; המפר זכויות קניין רוחני או פרטיות של צד שלישי; של התחזות לאנשים אמיתיים (כולל deepfakes) ללא הסכמתם; פורנוגרפי, בפרט כל תוכן המנצל קטינים (CSAM); של הונאה, הטעיה או מצג שווא; שנועד לעקוף מסנני בטיחות או הגבלות של השירות; של ספאם, תוכנות זדוניות או פישינג. TodoAI שומרת על הזכות להסיר תוכן, להשעות או לסגור חשבונות המפרים תנאים אלה, לפי שיקול דעתה הבלעדי וללא הודעה מוקדמת.",
      section8Title: "8. פיקוח על תוכן והסרת הפרות",
      section8Content: "TodoAI שומרת על הזכות (אך אינה מחויבת) לסקור, לנטר ולהסיר כל תוכן שנוצר באמצעות השירות. אם אתה סבור שתוכן מפר את זכויות היוצרים שלך, אנא צור איתנו קשר עם פרטי ההפרה הנטענת, כולל: תיאור היצירה המוגנת, זיהוי התוכן המפר, ופרטי ההתקשרות שלך. TodoAI תטפל בתלונות ותסיר תוכן מפר בהתאם לחוק. מפרים חוזרים עלולים לגלות שחשבונם נסגר לצמיתות.",
      section9Title: "9. שירותי צד שלישי",
      section9Content: "השירות משתמש בספקי בינה מלאכותית ושירותים של צד שלישי (כולל OpenAI, Kling AI, NanoBanana ואחרים) לעיבוד ויצירת תוכן. שירותי צד שלישי אלה כפופים לתנאים ולמדיניות הפרטיות שלהם. TodoAI אינה אחראית לזמינות, דיוק או ביצועים של שירותי צד שלישי. שינויים או הפסקת שירותי צד שלישי עלולים להשפיע על תכונות ויכולות השירות.",
      section10Title: "10. זמינות השירות",
      section10Content: "TodoAI שואפת לספק שירות רציף אך אינה מתחייבת לזמינות ללא הפרעות. השירות עשוי שלא להיות זמין בשל תחזוקה, עדכונים, תקלות טכניות או נסיבות שאינן בשליטתנו. TodoAI רשאית לשנות, להשעות או להפסיק כל חלק מהשירות בכל עת, עם או בלי הודעה מוקדמת. לא תהיה לך כל טענה בגין הפסקת שירות זמנית או קבועה.",
      section11Title: "11. סיום",
      section11Content: "TodoAI רשאית להשעות או לסגור את חשבונך בכל עת, מכל סיבה שהיא, לפי שיקול דעתה הבלעדי, כולל אך לא רק הפרת תנאים אלה. עם סיום החשבון: קרדיטים שלא נוצלו יחולטו ולא יוחזרו; הגישה שלך לשירות ולתוכן שנוצר תופסק; TodoAI רשאית למחוק את הנתונים והתוכן שלך. אתה רשאי לסגור את חשבונך בכל עת דרך הגדרות החשבון או על ידי יצירת קשר עמנו.",
      section12Title: "12. הגבלת אחריות",
      section12Content: "השירות מסופק \"כמות שהוא\" ו\"כפי שהוא זמין\" ללא כל אחריות, מפורשת או משתמעת, כולל אך לא רק אחריות לסחירות, התאמה למטרה מסוימת, ואי-הפרה. בשום מקרה TodoAI, מנהליה, עובדיה או שותפיה לא יהיו אחראים לנזקים עקיפים, מקריים, מיוחדים, תוצאתיים או עונשיים, כולל אובדן רווחים, נתונים, מוניטין או הפסדים עסקיים. האחריות הכוללת של TodoAI כלפיך מוגבלת לסכום ששילמת עבור השירות ב-12 החודשים שקדמו לתביעה.",
      section13Title: "13. שיפוי",
      section13Content: "אתה מתחייב לשפות, להגן ולפטור את TodoAI, מנהליה, עובדיה ושותפיה מכל תביעה, נזק, הפסד, אחריות, עלויות והוצאות (כולל שכר טרחת עורכי דין) הנובעים מ: (א) שימושך בשירות; (ב) תוכן שיצרת או העלית; (ג) הפרת תנאים אלה על ידך; (ד) הפרת זכויות צד שלישי על ידך.",
      section14Title: "14. הדין החל וסמכות שיפוט",
      section14Content: "תנאים אלה כפופים לחוקי מדינת ישראל ויפורשו בהתאם להם, מבלי להתחשב בכללי ברירת הדין. כל מחלוקת הנובעת מתנאים אלה או הקשורה אליהם תהיה בסמכות השיפוט הבלעדית של בתי המשפט בתל אביב-יפו, ישראל. הצדדים מסכימים לנסות ליישב מחלוקות בדרכי שלום לפני פנייה לבית משפט.",
      section15Title: "15. שינויים בתנאים",
      section15Content: "TodoAI רשאית לעדכן תנאים אלה מעת לעת. נודיע על שינויים מהותיים באמצעות הודעה באתר או באימייל. המשך השימוש בשירות לאחר עדכון מהווה הסכמה לתנאים המעודכנים. אם אינך מסכים לתנאים המעודכנים, עליך להפסיק את השימוש בשירות.",
      section16Title: "16. יצירת קשר",
      section16Content: "לשאלות בנוגע לתנאי שימוש אלה, ניתן לפנות אלינו דרך דף יצירת הקשר באתר.",
    },
    // Privacy Policy
    privacy: {
      title: "Privacy Policy for TodoAI",
      lastUpdated: "Last Updated: February 2026",
      intro: "This Privacy Policy explains how TodoAI, operated by Todo AI Technologies Ltd. (\"we,\" \"us,\" or \"our\"), collects, uses, discloses, and safeguards your information when you use our platform and related services (collectively, the \"Service\").",
      agreement: "By accessing or using the Service, you acknowledge that you have read and understand this Privacy Policy. If you do not agree, please do not use the Service.",
      keyPointsTitle: "Key Points",
      keyPoints: [
        "**You own** all content you generate through our AI tools",
        "**We don't sell** your personal information",
        "**Your images and prompts** are sent to third-party AI providers to generate your content",
        "**We don't train** on your outputs for other users",
        "**You can request** deletion of your data and account at any time",
        "**Your data** is processed in Israel (EU-adequate) and may be processed in other countries where our AI providers operate",
      ],
      section1Title: "1. Information We Collect",
      section1Sub1Title: "Information You Provide:",
      section1Sub1Items: [
        "Name and email address",
        "Profile preferences and language setting",
        "Billing and payment information (processed securely by our payment provider — we never see or store your card details)",
        "Images you upload, text prompts you write, and the images and videos generated for you",
      ],
      section1Sub2Title: "Information Collected Automatically:",
      section1Sub2Items: [
        "IP address, browser type, operating system, device type",
        "Pages visited, features used, session duration",
        "Cookies and similar technologies (see Section 4)",
      ],
      section1Sub3Title: "Information from Third Parties:",
      section1Sub3Items: [
        "If you sign in via Google: name, email, and profile picture as provided by Google",
      ],
      section2Title: "2. How We Use Your Information",
      section2Items: [
        "Provide, maintain, and improve our Service",
        "Process your images and prompts through AI models and deliver generated outputs",
        "Process payments and send transaction confirmations",
        "Communicate with you (support, updates, security alerts)",
        "Send marketing and promotional communications (only with your opt-in consent)",
        "Analyze usage patterns to improve the Service",
        "Display free-plan creations in the Community Gallery (see Section 3)",
        "Maintain the security of the Service",
        "Comply with legal obligations",
      ],
      section3Title: "3. Sharing Your Information",
      section3Content: "We do not sell your personal information. We share data only in these situations:",
      section3Items: [
        "**AI providers:** Your uploaded images and prompts are sent to the third-party AI providers powering the feature you use, in order to generate your outputs. Each provider's own privacy policy also applies. We select providers that commit to not using API customer data for model training, but we cannot guarantee their internal practices",
        "**Service providers:** Cloud hosting, payment processing, analytics, and email communications",
        "**Community Gallery:** Images generated on the free plan are displayed publicly in our Explore gallery. Only the generated image and your display name are shown — never your email, account details, or original uploads. You can remove your content from the gallery at any time through your account settings",
        "**Legal requirements:** When required by law, court order, or by the Israel Privacy Protection Authority (PPA)",
        "**Business transfers:** In connection with a merger, acquisition, or sale of assets — with prior notice to you",
        "**With your consent:** For any purpose not described in this Policy",
      ],
      section3Outro: "We may share non-personally-identifiable, aggregated data for analytics and improvement purposes. For a current list of sub-processors or more details, contact team@todowith.ai.",
      section4Title: "4. Cookies and Analytics",
      section4Content: "We use cookies and similar technologies to personalize your experience and understand usage patterns:",
      section4Items: [
        "**Essential cookies** — Required for the Service to function (authentication, session management, and language preferences). These cannot be disabled.",
        "**Analytics cookies (PostHog)** — Help us understand how visitors use the Service, including page views, feature usage, and performance. We may also collect your user ID, email, display name, and subscription type for analytics purposes. You can opt in or out of analytics cookies at any time via the cookie consent banner.",
      ],
      section4Outro: "When you first visit, we display a cookie consent banner where you can accept, reject, or customize your preferences. You can change your cookie settings at any time via the \"Manage Cookies\" link in the footer. Declining analytics cookies does not affect core functionality.",
      section5Title: "5. Security",
      section5Content: "We implement appropriate technical and organizational measures to protect your personal data, including encryption in transit and at rest, access controls, and monitoring.\n\nNo system is perfectly secure, and we cannot guarantee absolute security. In the event of a data breach, we will notify the Israel Privacy Protection Authority and affected users as required by the Protection of Privacy Law.",
      section6Title: "6. Data Retention",
      section6Items: [
        "**Account data:** Retained while your account is active",
        "**Uploaded images and generated content:** Retained while your account is active; deleted within 30 days of account deletion",
        "**Financial records:** 7 years as required by Israeli tax law (held by our payment provider)",
        "**Usage and analytics data:** Up to 24 months, then anonymized",
        "**Server logs:** 90 days",
      ],
      section6Outro: "You may request deletion of your data at any time by contacting us. Some data may be retained where required by law.",
      section7Title: "7. Your Rights",
      section7Content: "Under the Protection of Privacy Law, 5741-1981 (as amended by Amendment No. 13) and, where applicable, the GDPR, you have the right to:",
      section7Items: [
        "Access, correct, or delete your personal data",
        "Restrict or object to certain processing",
        "Request data portability",
        "Withdraw consent for non-essential processing",
        "Lodge a complaint with the Israel Privacy Protection Authority (PPA): 66 Kanfei Nesharim St., Jerusalem; Phone: *3450",
      ],
      section7Outro: "Providing your information is voluntary. However, without an email and name you cannot create an account, and without uploading images the AI generation features cannot function.\n\nContact team@todowith.ai to exercise your rights. We respond within 30 days.",
      section8Title: "8. AI Content and Ownership",
      section8Sub1Title: "Ownership:",
      section8Sub1Content: "You own the images and videos you generate through our AI tools. We do not claim ownership of your content.",
      section8Sub2Title: "How it works:",
      section8Sub2Content: "When you use our generation features, your uploaded images and text prompts are sent to third-party AI model providers to generate your requested output. The results are returned to our servers and delivered to you.",
      section8Sub3Title: "Your content is yours:",
      section8Sub3Content: "Your images, prompts, and generated outputs are not used to train AI models for other users. We may use anonymized, aggregated usage statistics for platform improvement.",
      section8Sub4Title: "No automated decisions:",
      section8Sub4Content: "We do not use automated decision-making for decisions that produce legal or similarly significant effects on you. AI is used solely to generate content at your request.",
      section9Title: "9. International Data Transfers",
      section9Content: "TodoAI is operated from Israel. Your data is primarily processed in Israel, and may also be processed in other countries where our service providers and AI providers operate.\n\nIsrael has been recognized by the European Commission as providing adequate data protection (Decision 2011/61/EU). For transfers to countries without an adequacy decision, we rely on contractual safeguards as implemented by our service providers.",
      section10Title: "10. Children's Privacy",
      section10Content: "Our Service is intended for users who are at least 16 years old. We do not knowingly collect information from children under 16. If we discover we have collected such data, we will delete it promptly. Contact team@todowith.ai if you believe a child has provided us with personal information.",
      section11Title: "11. California Privacy Rights (CCPA/CPRA)",
      section11Content: "California residents have additional rights: the right to know what personal information we collect, the right to delete it, and the right to opt out of its sale. We do not sell personal information or share it for cross-context behavioral advertising. We will not discriminate against you for exercising these rights. Contact team@todowith.ai to exercise your California privacy rights.",
      section12Title: "12. Links to Other Sites",
      section12Content: "Our Service may contain links to third-party websites. We are not responsible for the privacy practices or content of those sites. We encourage you to review the privacy policies of any third-party sites you visit.",
      section13Title: "13. Email Communications",
      section13Content: "By signing up, you may receive marketing and promotional emails from us. You can unsubscribe at any time via the link in any email. Transactional emails (receipts, credit notifications, security alerts) will continue regardless.",
      section14Title: "14. Changes to This Policy",
      section14Content: "We may update this policy from time to time. We will notify you of significant changes via email or a notice on the Service. Continued use after changes constitutes acknowledgment of the updated policy.",
      section15Title: "15. Contact",
      section15Content: "Todo AI Technologies Ltd.\nRamat Gan, Israel\nWebsite: app.todowith.ai\nEmail: team@todowith.ai",
    },
    // Accessibility Statement
    accessibility: {
      title: "הצהרת נגישות",
      lastUpdated: "עודכן לאחרונה: פברואר 2026",
      section1Title: "1. מחויבות לנגישות",
      section1Content: "TodoAI מחויבת להנגיש את האתר והשירותים שלה לכלל האוכלוסייה, כולל אנשים עם מוגבלויות. אנו משקיעים משאבים רבים על מנת להבטיח שכל משתמש יוכל לגלוש באתר בצורה נוחה ושוויונית.",
      section2Title: "2. תקן הנגישות",
      section2Content: "אתר זה עומד בדרישות תקן ישראלי 5568 ובהנחיות הנגישות לתוכן אינטרנט WCAG 2.1 ברמה AA. התקן מגדיר כיצד להנגיש תכנים באינטרנט עבור אנשים עם מוגבלויות שונות.",
      section3Title: "3. תוסף נגישות",
      section3Content: "באתר מותקן תוסף נגישות (Enable) המאפשר התאמות נגישות מגוונות, כולל: שינוי גודל טקסט, ניגודיות צבעים, עצירת אנימציות, הדגשת קישורים, ועוד. ניתן לגשת לתוסף באמצעות סמל הנגישות המופיע באתר.",
      section4Title: "4. התאמות שבוצעו",
      section4Content: "במסגרת הנגשת האתר בוצעו, בין היתר, ההתאמות הבאות: מבנה כותרות היררכי וסמנטי, תיאורים חלופיים לתמונות, תמיכה בניווט מקלדת, התאמה לקוראי מסך, ניגודיות צבעים מספקת, ותמיכה בשינוי גודל טקסט.",
      section5Title: "5. מגבלות ידועות",
      section5Content: "למרות מאמצינו להנגיש את כל העמודים והתכנים באתר, ייתכן שחלק מהתכנים טרם הונגשו במלואם. בפרט, תמונות שנוצרות באמצעות בינה מלאכותית עשויות שלא לכלול תיאורים חלופיים מלאים. אנו ממשיכים לעבוד על שיפור הנגישות באופן שוטף.",
      section6Title: "6. דיווח על בעיות נגישות",
      section6Content: "אם נתקלת בבעיית נגישות באתר, נשמח לשמוע ממך. ניתן לפנות אלינו דרך דף יצירת הקשר באתר ולציין את הבעיה שנתקלת בה. אנו מתחייבים לטפל בפניות נגישות תוך 7 ימי עסקים.",
    },
    // Admin
    admin: {
      title: "ניהול",
      pricingTab: "תמחור",
      featureRequestsTab: "בקשות לפיצ'רים",
      totalRevenue: "הכנסות",
      totalCost: "עלות",
      overallMargin: "מרווח",
      totalGenerations: "יצירות",
      revenueVsCost: "הכנסות מול עלות (יומי)",
      marginByModel: "מרווח לפי מודל",
      revenue: "הכנסות",
      cost: "עלות",
      margin: "מרווח %",
      noData: "אין נתונים לתצוגה",
      last7Days: "7 ימים",
      last30Days: "30 ימים",
      last90Days: "90 ימים",
      dateRange: "טווח תאריכים",
      // Customers (per-user profitability) tab
      customersTab: "לקוחות",
      payingUsers: "משלמים",
      totalProfit: "רווח",
      avgProfit: "רווח ממוצע",
      providerCost: "עלות ספק",
      profitByCustomer: "רווח לפי לקוח",
      searchByEmail: "חיפוש לפי אימייל",
      exportCsv: "ייצוא CSV",
      colCustomer: "לקוח",
      colPlan: "תוכנית",
      colPaid: "שולם",
      colGenerations: "יצירות",
      colCreditsUsed: "קרדיטים",
      colProviderCost: "עלות ספק",
      colProfit: "רווח",
      colMargin: "מרווח %",
      noCustomers: "אין עדיין לקוחות משלמים",
      measuredCost: "נמדד",
    },
    // Onboarding Tour
    onboardingTour: {
      studioTabsTitle: "לשוניות הסטודיו",
      studioTabsContent: "בחרו בין יצירת תמונות וסרטונים, ובחרו את הכלי שלכם",
      sourceUploadTitle: "העלאת תמונה",
      sourceUploadContent: "העלו את התמונה שלכם כאן כדי להתחיל",
      promptAreaTitle: "אזור הפרומפט",
      promptAreaContent: "תארו מה תרצו לשנות",
      enhanceSuggestionsTitle: "שיפור והצעות",
      enhanceSuggestionsContent: "השתמשו בשיפור AI או בהצעות מהירות",
      generationBarTitle: "סרגל היצירה",
      generationBarContent: "התאימו מודל, יחס גובה-רוחב, רזולוציה וכמות",
      generateButtonTitle: "כפתור היצירה",
      generateButtonContent: "לחצו כאן ליצירה!",
      creationsGalleryTitle: "גלריית היצירות",
      creationsGalleryContent: "היצירות שלכם יופיעו כאן",
      next: "הבא",
      back: "הקודם",
      skip: "דלג",
      finish: "סיום",
      close: "סגור",
      nextLabelWithProgress: "הבא (שלב {step} מתוך {steps})",
      open: "פתח את הדיאלוג",
    },
    // SEO — per-route <title> + meta description. Keyed by `SeoKey` in
    // src/config/seo.ts. English is the indexed, prerendered version of the site.
    seo: {
      home: {
        title: "TodoAI Studio — סטודיו AI לייצור ויזואלי בעברית",
        description:
          "TodoAI Studio — סטודיו AI ישראלי ליצירת תמונות, סרטונים, Talking Avatars ותמונות מוצר. בעברית מלאה. התחילו חינם — 100 קרדיטים, ללא כרטיס אשראי.",
      },
      productCatalog: {
        title: "תמונות מוצר מקצועיות עם AI · TodoAI Studio",
        description:
          "TodoAI Studio — העלו תמונת מוצר אחת וקבלו 4 צילומי סטודיו מקצועיים ב-AI. ללא צלם או אולפן. מושלם לחנויות e-commerce ולמרקטפלייסים. בעברית, התחילו חינם.",
      },
      productCreative: {
        title: "ויזואל מוצר מקצועי בבינה מלאכותית · TodoAI",
        description:
          "הפכו תמונת מוצר לוויזואל פרסומי מקצועי עם AI — רקע נקי, אווירה קולנועית, בלי לכתוב פרומפט. מוכן לפרסום ולרשתות החברתיות.",
      },
      imageGenerator: {
        title: "יצירת תמונות AI מטקסט בעברית · TodoAI Studio",
        description:
          "TodoAI Studio — צרו תמונות מרהיבות מטקסט עם AI. עורך מובנה, איכות 4K, בלי סימני מים. תמיכה מלאה בעברית. לאומנים, יוצרי תוכן ועסקים קטנים. התחילו חינם.",
      },
      profilePhoto: {
        title: "תמונת פרופיל ותדמית מקצועית עם AI · TodoAI",
        description:
          "העלו סלפי וקבלו תמונת פרופיל מקצועית בסגנון לינקדאין, נוצרת בבינה מלאכותית. בוחרים סגנון ותסרוקת — מוכן בפחות מדקה.",
      },
      talkingAvatar: {
        title: "Talking Avatar בעברית — תמונה לסרטון מדבר · TodoAI Studio",
        description:
          "TodoAI Studio — הפכו תמונה אחת לסרטון Talking Avatar עם ליפסינק אוטומטי בעברית. כלי AI ישראלי לקריאייטורים ויוצרי תוכן. ראשון בעברית, התחילו חינם.",
      },
      baseballTrend: {
        title: "טרנד הבייסבול — סרטון ויראלי מתמונה · TodoAI",
        description:
          "העלו תמונה אחת והפכו לכוכבי הטרנד הוויראלי — סרטון קצר שבו המצלמה תופסת אתכם ביציע. נוצר בבינה מלאכותית בלחיצה.",
      },
      textToVideo: {
        title: "יצירת סרטון מטקסט עם בינה מלאכותית · TodoAI",
        description:
          "תארו סצנה בטקסט והבינה המלאכותית יוצרת סרטון. מודלי וידאו מובילים בלי הגדרות מסובכות — בעברית, בלחיצה אחת.",
      },
      framesToVideo: {
        title: "הנפשת תמונות — תמונה לסרטון עם AI · TodoAI",
        description:
          "הפכו תמונת סטילס לסרטון מונפש עם בינה מלאכותית. מעלים תמונה והמערכת מוסיפה תנועה חיה — מושלם למוצרים ולתוכן לרשתות.",
      },
      imageDirector: {
        title: "צ'אט במאי קריאייטיב — יצירה עם AI · TodoAI",
        description:
          "התייעצו עם במאי הקריאייטיב החכם של TodoAI בצ'אט, ותנו לבינה המלאכותית ליצור ולערוך תמונות לפי הרעיון שלכם.",
      },
      pricing: {
        title: "תמחור — תוכניות וקרדיטים · TodoAI Studio",
        description:
          "TodoAI Studio — תמחור פשוט בשקלים. מתחילים חינם עם 100 קרדיטים. תוכניות Starter (₪35), Pro (₪95) ו-Creator (₪190) לחודש. ביטול בכל עת, ללא כרטיס אשראי בתוכנית החינמית.",
      },
      help: {
        title: "מרכז עזרה ושאלות נפוצות · TodoAI",
        description:
          "תשובות לשאלות הנפוצות על TodoAI — איך מתחילים, אילו קבצים נתמכים, כמה זמן לוקחת יצירה, תמיכה בעברית ועוד.",
      },
      contact: {
        title: "יצירת קשר · TodoAI",
        description:
          "צריכים עזרה או רוצים לדבר איתנו? צרו קשר עם צוות TodoAI ונחזור אליכם בהקדם.",
      },
      terms: {
        title: "תנאי שימוש · TodoAI",
        description:
          "תנאי השימוש בפלטפורמת TodoAI ליצירת תמונות וסרטונים בבינה מלאכותית.",
      },
      privacy: {
        title: "מדיניות פרטיות · TodoAI",
        description:
          "כיצד TodoAI אוספת, משתמשת ומגנה על המידע שלכם בעת השימוש בפלטפורמה.",
      },
      accessibility: {
        title: "הצהרת נגישות · TodoAI",
        description:
          "הצהרת הנגישות של TodoAI והמחויבות שלנו להנגיש את הפלטפורמה לכל המשתמשים.",
      },
      // Comparison pages — Hebrew titles + descriptions. The page body is
      // currently English (matches the prerendered locale); when bilingual
      // prerender lands the body translation can follow.
      compareMidjourney: {
        title: "Midjourney מול TodoAI — איזה מחולל תמונות AI עדיף? | TodoAI",
        description:
          "השוואה מקיפה בין Midjourney ל-TodoAI ב-2026: מחיר, תמיכה בעברית, קלות שימוש, פלואים זמינים, ומי מנצח לכל שימוש. עודכן במאי 2026.",
      },
      compareHeygen: {
        title: "HeyGen מול TodoAI Talking Avatar — השוואה | TodoAI",
        description:
          "השוואה צד-לצד בין HeyGen ל-Talking Avatar של TodoAI: מחיר, lip-sync בעברית, קלות שימוש, ולמי כדאי כל אחד. עודכן במאי 2026.",
      },
      compareKling: {
        title: "Kling AI מול TodoAI Text-to-Video — מי עדיף? | TodoAI",
        description:
          "השוואה בין Kling AI ל-Text-to-Video של TodoAI ב-2026: תמיכה בעברית, מחיר בשקלים, קלות שימוש, ולמי כדאי. עודכן במאי 2026.",
      },
    },
    // Referral program
    referral: {
      landingTitle: "{name} הזמין אתכם ל-Todo AI",
      landingTitleGeneric: "הוזמנתם ל-Todo AI",
      landingSubtitle: "צרו תמונות וסרטוני AI מרהיבים תוך שניות. הירשמו לחבילה בתשלום ואתם והחבר שלכם תקבלו קרדיטים בונוס כל אחד.",
      landingBadge: "הירשמו לחבילה בתשלום ← שניכם תקבלו {credits} קרדיטים בונוס",
      landingCta: "הרשמה כדי להתחיל",
      landingAlreadyMember: "אתם כבר חברים שלנו 🙂",
      landingAlreadyMemberCta: "להזמנת חברים",
      cardTitle: "הזמינו חברים — שניכם מרוויחים {refereeCredits} קרדיטים",
      cardSubtitle: "כשחבר נרשם לחבילה בתשלום, כל אחד מכם מקבל קרדיטים בונוס — {refereeCredits} עבורו, {referrerCredits} עבורכם.",
      cardLinkLabel: "קישור ההזמנה שלכם",
      copy: "העתקה",
      copied: "הקישור הועתק!",
      shareWhatsapp: "שיתוף בוואטסאפ",
      share: "שיתוף",
      statsJoined: "נרשמו",
      statsSubscribed: "מנויים",
      statsEarned: "קרדיטים שהרווחתם",
      cardEmpty: "עדיין אין הזמנות. שתפו את הקישור כדי להתחיל להרוויח.",
      shareMessage: "אני יוצר תמונות וסרטוני AI עם Todo AI. הצטרפו עם הקישור שלי — הירשמו לחבילה בתשלום וכל אחד מאיתנו יקבל {credits} קרדיטים בונוס: {link}",
      bonusToast: "🎁 {name} הזמין אתכם! הירשמו לחבילה בתשלום ושניכם תקבלו {credits} קרדיטים בונוס.",
      bonusToastGeneric: "🎁 הוזמנתם! הירשמו לחבילה בתשלום כדי לקבל {credits} קרדיטים בונוס.",
      earnedToast: "🎉 חבר שהזמנתם הפך למנוי! הרווחתם {credits} קרדיטים.",
      refereeRewardToast: "🎉 בונוס הצטרפות! הרווחתם {credits} קרדיטים מהזמנת חבר.",
      subscribeBannerText: "🎁 הירשמו לכל חבילה בתשלום ואתם ו-{name} תקבלו {credits} קרדיטים בונוס כל אחד.",
      subscribeBannerTextGeneric: "🎁 הירשמו לכל חבילה בתשלום ואתם והחבר שלכם תקבלו {credits} קרדיטים בונוס כל אחד.",
      loadError: "לא הצלחנו לטעון את נתוני ההזמנות. נסו שוב.",
      retry: "נסו שוב",
    },
    featureRequest: {
      dialogTitle: "יש לכם רעיון?",
      dialogDescription: "אנחנו קוראים כל רעיון. הרעיון הראשון שלכם מזכה אתכם ב{count} קרדיטים חינם.",
      titleLabel: "כותרת",
      titlePlaceholder: "במשפט אחד, מה הייתם רוצים להוסיף?",
      descriptionLabel: "ספרו לנו עוד",
      descriptionPlaceholder: "איך זה היה אמור לעבוד? באיזה זרימה? למה זה היה עוזר לכם?",
      categoryLabel: "קטגוריה",
      phoneLabel: "טלפון (אופציונלי)",
      phonePlaceholder: "",
      category: {
        newFlow: "פיצ'ר חדש",
        improveFlow: "שיפור פיצ'ר קיים",
        pricing: "מחירים",
        account: "חשבון / פרופיל",
        other: "אחר",
      },
      notifyOnShip: "שלחו לי מייל כשהפיצ'ר ייצא לאוויר",
      submit: "שליחת הרעיון",
      submitting: "שולחים...",
      submitSuccess: "תודה! קיבלנו את הרעיון.",
      submitSuccessWithCredits: "תודה! חשבונכם מזוכה ב+{count} קרדיטים.",
      submitError: "לא הצלחנו לשלוח את הרעיון. נסו שוב.",
      descriptionMinHint: "צריך לפחות {min} תווים",
      validation: {
        titleTooShort: "הוסיפו כותרת קצרה (לפחות {min} תווים).",
        descriptionTooShort: "ספרו לנו עוד קצת, לפחות {min} תווים.",
      },
      status: {
        new: "חדש",
        underReview: "בבחינה",
        planned: "מתוכנן",
        inProgress: "בעבודה",
        shipped: "יצא לאוויר",
        declined: "נדחה",
      },
      profileCard: {
        heading: "יש לכם רעיון?",
        subtitle: "מה תרצו שנוסיף? הרעיון הראשון מזכה ב+{count} קרדיטים.",
        cta: "הציעו רעיון",
        yourIdeasTitle: "הרעיונות שלכם",
        empty: "עוד לא שלחתם רעיונות.",
        loadError: "לא הצלחנו לטעון את הרעיונות שלכם.",
      },
      postGen: {
        prompt: "רוצים שהפיצ'ר יעשה משהו אחר?",
        cta: "ספרו לנו",
        dismiss: "סגירה",
      },
      galleryBadge: {
        cta: "הציעו רעיון",
      },
      admin: {
        title: "בקשות לפיצ'רים",
        empty: "אין בקשות לפיצ'רים.",
        filterLabel: "סינון לפי סטטוס",
        filterAll: "הכל",
        colUser: "משתמש",
        colTitle: "כותרת",
        colCategory: "קטגוריה",
        colStatus: "סטטוס",
        colSource: "מקור",
        colCreatedAt: "נשלח",
        adminNotesLabel: "הערות מנהל",
        adminNotesPlaceholder: "הערה פנימית (לא נשלחת למשתמש)",
        save: "שמירה",
        saving: "שומרים...",
        saved: "נשמר",
        saveError: "השמירה נכשלה",
        loadError: "לא הצלחנו לטעון את הבקשות.",
      },
    },
  },
  en: {
    // Navbar
    nav: {
      explore: "Explore Community",
      pricing: "Pricing",
      aboutUs: "About Us",
      gallery: "My Gallery",
      login: "Login",
      signup: "Sign Up",
      tryFree: "Try Free",
      logout: "Logout",
      logoutSuccess: "Logged out successfully",
      myProfile: "My Profile",
      upgradePlan: "Upgrade Plan",
      managePlan: "Manage Plan",
      createNow: "Create Now",
      createNowFree: "Start now for free",
      startNow: "Start Now",
      profile: "Profile",
      selectLanguage: "Select Language",
      credits: "Credits",
      remaining: "remaining",
      plan: "Plan",
      defaultUser: "User",
      menu: "Menu",
      lightMode: "Light Mode",
      darkMode: "Dark Mode",
      admin: "Admin",
      inviteFriends: "Invite a friend",
      myBot: "My Bot",
      betaSection: "B2B",
      devEnvironment: "Development Environment",
      devModelsLabel: "Models",
      devModelsCheap: "Cheap",
      devModelsNormal: "Normal",
    },
    // Landing Page
    landing: {
      // Hero
      heroTagline: "Imagine It. Create It. Share It.",
      heroTitle: "AI Art Generator",
      heroSubtitle: "The fastest way to turn any idea into stunning images, videos, and animations. No skills needed.",
      startFree: "Start Creating for Free",
      seeHowItWorks: "See How It Works",
      heroBadge: "100 Free Credits, No Card Needed",
      heroMicrocopyCredits: "100 free credits",
      heroMicrocopyNoCard: "No credit card required",
      // Trust Badges
      trustBadgeNoWatermarks: "No Watermarks",
      trustBadge4K: "Up to 4K Quality",
      trustBadgeCommercial: "Full Commercial Rights",
      trustBadgeSpeed: "Under 60 Seconds",
      // Hero title split (accent word rendered in brand gradient)
      heroTitlePrefix: "Your ",
      heroTitleAccent: "Creative",
      heroTitleSuffix: " Studio",
      // Hero scroll cue
      heroScrollHint: "Explore the tools",
      // Social proof strip (numbers live in constants; only labels are translated)
      socialImagesLabel: "Images Created",
      socialCreatorsLabel: "Active Creators",
      socialSpeedLabel: "Avg. Generation",
      // Section eyebrows (small uppercase label above each H2)
      eyebrowProcess: "The Process",
      eyebrowTestimonials: "Testimonials",
      eyebrowPricing: "Pricing",
      eyebrowFaq: "FAQ",
      // How It Works
      howItWorksTitle: "How It Works",
      howItWorksSubtitle:
        "We built an innovative platform powered by the world's most advanced AI tools, to give you a simple, one-of-a-kind experience and true studio-grade results. Instead of spending money on photographers, expensive equipment and endless hours, you get everything in one click and at an accessible price. Don't fall behind. Start creating today!",
      // Testimonials / Social Proof
      testimonialsTitle: "They're Already Creating with TodoAI",
      testimonialsSubtitle: "Join 1,000+ people and businesses that already upgraded their visuals",
      testimonial1Quote: "I didn't think it would actually work, but the first images I made for my store blew me away. Now I don't list a product without it.",
      testimonial1Name: "Michelle K.",
      testimonial1Role: "Online Store Owner",
      testimonial2Quote: "A friend sent me a link and said 'just try it.' Now I use it for everything - posts, gifts, greeting cards. It's addictive honestly.",
      testimonial2Name: "Ori S.",
      testimonial2Role: "Content Creator",
      testimonial3Quote: "I post stories for my studio almost every day. It used to take me at least an hour, now it's a matter of minutes.",
      testimonial3Name: "Noa D.",
      testimonial3Role: "Yoga Studio Owner",
      testimonial4Quote: "I uploaded a photo of our pizza and got back an ad image that looked like a pro photographer shot it. Customers thought we hired an agency.",
      testimonial4Name: "Danny R.",
      testimonial4Role: "Restaurant Manager",
      testimonial5Quote: "I had this idea for my wedding invitation but zero design skills. After a few tries I got exactly what I had in mind. So glad I found this.",
      testimonial5Name: "Ronit A.",
      testimonial5Role: "Personal User",
      testimonial6Quote: "We have hundreds of products and photographing each one is a whole thing. Now we upload a simple photo and get a full catalog. Saves us a ton.",
      testimonial6Name: "Yossi M.",
      testimonial6Role: "Furniture Store Owner",
      // Community Gallery
      galleryTitle: "Created with TodoAI",
      gallerySubtitle: "Real results from real users",
      galleryCta: "Explore the Full Gallery",
      galleryEmpty: "No community creations available yet.",
      galleryImageAlt: "Community creation",
      // Pricing Preview
      pricingTitle: "Simple, Transparent Pricing",
      pricingSubtitle: "Start free. Upgrade when you're ready.",
      pricingFreeHighlight: "100 free credits, no credit card required",
      pricingFreeLabel: "Free",
      pricingTokens: "tokens",
      pricingMonth: "/month",
      pricingCompareAll: "Compare all plans",
      pricingFreeCta: "Start Free",
      pricingPaidCta: "Choose Plan",
      // FAQ
      faqTitle: "Questions? We've Got Answers.",
      faq1Q: "I'm not a designer or tech person. Can I really use this?",
      faq1A: "Absolutely. Upload a photo, and the AI does the creative work. No design software, no complicated settings, no learning curve. If you can attach a photo to a message, you can use TodoAI.",
      faq2Q: "What's the catch with the free plan?",
      faq2A: "No catch. You get 100 tokens, access to all features, all AI models, 4K quality, and zero watermarks. No credit card needed to start. We want you to try it and see the results for yourself before you decide to pay.",
      faq3Q: "What can I create with TodoAI?",
      faq3A: "Almost anything visual! Generate images from text descriptions, turn photos into videos, animate still images, create product photography, and explore creative ideas with our AI chat. Whether it's social media content, personal art, or business visuals, we've got you covered.",
      faq4Q: "Can I use what I create commercially?",
      faq4A: "100%. Everything you create with TodoAI is yours. Full commercial rights. Use it on social media, in ads, on your website, in print, or anywhere else you need it.",
      faq5Q: "Am I locked into a contract? Can I cancel anytime?",
      faq5A: "No contracts, no commitments. You can cancel your subscription anytime with one click, and you'll keep access until the end of your billing period. The free plan doesn't even require a credit card.",
      // Final CTA
      finalCtaTitle: "Your First Creation Is on Us.",
      finalCtaSubtitle: "Free to start. No credit card. No experience required.",
      finalCtaButton: "Start Creating for Free",
      finalCtaTrust: "100 free credits included. Cancel anytime.",
    },
    // Footer
    footer: {
      description: "Create stunning images, videos, and animations with AI. TodoAI is the fastest way to bring your ideas to life. No design skills needed.",
      create: "Create",
      images: "Images",
      imageGenerator: "Image Generator",
      adsCreator: "Product Studio",
      imageDirector: "Image Director",
      profilePhoto: "Profile Photo",
      productCreative: "Product Creative",
      videos: "Videos",
      framesToVideo: "Frames to Video",
      textToVideo: "Text to Video",
      talkingAvatar: "Talking Avatar",
      discover: "Discover",
      explore: "Explore Community",
      pricing: "Pricing",
      contact: "Contact",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      accessibility: "Accessibility Statement",
      support: "Support",
      help: "Help",
      suggestFeature: "Suggest a feature",
      copyright: "© 2026 TodoAI Technologies Inc.",
      manageCookies: "Manage Cookies",
      agencyCta: "Need AI lectures, workshops or custom automation for your business? Visit TodoAI",
    },
    // Cookie Consent
    cookieConsent: {
      bannerTitle: "We use cookies",
      bannerDescription: "We use cookies to improve your experience and analyze site usage. You can choose which cookies to allow.",
      acceptAll: "Accept All",
      rejectAll: "Reject All",
      customize: "Customize",
      learnMore: "Privacy Policy",
      preferenceCenterTitle: "Cookie Settings",
      preferenceCenterDescription: "Choose which cookies you want to allow. Essential cookies are required for the site to function and cannot be disabled.",
      essentialTitle: "Essential Cookies",
      essentialDescription: "Required for the site to function — authentication, session management, and language preferences.",
      essentialBadge: "Required",
      analyticsTitle: "Analytics Cookies",
      analyticsDescription: "Help us understand how visitors use the site, including page views, feature usage, and performance analysis.",
      savePreferences: "Save Preferences",
      cancel: "Cancel",
    },
    // Sidebar
    sidebar: {
      overview: "Overview",
      creativeStudio: "Creative Studio",
      upgradePlan: "Upgrade Plan",
      supportInfo: "Support & Info",
      helpCenter: "Help Center",
      apiDocs: "API Docs",
    },
    // Generate Page
    generate: {
      title: "Creative Studio",
      createImage: "Create Image",
      editImage: "Edit Image",
      createVideo: "Create Video",
      uploadImage: "Upload Image",
      uploadImageDesc: "Drag here or click to select file",
      supportedFormats: "PNG, JPG, WEBP up to 10MB",
      changeImage: "Change Image",
      prompt: "Prompt",
      promptPlaceholder: "Describe the visual you want to create...",
      customizePrompt: "Customize",
      autoPromptTitle: "No need to write a prompt",
      autoPromptSubtitle: "We'll handle the magic — just upload your product photo",
      aspectRatio: "Aspect Ratio",
      resolution: "Resolution",
      createAd: "Create Ad",
      generatedImages: "Generated Images",
      clickToOpen: "Click to open",
      uploadRequired: "Image Required",
      uploadRequiredDesc: "Please upload the desired image to the designated area",
      imagesReady: "Images Ready! 🎉",
      imagesReadyDesc: "4 new images added to your gallery",
      noCredits: "Out of Credits",
      sound: "Sound",
      firstFrame: "First Frame",
      endFrame: "Last Frame",
      videoModel: "Video Model",
      uploadFirstFrame: "Upload First Frame",
      uploadEndFrame: "Upload End Frame",
      uploadSingleImage: "Upload Image",
      createVideoBtn: "Create Video",
      videoReady: "Video Ready! 🎉",
      videoReadyDesc: "Video added to your gallery",
      // Additional keys for Generate page
      creativeStudio: "Creative Studio",
      newAdCreation: "New ad creation",
      upgradePlan: "Upgrade Plan",
      imagesTab: "Images",
      editTab: "Edit",
      videosTab: "Videos",
      marketingStudioTab: "Marketing Studio",
      trendsTab: "Trends",
      dragImageHere: "Drag image here",
      dragOrClick: "Drag image here or click to upload",
      dragOrClickShort: "Drag or click",
      upTo10mb: "up to 10MB",
      yourCreations: "Your Creations",
      yourVideos: "Your Videos",
      processing: "Processing...",
      creatingVideo: "Creating video...",
      allReadyTitle: "All set!",
      allReadyHint: "Hit the button to start creating",
      selectStyle: "🎨 Select Style",
      flowlyMagic: "TodoAI is creating magic...",
      aiProcessing: "Our AI is processing 4 different variations for you.",
      generatedImagesTitle: "📸 Generated Images",
      clickCreateAd: "Click \"Create Ad\" to generate images",
      selectModel: "Select model:",
      framesToVideo: "Frames to Video",
      textToVideo: "Text to Video",
      talkingAvatar: "Talking Avatar",
      imageGeneratorDesc: "Create images from text prompts",
      adsCreatorDesc: "Product photos to pro visuals",
      imageDirectorDesc: "Refine images through chat",
      profilePhotoDesc: "Professional headshots for your profile",
      productCreativeDesc: "Our system creates the visual for your product — no prompt-writing needed",
      framesToVideoDesc: "Animate between key frames",
      textToVideoDesc: "Describe a scene, get a video",
      talkingAvatarDesc: "From one photo — a video of a talking character",
      baseballTrendDesc: "One photo → a viral live-broadcast video",
      noModelsAvailable: "No models available",
      bestModelForFlow: "Best model for this flow",
      firstFrameLabel: "First Frame",
      endFrameLabel: "End Frame",
      endFrameOptional: "End Frame (optional)",
      sourceImage: "Source Image",
      uploadForAnimation: "Upload image for video animation",
      soundEnabled: "SOUND enabled",
      addSound: "Add SOUND",
      soundAlwaysOn: "SOUND included",
      animationInstructions: "Animation Instructions",
      model: "model",
      describeMotion: "Describe the desired motion",
      enhancePrompt: "Enhance Prompt",
      videoPromptPlaceholder: "e.g.: Product rotates slowly, smooth zoom in, sparkling particles in background...",
      rotate360: "🔄 360° rotation",
      slowZoomIn: "🔍 Slow zoom in",
      dynamicBackground: "🌊 Dynamic background",
      sparklingParticles: "✨ Sparkling particles",
      waveEffect: "〰️ Wave effect",
      cinematicMotion: "🎬 Cinematic motion",
      creatingVideoTitle: "Creating video...",
      modelProcessing: "processing the image",
      video: "Video",
      imageSelected: "Image selected",
      change: "Change",
      insertImageHint: "Please insert an image in the designated area",
      fiveSeconds: "5s",
      tenSeconds: "10s",
      fourSeconds: "4s",
      eightSeconds: "8s",
      twelveSeconds: "12s",
      soraPromptPlaceholder: "Describe the video you want to create in detail",
      backgroundColor: "Background Color",
      darkGray: "Dark Gray",
      white: "White",
      auto: "Auto",
      animateBetweenFrames: "Animate between images",
      fastAnimationPlaceholder: "Fast animation from first frame to last frame",
      generationFailed: "Image Generation Failed",
      generationFailedDesc: "An error occurred while generating images. Please try again.",
      failedRefunded: "Failed - Refunded",
      generationFailedWithRefund: "Generation failed. Credits refunded.",
      generationInProgress: "Generation in progress",
      parallelProRequired: "Parallel generation is available on the PRO plan",
      progressPreparing: "Preparing...",
      progressGenerating: "Generating...",
      progressEnhancing: "Enhancing...",
      progressAlmostReady: "Almost ready...",
      progressDone: "Done!",
      previewInProgress: "In production, please wait",
      contentFlagged: "Content flagged",
      contentFlaggedDesc: "Your content was flagged by the model's safety filter. Your credits have been refunded.",
      staleGenerationCleaned: "Some generations timed out and were marked as failed",
      promptImproved: "Prompt improved!",
      promptImprovedDesc: "The prompt has been expanded and made more professional",
      enhanceFailed: "Enhancement failed",
      tryAgain: "Please try again",
      enhanceError: "An error occurred improving the prompt",
      improving: "Improving...",
      recommended: "Recommended",
      new: "New",
      animateBetweenImages: "🔀 Animate between images",
      creationInstructions: "Creation Instructions",
      noCreationsYet: "No creations yet",
      startCreating: "Upload an image and start creating",
      noVideosYet: "No videos yet",
      startCreatingVideos: "Upload an image and start creating videos",
      modelHighDemand: "This model is experiencing high demand. Generation may take longer or temporarily fail, credits will be refunded",
      quantity: "Quantity",
      swapFrames: "Swap frames",
      selectProvider: "Select provider",
      providerOpenAI: "OpenAI",
      providerGemini: "Google Gemini",
      providerKling: "Kling AI",
      providerSora: "Sora (OpenAI)",
      providerBFL: "FLUX",
      perImage: "per image",
      perVideo: "per video",
    },
    // Image Generator Page
    imageGenerator: {
      title: "Image Generator",
      editPromptPlaceholder: "Describe the image you want to generate...",
      editImage: "Generate Image",
      editedImages: "Generated Images",
      imageReady: "Image Ready! 🎉",
      imageReadyDesc: "Generated image added to your gallery",
      originalImage: "Source Image",
      uploadForEdit: "Upload source image",
      replace: "Replace",
      uploadImage: "Upload Image",
      uploadWithAI: "Upload image for AI generation",
      editResults: "Generation Results",
      editInstructions: "Generation Instructions",
      whatToChange: "What would you like to generate?",
      promptPlaceholder: "e.g.: Change background to beach, add sunset, make retro style...",
      improvePrompt: "Improve prompt",
      improving: "Improving...",
      promptImproved: "Prompt improved!",
      promptImprovedDesc: "The prompt has been expanded and made more professional",
      enhanceFailed: "Enhancement failed",
      tryAgain: "Please try again",
      enhanceError: "An error occurred improving the prompt",
      enterEditInstructions: "Please enter generation instructions",
      enterEditInstructionsDesc: "Tell us what you want to generate",
      pleaseUploadImage: "Please upload an image",
      pleaseUploadImageDesc: "Upload a source image",
      editCompleted: "Generation completed!",
      editCompletedDesc: "Your image has been generated",
      editFailed: "Generation failed",
      editFailedDesc: "An error occurred while generating the image",
      processingImage: "Generating image...",
      aiEditing: "Our AI is generating the image according to your instructions",
      download: "Download",
      moreEditing: "Generate more",
      editingImage: "Generating image...",
      quickStudioBg: "🎨 Studio background",
      quickDramaticLight: "💡 Dramatic lighting",
      quickMinimalist: "✨ Minimalist style",
      quickBlackWhite: "🖤 Black & white",
      quickShadows: "🌑 Add shadows",
      yourCreations: "Your Creations",
      clickToOpen: "Click to open",
      editImageBtn: "Generate Image",
      noEditsYet: "No edits yet",
      startEditing: "Upload an image and start editing",
      referenceImages: "Reference Images",
      addReferenceHint: "Add style or context images (optional)",
    },
    // Profile Photo Page
    profilePhoto: {
      title: "Profile Photo",
      subtitle: "Get LinkedIn-style headshots from your face",
      heroBadge: "AI Headshot Generator",
      heroTitle: "Professional headshots in one click",
      heroSubtitle: "Upload your photos, pick a style, and get LinkedIn-grade portraits made just for you.",
      heroUploadTitle: "Drop photos here or click to upload",
      heroUploadHint: "2–3 face photos from different angles for best results",
      uploadFormats: "JPG, PNG · up to 10MB each",
      beforeLabel: "Before",
      afterLabel: "After",
      afterPlaceholder: "Your Photo",
      createNowCta: "Create now",
      guideModalTitle: "One quick tip",
      guideModalBody:
        "Make sure you uploaded a clear, good-quality photo where your face is plainly visible, facing the camera up close — the photo directly affects the quality of the result.",
      guideImageCaption: "Shoot it like this",
      guideModalCta: "Got it",
      genderQuestion: "Step 2 · Pick your gender",
      genderMale: "Male",
      genderFemale: "Female",
      pickPreset: "Step 3 · Pick a style",
      pickPresetHint: "Each style creates a different look and outfit — tap to select",
      uploadTitle: "Step 1 · Upload 2–3 face photos",
      uploadHint: "For best results, upload 3 photos from different angles",
      minUploadsHint: "Add 1 more photo — at least 2 are required to create.",
      uploadAdd: "Add photo",
      removePhoto: "Remove",
      generateBtn: "Create headshots",
      generating: "Creating...",
      missingGender: "Pick a gender",
      missingPreset: "Pick a style",
      missingUpload: "Upload at least 2 photos",
      results: "Your results",
      noResults: "Tap 'Create' to get fresh headshots",
      generationFailed: "Generation failed",
      generationFailedDesc: "Something went wrong. Your credits were refunded automatically.",
      invalidImage: "We couldn't read this photo. Please try a clear JPG or PNG under 10 MB.",
      linkCopied: "Link copied",
      downloadAria: "Download",
      hairPickerTitle: "Step 4 · Hairstyle",
      hairPickerHint: "By default we keep your hair as in the photo. You can also describe a new style.",
      hairKeepTitle: "Keep my hair as in the photo",
      hairKeepSubtitle: "No change to color, length or styling",
      hairDescribeTitle: "Describe a new hairstyle",
      hairDescribeSubtitle: "Must still resemble the reference",
      hairDescriptionLabel: "Hairstyle description",
      hairDescriptionPlaceholder: "Example: low ponytail with front bangs",
      customCardSubtitle: "Design your own",
      customTitle: "Design your own style",
      customExplanation:
        "Pick your own background and outfit — they're woven straight into your generated photo.",
      customBackgroundLabel: "Background",
      customBackgroundPlaceholder: "e.g. soft grey studio backdrop",
      customClothingLabel: "Clothing style",
      customClothingPlaceholder: "e.g. navy blazer with a white shirt",
      customChipsHint: "Or pick a quick suggestion:",
      customBackgroundChips: [
        "Soft grey studio backdrop",
        "Blurred modern office",
        "Clean white background",
        "Dark grey gradient",
        "Warm beige wall",
      ],
      customClothingChips: [
        "Navy suit with a tie",
        "Smart blazer over a white shirt",
        "Dark knit sweater",
        "Classic black suit",
        "Clean polo shirt",
      ],
      customContinue: "Continue",
      presets: {
        customStyle: "Custom",
        maleCorporateSuit: "Corporate Suit",
        maleBusinessCasual: "Business Casual",
        maleTechStartup: "Tech Startup",
        maleClassicPortrait: "Classic Portrait",
        femaleCorporateSuit: "Corporate Suit",
        femaleBusinessCasual: "Business Casual",
        femaleTechStartup: "Tech Startup",
        femaleClassicPortrait: "Classic Portrait",
      },
    },
    landingFlows: {
      title: "Pick a flow and start now",
      imagesSectionTitle: "Studio Photos",
      videosSectionTitle: "Videos & animations in one click",
      beforeLabel: "Before",
      afterLabel: "After",
      tryCta: "Try now",
      flows: {
        profilePhoto: {
          name: "Profile Photo",
          description: "A LinkedIn-grade portrait of you, generated in one click",
        },
        productStudio: {
          name: "Product Studio",
          description: "4 studio-grade product shots with clean backgrounds, from one photo",
        },
        productCreative: {
          name: "Product Creative",
          description: "A finished campaign with a clean backdrop and dynamic elements around the product",
        },
        baseballTrend: {
          name: "Baseball Trend",
          description: "One photo → a viral \"caught on live TV\" stadium video",
        },
        talkingAvatar: {
          name: "Talking Avatar",
          description: "Turn one photo into a talking-avatar video with auto lip-sync",
        },
      },
    },
    productCreative: {
      title: "Product Creative",
      subtitle: "Let our system craft the visual for your product — no prompt required",
      heroTitle: "A polished visual for your product — in one click",
      heroSubtitle: "Upload your product and our system crafts the visual for you — no prompt-writing, no setup. Clean backdrop, dynamic elements, cinematic mood.",
      heroUploadTitle: "Drop your product photo here or click to upload",
      heroUploadHint: "1–3 photos of the same product for best results",
      uploadFormats: "JPG, PNG · up to 10MB each",
      beforeLabel: "Your Product",
      afterLabel: "The Creative",
      afterPlaceholder: "Your Photo",
      createNowCta: "Create now",
      firstUploadTipTitle: "Tip for the best result",
      firstUploadTipDesc: "Upload a clean, well-lit photo of the product. The sharper the product, the better the creative.",
      uploadTitle: "Step 1 · Upload 1–3 product photos",
      uploadHint: "For best results, upload photos from different angles",
      uploadAdd: "Add photo",
      removePhoto: "Remove",
      stylePickerTitle: "Step 2 · Pick a creative style",
      stylePickerHint: "Let the system decide, or describe it yourself",
      styleAutoTitle: "Let the system decide",
      styleAutoSubtitle: "We'll choose the background and the elements that match your product best",
      styleManualTitle: "Describe it yourself",
      styleManualSubtitle: "Write what you want in the background and what should fly around the product",
      customDirectionLabel: "Background & elements description",
      customDirectionPlaceholder: "Example: blue ocean background with seashells, seaweed and water droplets flying around the bottle",
      generateBtn: "Create creative",
      generating: "Creating...",
      results: "Your creatives",
      noResults: "Tap 'Create' to generate new creatives",
      generationFailed: "Generation failed",
      generationFailedDesc: "Something went wrong. Your credits were refunded automatically.",
      linkCopied: "Link copied",
      downloadAria: "Download",
    },
    talkingAvatar: {
      title: "Talking Avatar",
      subtitle: "From one photo to a video of a talking character — in the style you choose",
      heroTitle: "Turn a photo into a talking video",
      heroSubtitle: "Upload a photo of a person or an object, pick a style, write what they'll say — and the system creates a lip-synced talking video.",
      heroUploadTitle: "Drop a photo here or click to upload",
      heroUploadHint: "A clear photo of a person or object — one is enough",
      uploadFormats: "JPG, PNG · up to 10MB",
      beforeLabel: "Photo",
      afterLabel: "Video",
      afterPlaceholder: "Your Video",
      createNowCta: "Create now",
      stepPrefix: "Step {n} · ",
      guideModalTitle: "One quick tip",
      guideModalBody: "Upload a clear photo with the character close to the camera — eyes and mouth visible. That's how lip-sync comes out best; a far-away shot works worse. Person, animal or cartoon — all work.",
      guideImageCaption: "It should look like this",
      guideModalCta: "Got it",
      imageModeTitle: "Step 2 · Which image will do the talking?",
      imageModeHint: "Use your uploaded photo exactly as it is, or let AI design a new image from it",
      imageModeSourceTitle: "My uploaded photo",
      imageModeSourceSubtitle: "Skip straight to choosing what the character says — no redesign",
      imageModeGenerateTitle: "A new styled image",
      imageModeGenerateSubtitle: "Pick a style and background, AI creates a fresh version — then it talks",
      stylePickerTitle: "Pick a style",
      stylePickerHint: "Realistic preserves the original look; cartoon turns it into a stylized 3D scene",
      styleRealisticTitle: "Realistic",
      styleRealisticSubtitle: "Stays true to the source photo",
      styleCartoonTitle: "Cartoon (Pixar)",
      styleCartoonSubtitle: "Stylized 3D look",
      backgroundStepTitle: "Background & composition",
      backgroundStepHint: "This text shapes the preview image — the background, environment and composition.",
      backgroundPresetsLabel: "Quick descriptions",
      backgroundPresetOfficeLabel: "Office background",
      backgroundPresetOfficeText: "Modern office background, large windows, natural light",
      backgroundPresetForestLabel: "Forest background",
      backgroundPresetForestText: "Forest background with green trees and soft sunlight",
      backgroundPresetHomeLabel: "Home background",
      backgroundPresetHomeText: "Designed home background, warm living room with pleasant light",
      backgroundPresetKitchenLabel: "Kitchen background",
      backgroundPresetKitchenText: "Modern kitchen background with natural light",
      previewHistoryTitle: "Your past previews",
      previewHistoryHint: "Pick a previously generated preview to render it into a clip",
      previewHistoryShowMore: "Show more",
      previewHistoryDialogTitle: "Avatar preview history",
      createCharactersCta: "Create 2 characters",
      advancedToggleShow: "Advanced instructions",
      advancedToggleHide: "Hide advanced instructions",
      advancedCompositionLabel: "Composition (pose, props, framing)",
      advancedCompositionPlaceholder: "e.g. sitting on an office chair, holding a coffee cup, framed from the waist up",
      advancedCompositionHint: "Describe pose (sitting/standing), props (what they hold), camera angle — all of it feeds into the prompt.",
      sourcePhotoLabel: "Your source photo",
      replaceImageCta: "Replace photo",
      previewPickerTitle: "Pick one to work with",
      previewPickerHint: "Create 2 characters and pick your favorite — it'll be turned into a talking clip",
      previewRegenerateCta: "Generate 2 more",
      previewGenerating: "Generating 2 images...",
      previewFailedDesc: "Something went wrong while generating images. Your credits were refunded.",
      previewDownloadAria: "Download image",
      dialogueTitle: "What will the character say?",
      dialogueHint: "Up to 60 words. The text will be turned into speech with lip-sync.",
      dialogueLabel: "Dialogue text",
      dialoguePlaceholder: "Hi, I'm your new product — we're about to change the game.",
      motionToggleShow: "Motion / action (optional)",
      motionToggleHide: "Hide motion / action",
      motionLabel: "Describe the motion while speaking",
      motionPlaceholder: "e.g. waves hello, smiles warmly, tilts head slightly",
      motionHint: "Describe gestures, movement or expressions the character performs while speaking. The face stays toward the camera for lip-sync.",
      backgroundLabel: "Background description",
      backgroundPlaceholder: "Clean white studio with soft lighting",
      wordCountLabel: "{count} / {max} words",
      minWordsHint: "Add at least {min} words so there's enough audio for lip-sync.",
      voicePickerTitle: "Pick a voice",
      voicePickerHint: "All voices also support Hebrew",
      voicesLoading: "Loading voices...",
      voiceLanguageEn: "English",
      voiceLanguageHe: "Hebrew",
      voiceLanguageMulti: "Multilingual",
      voiceGenderMale: "Male",
      voiceGenderFemale: "Female",
      voices: {
        rachel: "Rachel",
        domi: "Domi",
        antoni: "Antoni",
        josh: "Josh",
        sarah: "Sarah",
        george: "George",
        bella: "Bella",
        jessica: "Jessica",
        brian: "Brian",
        liam: "Liam",
        stevie: "Stevie",
        gappu: "Gappu",
        littleDude: "Little Dude",
        minnie: "Minnie",
        miffy: "Miffy",
      },
      voiceCategories: {
        sarah: "Explainers & presentations",
        bella: "Stories & calm content",
        jessica: "Marketing & social",
        george: "Narration & storytelling",
        brian: "Narration & ads",
        liam: "Dynamic, energetic content",
        stevie: "Energetic cartoon character",
        gappu: "Funny kids character",
        littleDude: "Cool cartoon character",
        minnie: "Sharp cartoon character",
        miffy: "Bouncy cartoon character",
      },
      voiceFilterToggle: "Categories",
      voiceFilterAll: "All",
      voiceMoreAria: "More voices",
      voiceCategoryNames: {
        narration: "Narration & stories",
        marketing: "Marketing & ads",
        cartoon: "Cartoon characters",
      },
      previewPlayAria: "Play sample",
      cloneVoiceCta: "Create your own voice",
      cloneVoiceHint: "Record 30-60 seconds. After cloning you can pick your voice for any video.",
      cloneVoiceProOnly: "Available on Pro plans and above",
      cloneVoiceBadge: "Recommended feature",
      uploadVoiceCta: "Already have an audio file? Upload it",
      uploadVoiceHint: "MP3, WAV or M4A — skips the recording step",
      clonedVoiceBadge: "Your voice",
      clonedVoiceDelete: "Delete cloned voice",
      cloneModalTitle: "Create a custom voice",
      cloneModalDescription: "Record about a minute of clear continuous Hebrew speech (no background noise) and pick a name that will appear in the voice picker.",
      cloneModalNameLabel: "Voice name",
      cloneModalNamePlaceholder: "e.g. My voice",
      cloneModalGenderLabel: "Voice gender",
      cloneModalUploadCta: "Upload audio file",
      cloneModalRecordCta: "Start recording",
      cloneModalStopCta: "Stop recording",
      cloneModalSubmit: "Create voice",
      cloneModalCancel: "Cancel",
      cloneModalUploading: "Uploading...",
      cloneModalCloning: "Cloning... this may take up to a minute",
      cloneModalRecordingHint: "Recording: {seconds} sec (at least 30 recommended)",
      cloneModalUploadHint: "{filename} ({size} KB) — click 'Create voice' to continue",
      cloneSuccessToast: "Your cloned voice is ready ✨",
      cloneErrorToast: "Voice cloning failed",
      cloneDeleteConfirm: "Delete your cloned voice? This cannot be undone.",
      // BYO-audio (Bring Your Own audio) — user's pre-recorded voice goes
      // straight to lip-sync, skipping TTS entirely.
      userAudioCta: "Use your own recording",
      userAudioCtaHint: "Skip TTS — record or upload audio and the avatar speaks it directly",
      userAudioModalTitle: "Use your own recording",
      userAudioModalDescription: "Record up to {max} seconds (or upload an audio file) and the avatar will lip-sync to it directly. No need to type a script — what you record is what the character will say, in your voice.",
      userAudioRecordCta: "Start recording",
      userAudioStopCta: "Stop recording",
      userAudioUploadCta: "Upload audio file",
      userAudioReplaceCta: "Replace recording",
      userAudioSubmit: "Use this recording",
      userAudioSubmitting: "Uploading...",
      userAudioCancel: "Cancel",
      userAudioRecordingHint: "Recording: {seconds} / {max} seconds",
      userAudioDurationLabel: "{seconds} seconds",
      userAudioErrorMic: "Couldn't start the microphone. Check browser permissions.",
      userAudioErrorRead: "Couldn't read the file. Try a different one.",
      userAudioErrorTooLong: "File is longer than {max} seconds. Use a shorter clip.",
      userAudioErrorTooShort: "Audio is too short. It needs at least {min} seconds of speech.",
      userAudioErrorUnsupportedRecord: "Your browser can't record in a supported format. Please upload an MP3, WAV, or M4A file instead.",
      userAudioErrorUnsupportedFormat: "Unsupported file format. Please choose MP3, WAV, M4A, or AAC.",
      userAudioActiveLabel: "Your recording will be used as-is — no script needed.",
      userAudioActiveClear: "Remove recording",
      // Step-6 two-path picker — user chooses between TTS (write a script,
      // pick a voice) OR BYO audio (own recording, no voice picker).
      dialogueModeChooseTitle: "How should the character speak?",
      dialogueModeChooseHint: "Pick one path — the voice picker only opens if you choose text.",
      dialogueModeText: "I'll write a script",
      dialogueModeTextHint: "The AI will read your text in the voice you choose next.",
      dialogueModeAudio: "Use my own recording",
      dialogueModeAudioHint: "Record or upload audio — the character lip-syncs to your voice. No voice picker needed.",
      dialogueModeSwitch: "Switch path",
      dialogueModeActiveTextLabel: "Path: written script",
      dialogueModeActiveAudioLabel: "Path: your own recording",
      wordLimitModalTitle: "Word limit reached",
      wordLimitModalBodyUpgrade: "The Free plan allows up to {current} words per video. Upgrade to Pro for up to {upgrade} words.",
      wordLimitModalBodyHardCap: "Maximum {current} words per video.",
      wordLimitModalUpgradeCta: "Upgrade to Pro",
      wordLimitModalCloseCta: "Got it",
      heroMuteAria: "Mute",
      heroUnmuteAria: "Play with sound",
      tierPickerTitle: "Video quality",
      tierStandardTitle: "Standard",
      tierStandardSubtitle: "720p — best value",
      tierProTitle: "Pro",
      tierProSubtitle: "Higher fidelity, costs more",
      generateBtn: "Create video",
      generating: "Creating the video...",
      results: "Your videos",
      noResults: "No videos yet",
      generationFailed: "Generation failed",
      generationFailedDesc: "Something went wrong. Your credits were refunded automatically.",
    },
    // Baseball Trend (Trends tab — "caught on live TV" video flow)
    baseballTrend: {
      title: "Baseball Trend Guide",
      subtitle: "One photo of you → a short \"caught on the jumbotron\" broadcast video",
      heroTitle: "Catch yourself on the big screen — in one click",
      heroSubtitle: "Upload one clear photo. Pick a scene (game / concert), and the system creates a short viral broadcast clip of you.",
      heroBeforeLabel: "Before",
      heroAfterLabel: "After",
      uploadTitle: "Step 1 · Upload your photo",
      uploadHint: "One clear photo — well-lit face, no sunglasses, high quality",
      uploadDropTitle: "Drop your photo here or click to upload",
      uploadFormats: "JPG, PNG · up to 10MB",
      removePhoto: "Remove",
      presetTitle: "Step 2 · Pick a scene",
      presetHint: "Each style swaps the background, crowd and outfit in the broadcast",
      actionTitle: "Step 6 · Describe the video's motion",
      actionHint: "Pick between the recommended natural motion and writing your own.",
      aspectRatioTitle: "Step 4 · Aspect ratio",
      aspectRatioHint: "Same ratio is used for both previews and the final video",
      aspectRatioLandscape: "Landscape — TV broadcast",
      aspectRatioPortrait: "Portrait — mobile / stories",
      actionRecommendedBadge: "Recommended",
      actionDefaultTitle: "Default",
      actionDefaultSubtitle: "Natural stadium-spectator vibe — glancing around, light smile, relaxed pose",
      actionCustomTitle: "Your description",
      actionCustomSubtitle: "Describe in your own words how the character should move and react",
      actionPlaceholder: "e.g. looking surprised at the camera, smiling, waving enthusiastically",
      durationTitle: "Video length",
      durationFiveSec: "5 seconds",
      durationTenSec: "10 seconds",
      generateBtn: "Create video",
      generating: "Creating the video...",
      results: "Your videos",
      noResults: "Tap 'Create' to get a new video",
      generationFailed: "Generation failed",
      generationFailedDesc: "Something went wrong. Your credits were refunded automatically.",
      missingUpload: "Upload a photo",
      missingPreset: "Pick a scene",
      missingPreview: "Generate & pick a preview",
      linkCopied: "Link copied",
      downloadAria: "Download",
      // Step 3 — Wardrobe / props
      wardrobeTitle: "Step 3 · Wardrobe & props",
      wardrobeHint: "The system dresses the character to match the scene. You can override.",
      wardrobeDefaultTitle: "Match the scene",
      wardrobeDefaultSubtitle: "Clothing matches the preset — not pulled from your photo",
      wardrobeCustomTitle: "Custom",
      wardrobeCustomSubtitle: "Describe outfit or props to hold",
      wardrobePlaceholder: "Red baseball cap, holding a team-name sign",
      // Step 4 — Preview pair
      previewTitle: "Step 5 · Pick your shot",
      previewHint: "Create 2 images and pick your favorite — it'll be turned into a clip",
      previewHistoryTitle: "Your past previews",
      previewHistoryHint: "Pick a previously generated preview to render it into a clip",
      previewHistoryShowMore: "Show more",
      previewHistoryDialogTitle: "Baseball preview history",
      previewGenerateBtn: "Generate 2 previews",
      previewRegenerate: "Regenerate 2 previews",
      previewDownloadAria: "Download image",
      presets: {
        baseball: "Baseball game",
        soccer: "Soccer match",
        concert: "Live concert",
        basketball: "Basketball game",
      },
    },
    // Product Studio (4 product photos in one click)
    productStudio: {
      heroBadge: "AI Product Studio",
      heroTitle: "Professional product photos in one click",
      heroSubtitle: "Upload one product photo. The AI creates 4 studio-grade shots.",
      heroBeforeLabel: "Before",
      heroAfterLabel: "× 4 After",
      uploadTitle: "Step 1 · Upload product photo",
      uploadHint: "A clear, well-lit photo gives the best result",
      uploadCta: "Drop your product photo here or click to upload",
      uploadFormats: "JPG, PNG · up to 10MB",
      changePhoto: "Change photo",
      addMorePhotos: "Add photos to improve results",
      addMorePhotosHint: "(Add clear photos of the product)",
      afterPlaceholder: "Your photos",
      createNowCta: "Create now",
      pickPreset: "Step 2 · Pick a style",
      moreStyles: "More styles",
      customBackgroundLabel: "Design your own scene",
      customBackgroundPlaceholder: "e.g. white marble with reflections, soft morning light, minimalist scene…",
      customBackgroundHelp: "Describe the scene you want — we'll place your product right in it.",
      customBackgroundQuickIdeas: "Quick ideas",
      quickBackgrounds: {
        marble: "White marble",
        wood: "Wood floor",
        beach: "Beach",
        modernLiving: "Modern living room",
        cafe: "Coffee shop",
        kitchen: "Sunny kitchen",
      },
      pickPresetHint: "Each style gives the AI a different visual direction",
      advancedCard: "Custom",
      advancedCardDesc: "Advanced settings (prompt, references, model)",
      advancedTitle: "Advanced settings",
      advancedDesc: "Write a custom prompt or add reference images",
      generateBtn: "Create 4 studio photos",
      firstUploadTipTitle: "Tip for the best result",
      firstUploadTipDesc: "Upload a clear photo of the product on a clean background. The higher the quality, the more professional the results.",
      presets: {
        cleanWhiteName: "Clean white studio",
        cleanWhiteDesc: "Pure white backdrop, even lighting, commercial look",
        dramaticLightName: "Dramatic lighting",
        dramaticLightDesc: "Deep shadows, cinematic mood, premium feel",
        minimalistName: "Minimalist",
        minimalistDesc: "Neutral palette, breathing room, modern aesthetic",
        blackWhiteName: "Black & white",
        blackWhiteDesc: "High contrast, editorial, timeless",
        lifestyleName: "Lifestyle",
        lifestyleDesc: "Real-world setting, golden-hour light, campaign feel",
      },
    },
    // Gallery Page
    gallery: {
      title: "Gallery",
      search: "Search...",
      new: "New",
      viewProject: "View Project",
      myGallery: "My Gallery",
      allMediaDescription: "All your images and videos in one place",
      all: "All",
      images: "Images",
      videos: "Videos",
      favorites: "Favorites",
      clickToOpen: "Click to open",
      video: "Video",
      image: "Image",
      adsCreator: "Product Studio",
      imageDirector: "Image Director",
      startCreation: "Start Creating",
      noImages: "No images",
      createNew: "Create new images in the studio",
      clearFailed: "Clear failed",
    },
    // Pricing Page
    pricing: {
      title: "Choose Your Plan",
      subtitle: "Start for free, upgrade anytime.",
      popular: "Popular",
      perMonth: "per month",
      tokens: "tokens",
      tokensPerMonth: "tokens per month",
      variations: "variations per creation",
      styles: "styles",
      allStyles: "All styles unlocked",
      quality: "Quality",
      customPrompts: "Custom prompts",
      noWatermark: "No watermark",
      fullEditor: "Full Editor",
      brandKit: "Brand Kit",
      batchUpload: "Batch Upload",
      prioritySupport: "Priority Support",
      notIncluded: "Not included",
      pageTitle: "Simple Pricing",
      pageSubtitle: "Choose the plan that fits your needs. No commitment, cancel anytime.",
      addTokensBtn: "Add Tokens",
      purchasesClosed: "Purchases are closed — the service is winding down.",
      purchasesClosedNotice: "We're winding down. New purchases and subscriptions are closed. Existing subscribers keep their access until July 10, 2026 with no further charges.",
      monthly: "Monthly",
      annual: "Annual",
      discount20: "20% Off",
      creditsPerImage: "10 credits = 1 image",
      popularChoice: "Popular Choice",
      monthLabel: "/ month",
      freeLabel: "Free",
      billedAnnually: "Billed annually: {symbol}{total}",
      savePercent: "Save {percent}%",
      approxImagesRange: " {min}–{max} images",
      approxShortVideosRange: " {min}–{max} short videos",
      annualSuffix: "(Annual)",
      currentPlan: "Current Plan",
      activeUntilDate: "Active until {date}",
      resubscribe: "Resubscribe",
      addTokensDialogTitle: "Add Tokens",
      addTokensDialogDesc: "Extra tokens are valid for 2 months and added to your current plan",
      tokensLabel: "tokens",
      extraTokens: "Extra Tokens",
      publicContent: "Your content is public",
      privateContent: "Your content is private",
      upgradeTo: "Upgrade to {plan}",
      downgradeTo: "Downgrade to {plan}",
      alreadyOnPlan: "You already have this plan",
      alreadyScheduled: "This plan change is already scheduled",
      confirmDowngradeTitle: "Change Plan",
      confirmDowngradeMessage: "Your plan will change from {from} to {to} on {date}. You'll keep your current benefits until then.",
      confirmDowngradeYes: "Yes, schedule change",
      confirmDowngradeNo: "Cancel",
      confirmDowngradeNewPrice: "Starting {date}, you'll be billed {symbol}{price}/{period}",
      confirmDowngradeTimelineTitle: "Plan change timeline",
      confirmDowngradeTodayLabel: "Today",
      confirmDowngradeScheduledLabel: "Scheduled",
      confirmDowngradeCurrentContinues: "{plan} continues until the end of the current cycle",
      confirmDowngradeStartingPlan: "Starting {date} — {plan}",
      confirmDowngradeNoCharge: "No charge today",
      confirmDowngradeFreePrice: "No charge",
      confirmDowngradeExplanation: "We won't charge you today. {currentPlan} ({currentPrice}) stays active until {date}, then you'll automatically switch to {newPlan} ({newPrice}).",
      downgradeScheduledSuccess: "Plan change scheduled successfully",
      confirmDowngradeToFreeMessage: "You're switching from {from} to FREE. Your current plan stays active until {date}.",
      scheduledChangeNotice: "Your plan will change to {plan} ({period}) on {date}",
      scheduledBadge: "Next plan · {date}",
      cancelScheduledChange: "Cancel scheduled change",
      cancelScheduledChangeSuccess: "Scheduled change cancelled",
      cancelScheduledTitle: "Cancel scheduled change?",
      cancelScheduledMessage: "You'll stay on your current {plan} ({period}) plan. The scheduled change to {newPlan} ({newPeriod}) will be cancelled.",
      cancelScheduledConfirm: "Yes, cancel change",
      cancelScheduledDismiss: "Keep scheduled change",
      keepThisPlan: "Keep this plan",
      alreadyDowngradingToFree: "You're already switching to the free plan at the end of your billing period",
      confirmUpgradeTitle: "Upgrade to {plan}",
      confirmUpgradeProrated: "You'll pay {symbol}{amount} today for the remaining {days} days of this cycle.",
      confirmUpgradeRecurring: "Starting next cycle, you'll be charged {symbol}{fullPrice}/{period}.",
      confirmUpgradeYes: "Upgrade",
      confirmUpgradeNo: "Cancel",
      confirmUpgradeTodayLabel: "Pay today",
      confirmUpgradeDaysContext: "for {days} remaining days",
      confirmUpgradeNextCycleLabel: "Starting {date}",
      reactivateTitle: "Reactivate Your Plan?",
      reactivateDescription: "Your plan will be reactivated with no additional charge. You'll continue on your current billing cycle.",
      reactivateYes: "Reactivate",
      reactivateNo: "Cancel",
      reactivationSuccess: "Your subscription has been reactivated!",
      reactivateChangeTitle: "Switch to {plan}?",
      reactivateChangeDescription: "No charge right now. Your new billing starts on {date}.",
      reactivateChangeYes: "Confirm Switch",
      periodMonth: "month",
      periodYear: "year",
      goToStudio: "Go to Studio",
      couponPlaceholder: "Enter coupon code",
      couponApply: "Apply",
      couponHave: "Have a coupon?",
      couponValidPercentMonthly: "{percent}% off your first month",
      couponValidPercentAnnual: "{percent}% off your first year",
      couponValidAmountMonthly: "${amount} off your first month",
      couponValidAmountAnnual: "${amount} off your first year",
      couponInvalid: "Invalid coupon code",
      couponError: "Error validating coupon",
      couponRemove: "Remove",
      couponThenPrice: "Then: {symbol}{price}/{period}",
      couponMonthlyOnly: "Coupons are valid for monthly plans only",
    },
    // Profile Page
    profile: {
      title: "My Profile",
      displayName: "Display Name",
      email: "Email",
      plan: "Plan",
      credits: "Credits",
      saveChanges: "Save Changes",
      saving: "Saving...",
      saved: "Saved successfully",
      hello: "Hello",
      studioReady: "Your studio is ready to create.",
      newCreation: "New Creation",
      creditBalance: "Credit Balance",
      monthlyCreations: "Monthly Creations",
      startCreating: "Start creating!",
      subscriptionType: "Subscription Type",
      upgradeToMore: "Upgrade to more plans",
      activeSubscription: "Active subscription",
      editProfile: "Edit Profile",
      upgradePlan: "Upgrade Plan",
      managePlan: "Manage Plan",
      addTokens: "Add Tokens",
      clickToChangeImage: "Click to change image",
      uploadingImage: "Uploading image...",
      profileUpdated: "Profile updated successfully!",
      profileUpdateError: "Error updating profile",
      loginRequired: "Please log in to view profile",
      imageFileOnly: "Only image files allowed",
      maxFileSize: "Maximum file size is 5MB",
      recommended: "Recommended",
      tokens: "tokens",
      validityPeriod: "Valid for 2 months • No monthly usage limit",
      sameAsYourPlan: "Same as tokens in your {plan} plan",
      tokensRemainPeriod: "Tokens remain in account for up to 2 months",
      canPurchaseMultiple: "Can be purchased multiple times",
      purchaseTokens: "Purchase {count} tokens",
      paymentImmediate: "Payment is immediate • Can be canceled anytime",
      loggedOutSuccess: "Logged out successfully",
      marketingNudgeTitle: "Join our email list",
      marketingNudgeSubtitle: "Get special discounts, tips, and product updates by email.",
      marketingNudgeCta: "💎 Add me for discounts",
      dangerZoneTitle: "Danger zone",
      dangerZoneSubtitle: "Irreversible actions",
      deleteAccountTitle: "Delete account",
      deleteAccountSubtitle: "Permanently delete your account, generations, and uploaded media. This cannot be undone.",
      deleteAccountButton: "Delete my account",
      deleteAccountDialogDescription: "This will permanently delete your account, every generation you've made, and every file you've uploaded. Voice samples are removed from our storage and from ElevenLabs. Type DELETE MY ACCOUNT below to confirm.",
      deleteAccountConfirmLabel: "Type DELETE MY ACCOUNT to confirm",
      deleteAccountCancel: "Cancel",
      deleteAccountSuccess: "Your account has been deleted.",
      deleteAccountError: "Could not delete your account. Please try again or contact support.",
      darkMode: "Dark Mode",
      darkModeDesc: "Change the site color theme",
      editProfileDesc: "Change name and avatar",
      preferences: "Preferences",
      account: "Account",
      usageTitle: "Usage",
      usageCreditsUsed: "Credits Used",
      usageImages: "Images",
      usageVideos: "Videos",
      usageThisMonth: "This Month",
      usageEmpty: "No usage yet",
      usageEmptySubtitle: "Start creating to see your stats here",
      manageSubscription: "Manage Subscription",
      cancelledActiveUntil: "Active until {date}",
      planActiveUntil: "{plan} plan active until {date}",
      cancelled: "Cancelled",
      resubscribe: "Resubscribe",
      tabUsage: "Usage",
      tabBilling: "Billing",
      billingPlan: "Plan",
      billingPeriod: "Billing Period",
      billingMonthly: "Monthly",
      billingAnnual: "Annual",
      billingPrice: "Price",
      billingNextRenewal: "Next Renewal",
      billingCreditsIncluded: "Credits Included",
      billingPerMonth: "/month",
      billingPerYear: "/year",
      billingChangePlan: "Change Plan",
      billingCancelPlan: "Cancel Subscription",
      billingFreePlan: "Free Plan",
      billingPaymentHistory: "Payment History",
      billingNoPayments: "No payments yet",
      billingNoPaymentsSubtitle: "Your payments will appear here",
      billingDate: "Date",
      billingType: "Type",
      billingAmount: "Amount",
      billingStatus: "Status",
      billingSubscription: "Subscription",
      billingTokenPack: "Token Pack",
      billingTokens: "{count} Tokens",
      billingStatusCompleted: "Completed",
      billingStatusPending: "Pending",
      billingStatusFailed: "Failed",
      billingStatusExpired: "Expired",
      billingCreditHistory: "Credit History",
      billingNoCreditHistory: "No credit history",
      billingNoCreditHistorySubtitle: "Credit usage will appear here",
      billingOperation: "Operation",
      billingCredits: "Credits",
      billingBalanceAfter: "Balance",
      billingOpImageGenerate: "Image Generation",
      billingOpImageEdit: "Image Edit",
      billingOpVideoGenerate: "Video Generation",
      billingOpDirectorGenerate: "Director Generation",
      billingOpTokenPurchase: "Token Purchase",
      billingOpRefund: "Refund",
      billingOpSubscription: "Subscription",
      billingOpSignupBonus: "Signup bonus",
      billingOpTokenPack: "Credit pack",
      billingOpReferralBonus: "Referral bonus",
      billingOpReferralReward: "Referral reward",
      billingOpCreditsRefresh: "Credits refreshed",
      billingOpPlanDowngrade: "Plan downgrade",
      billingOpOther: "Other",
      billingCancelledUntil: "Cancelled — active until {date}",
      billingDiscountBadge: "{percent}% off next billing",
      activityTitle: "Activity History",
      activityNoEvents: "No activity yet",
      activityNoEventsSubtitle: "Subscription actions will appear here",
      eventSubscriptionCreated: "Subscribed to {plan} ({period})",
      eventSubscriptionUpgraded: "Upgraded to {plan} ({period})",
      eventSubscriptionRenewed: "Subscription renewed",
      eventSubscriptionCancelled: "Subscription cancelled",
      eventSubscriptionExpired: "Subscription expired",
      eventSubscriptionReactivated: "Subscription reactivated",
      eventSubscriptionDowngraded: "Downgraded to {plan} ({period})",
      eventSubscriptionDowngradedToFree: "Downgraded to free plan",
      eventDowngradeScheduled: "Plan change to {plan} ({period}) scheduled",
      eventDowngradeScheduleCancelled: "Scheduled plan change cancelled",
      eventTokenPackPurchased: "Purchased {tokens} tokens",
      eventCreditsRefreshed: "Monthly credits refreshed",
      eventDiscountApplied: "{percent}% discount applied",
      eventDiscountRestored: "Discount period ended",
    },
    cancellation: {
      cancelSubscription: "Cancel Subscription",
      whyCancelling: "We'd love to know why",
      whyCancellingSubtitle: "Your answer helps us improve",
      weHaveAnOffer: "Before you go...",
      confirmCancellation: "Confirm Cancellation",

      reasonTooExpensive: "Too expensive for me",
      reasonNotUsing: "Not using it enough right now",
      reasonMissingFeatures: "Missing features I need",
      reasonSwitching: "Switching to another tool",
      reasonQuality: "Quality isn't good enough",
      reasonComplicated: "Too complicated to use",
      reasonOther: "Other",
      otherPlaceholder: "Tell us more...",
      feedbackPlaceholder: "Anything else you'd like to share?",

      offerDiscount: "Get 40% off your next month",
      offerDiscountDesc: "We'd love to keep you — here's a special price just for you.",
      offerNotUsing: "We're always improving — come back anytime!",
      offerFeatures: "New features are on the way. Stick around to be the first to try them!",
      offerSupport: "Need help? We'd love to hear from you.",
      offerGoodbye: "We understand. Thanks for trying TodoAI.",
      offerQuality: "Major quality updates are coming soon!",
      acceptOffer: "Accept offer",
      cancelAnyway: "Cancel anyway",
      keepSubscription: "Keep my subscription",

      whatYouLose: "Here's what you'll lose",
      creditsRemaining: "{n} credits remaining",
      imagesGenerated: "{n} images created this month",
      videosGenerated: "{n} videos created this month",
      accessUntil: "Access until {date}",
      switchToFree: "After that, you'll switch to the free plan",
      confirmCancel: "Confirm cancellation",

      whatsappCta: "Chat with us on WhatsApp — we'd love to help",
      whatsappButton: "Message us on WhatsApp",
      whatsappMsgTooExpensive: "Hi, I was thinking of cancelling because it's too expensive for me. I'd love to hear what you can do",
      whatsappMsgNotUsing: "Hi, I was thinking of cancelling because I'm not using it enough right now. I'd love to hear what you can do",
      whatsappMsgFeatures: "Hi, I was thinking of cancelling because I'm missing some features. I'd love to hear if anything is planned",
      whatsappMsgSwitching: "Hi, I was thinking of switching to another tool. I'd love to hear what makes you different",
      whatsappMsgQuality: "Hi, I was thinking of cancelling because the quality wasn't enough for me. I'd love to hear about improvements",
      whatsappMsgComplicated: "Hi, I was thinking of cancelling because it's too complicated for me. I'd love to get some help",

      subscriptionCancelled: "Subscription cancelled",
      discountApplied: "Discount applied!",
      cancelError: "Failed to cancel subscription",
      discountError: "Failed to apply discount",
      continueButton: "Continue",
    },
    // Dashboard Page
    dashboard: {
      resultsGallery: "Results Gallery",
      resultsDescription: "Real results from our customers — see how simple products become professional images",
      before: "Before",
      after: "After",
      createdBy: "Created by",
      wantToCreate: "Want to create results like these?",
      startCreatingNow: "Start creating now",
      categoryAll: "All",
      categorySkincare: "Skincare",
      categoryFashion: "Fashion",
      categoryTech: "Technology",
      categoryAccessories: "Accessories",
    },
    // Auth Pages
    auth: {
      loginTitle: "Login",
      signupTitle: "Sign Up",
      email: "Email",
      password: "Password",
      passwordReqLength: "At least 8 characters",
      passwordReqUppercase: "One uppercase letter",
      passwordReqLowercase: "One lowercase letter",
      passwordReqDigit: "One number",
      passwordReqSymbol: "One special character",
      loginButton: "Login",
      signupButton: "Sign Up",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      createAccount: "Create Account",
      loginHere: "Login here",
      welcomeBack: "Welcome Back",
      continueToCreate: "Sign in to continue creating",
      continueWithGoogle: "Continue with Google",
      or: "or",
      forgotPassword: "Forgot password",
      sending: "Sending...",
      loggingIn: "Logging in...",
      noAccountQuestion: "Don't have an account?",
      hasAccountQuestion: "Already have an account?",
      createNewAccount: "Create New Account",
      startCreatingFree: "Start creating amazing images for free",
      yourName: "Your name",
      creatingAccount: "Creating account...",
      passwordMinLength: "Password doesn't meet all requirements",
      signupSuccess: "Signed up successfully!",
      welcomeToFlowly: "Welcome to TodoAI!",
      loginSuccess: "Logged in successfully!",
      loginError: "Login error",
      signupError: "Signup error",
      googleLoginError: "Error signing in with Google",
      googleSignupError: "Error signing up with Google",
      invalidCredentials: "Invalid email or password",
      enterEmailForReset: "Please enter email",
      enterEmailDescription: "Enter your email address to reset password",
      resetEmailSent: "Password reset email sent",
      checkInbox: "Check your inbox",
      resetEmailError: "Error sending reset email",
      checkYourEmail: "Check Your Email",
      verificationEmailSentDescription: "We sent you a verification email. Click the link to activate your account.",
      verifyEmailTitle: "Verify Your Email",
      verifyEmailDescription: "We sent a verification link to",
      resendVerificationEmail: "Resend Verification Email",
      resendingEmail: "Sending...",
      verificationResent: "Verification email sent!",
      resendError: "Error sending email",
      checkSpamFolder: "Didn't receive it? Check your spam folder.",
      emailNotConfirmed: "Email not confirmed",
      pleaseVerifyFirst: "Please verify your email before logging in. Check your inbox.",
      resendIn: "Resend in {seconds}s",
      marketingConsent: "Email me special discounts and offers.",
      marketingPromptDecline: "Maybe later",
    },
    // Common
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      close: "Close",
      back: "Back",
      next: "Next",
      submit: "Submit",
      download: "Download",
      rateLimited: "You're doing that too fast. Please wait a moment and try again.",
      connectionLost: "Connection lost — please try again in a moment.",
      generationTimeout: "Generation is taking too long at this resolution — try a lower resolution (2K).",
      serviceWindingDown: "The service is winding down — generation is available to active subscribers only.",
      windDownBannerText: "We're moving! TodoAI is winding down — check out our new app.",
      windDownBannerSubscriberNote: "Subscribers keep full access until July 10, 2026 — no further charges.",
      windDownBannerCta: "Visit makepodcast.app",
      downloadError: "Download failed. Please try again.",
      downloadSuccess: "File downloaded successfully",
      loginRequired: "Please log in to continue",
      convertingHeic: "Converting iPhone photo (HEIC)...",
      convertingHeicSuccess: "Photo converted successfully",
      convertingHeicError: "Couldn't convert the photo. Try a different one or use JPEG.",
      uploadErrorTitle: "We couldn't process your file",
      uploadErrorBody:
        "The image may be in an unsupported format or the file may be corrupted. Please upload a JPG, PNG, or WebP image.",
      uploadErrorButton: "Got it",
      share: "Share",
      linkCopied: "Link copied",
      shareError: "Sharing failed. Please try again.",
    },
    // Todo Bot chatbot
    chatbot: {
      buttonLabel: "Need help?",
      panelTitle: "Todo Bot",
      panelSubtitle: "Here to help",
      welcomeMessage: "Hi, I'm Todo Bot 🙂 What can I help you with today?",
      inputPlaceholder: "Tell me what you need help with...",
      send: "Send",
      close: "Close",
      error: "Something went wrong, please try again.",
      anonymousLimitTitle: "Want to keep chatting?",
      anonymousLimitDescription: "Sign up to continue the conversation — it's free, and you get bonus credits.",
      signupCta: "Sign up",
      escalateWhatsapp: "Open WhatsApp chat",
      escalateEmail: "Email support",
      sessionLimitTitle: "You've reached the message limit for this session",
      sessionLimitDescription: "To keep getting help, message us on WhatsApp — a human will get back to you.",
      aiDisclaimer:
        "You're chatting with a generative AI. By continuing, you agree to the legal notice and confirm you've read our privacy & cookie policy.",
      reopenHint: "You have an open conversation",
    },
    // Bot Builder — custom AI chatbot per user, embeddable on their own site
    botBuilder: {
      navLabel: "My Bot",
      pageTitle: "Build your bot",
      pageSubtitle: "A custom AI support and info bot for your website, trained on your site's content.",
      proRequiredTitle: "Pro or Creator plan required",
      proRequiredDescription: "Building a custom bot is available to paid plans only.",
      proRequiredCta: "View plans",
      // Create form
      createTitle: "Let's create your bot",
      createDescription: "Fill in the details and we'll build a bot that knows your business.",
      nameLabel: "Bot name",
      namePlaceholder: "e.g., Avihai's Business Assistant",
      sourceUrlLabel: "Your website URL",
      sourceUrlPlaceholder: "https://mybusiness.com",
      sourceUrlHint: "We'll scan the homepage and extract info about your business",
      allowedDomainLabel: "Embed domain",
      allowedDomainPlaceholder: "mybusiness.com",
      allowedDomainHint: "The bot will only work when embedded on this domain (for security)",
      styleSampleLabel: "How should the bot speak? (optional, ≤30 words)",
      styleSamplePlaceholder: "e.g., Hi! Welcome. How can I help you today?",
      styleSampleHint: "We'll use this sample as the bot's voice",
      // Voice presets — chips above the textarea; click to auto-fill.
      stylePresetsLabel: "Or pick a preset:",
      stylePresetFriendlyName: "Friendly & casual",
      stylePresetFriendlyText: "Friendly and casual, opens with a warm hello, uses everyday accessible language. Adds an emoji here and there.",
      stylePresetProfessionalName: "Professional & formal",
      stylePresetProfessionalText: "Professional and respectful tone, clear and precise sentences, no slang, no emoji. Formal address.",
      stylePresetEnergeticName: "Energetic & upbeat",
      stylePresetEnergeticText: "Full of energy and enthusiasm! Short punchy sentences, exclamation marks and bold emoji. Fun and inviting.",
      extraInfoLabel: "Extra info the bot should know (optional)",
      extraInfoPlaceholder: "e.g., business hours, featured products, topics the bot must avoid...",
      createCost: "Creation cost: {cost} credits",
      createCta: "Create my bot",
      creating: "Creating your bot... up to a minute",
      cancelCta: "Cancel",
      createSuccess: "Your bot is ready ✨",
      createErrorTitle: "Bot creation failed",
      // Edit form — same shape as create, but the source URL is locked.
      editTitle: "Edit your bot",
      editDescription: "Update the text and embed domain. The scraped website URL can't be changed (to refresh knowledge, delete the bot and create a new one).",
      editCta: "Save changes",
      editSaving: "Saving...",
      editSuccess: "Bot updated ✨",
      editErrorTitle: "Bot update failed",
      editBackCta: "Back",
      sourceUrlLockedHint: "The website URL can't be changed after the bot is created",
      // Manage panel
      managePanelTitle: "Your bot",
      manageEditCta: "Edit",
      manageDeleteCta: "Delete",
      manageDeleteConfirm: "Delete this bot? This cannot be undone.",
      // Styled in-app delete confirmation (replaced the native window.confirm).
      deleteConfirmTitle: "Delete this bot?",
      deleteConfirmDescription: "The bot, the knowledge we scraped from your site, and the embed code will be permanently deleted. Any credits left in the bot's wallet will be refunded to your main balance.",
      deleteConfirmCancel: "Cancel",
      deleteConfirmCta: "Yes, delete the bot",
      // Localized error messages mapped from server error codes/strings via
      // mapBotServerError (see useBotBuilder).
      errorInvalidDomain: "Invalid domain. Use the format example.com (no https://, no path, no port).",
      errorAlreadyHaveBot: "You already have an active bot. Edit or delete it before creating a new one.",
      manageStatusActive: "Active",
      // Per-message pricing banner — replaces the old pack counter.
      managePricingHint: "Each AI reply costs 1 credit from your balance",
      manageCreditBalance: "{credits} credits",
      manageTopUpCta: "Top up credits",
      managePreviewTitle: "Preview",
      managePreviewHint: "Test the bot here. Internal tests don't consume credits.",
      manageEmbedTitle: "Embed on your site",
      manageEmbedHint: "Choose an embed style and paste the code into your website:",
      // Embed type tabs — owner picks one (server doesn't care, same endpoint).
      manageEmbedTabFloating: "Floating bubble",
      manageEmbedTabIframe: "Inline iframe",
      // Install help — opened from the "?" button next to each Copy button.
      manageEmbedInstallHelpCta: "How to install?",
      installHelpTitle: "How to install the code on your site",
      installHelpIntro: "You have two ways to add the code to your site — using an AI agent or doing it manually.",
      installHelpTabAi: "With AI",
      installHelpTabManual: "Manually",
      // AI approach — paste the snippet to a code assistant.
      installHelpAiIntro: "The fastest way: let an AI do it for you. Works with Claude Code, Cursor, ChatGPT, or any other coding assistant.",
      installHelpAiStep1: "Open your AI assistant (Claude Code / Cursor / ChatGPT).",
      installHelpAiStep2: "Paste the prompt below along with your site's code.",
      installHelpAiStep3: "Let it add the code to your site and save.",
      installHelpAiPromptLabel: "Prompt to copy (replace {snippet} with the code you copied):",
      installHelpAiPrompt: "Add this tag right before the closing </body> in the main HTML file of my site:\n\n{snippet}\n\nDon't change anything else on the site — just add this tag in the right place.",
      // Manual approach — per-platform short steps.
      installHelpManualIntro: "If you'd rather paste it yourself, pick your site's platform:",
      installHelpPlatformWordpress: "WordPress",
      installHelpPlatformWordpressSteps: "Install the 'Insert Headers and Footers' plugin → Settings → WPCode → paste the code in the 'Body' field → Save.",
      installHelpPlatformWix: "Wix",
      installHelpPlatformWixSteps: "Settings → Custom Code → Add Custom Code → paste the code → Place Code in: Body - end → Apply to: All pages → Add Code.",
      installHelpPlatformShopify: "Shopify",
      installHelpPlatformShopifySteps: "Online Store → Themes → Edit Code → theme.liquid → paste the code right before </body> → Save.",
      installHelpPlatformWebflow: "Webflow",
      installHelpPlatformWebflowSteps: "Project Settings → Custom Code → Footer Code → paste the code → Save Changes → Publish.",
      installHelpPlatformHtml: "Plain HTML site",
      installHelpPlatformHtmlSteps: "Open the HTML of the page, paste the code right before </body>, save the file. Upload to your server.",
      // Discreet attribution shown on every embedded chat panel.
      embedAttribution: "Created with TodoAi",
      manageEmbedFloatingHint: "A small chat button in the bottom-right corner that opens a chat window on click. Recommended for most sites.",
      manageEmbedIframeHint: "A fixed chat window placed wherever you put it on the page. Good for support pages and FAQs.",
      manageEmbedCopyCta: "Copy code",
      manageEmbedCopied: "Code copied",
      manageZeroBalanceWarning: "You're out of credits. The bot won't reply to visitors until you top up.",
      manageDeleted: "Bot deleted",
      // Shown when the bot had a non-zero wallet at delete time — the
      // remaining balance is automatically refunded to the user's main
      // credits (see migration 20260525000001).
      manageDeletedWithRefund: "Bot deleted • {amount} credits returned to your main balance ✨",
      manageDeleteFailed: "Failed to delete bot",
      // Bot Wallet — deposit credits from main balance into the bot's
      // prepaid wallet. 1:1, non-refundable. See migration 20260524000006.
      depositSectionTitle: "Top up your bot",
      depositSectionHint: "Deposit credits from your main balance so the bot can answer visitors. Each AI reply consumes one credit from the bot's wallet.",
      depositNonRefundable: "Deposits are non-refundable",
      depositSuccess: "{amount} credits deposited to your bot ✨",
      depositInsufficientToast: "Not enough credits in your main balance. Taking you to buy a credit pack.",
      depositErrorTitle: "Deposit failed",
      depositInProgress: "Depositing...",
      depositConfirmTitle: "Deposit {amount} credits to your bot?",
      depositConfirmDescription: "Credits move one-way from your main balance to the bot's wallet and cannot be moved back.",
      depositConfirmCta: "Yes, deposit",
      depositConfirmCancel: "Cancel",
      // Balance banner on the manage panel
      balanceLabel: "Bot balance",
      balanceMessagesRemaining: "~{count} replies remaining",
      balanceLowWarning: "Balance is running low",
      balanceEmptyWarning: "Bot is paused — wallet empty",
      // Locked-embed CTA when the wallet is empty
      embedLockedTitle: "Bot is paused",
      embedLockedDescription: "Deposit credits so the bot can resume and you can copy the embed code.",
      // Embed page (visitor-side)
      embedHeader: "Need help?",
      embedInputPlaceholder: "Type your question...",
      embedSend: "Send",
      embedUnavailable: "The bot is currently unavailable",
      embedUnavailableHint: "Reach out to us directly for more help.",
      // Visitor-side message when the bot owner's plan no longer permits
      // embed (e.g. they downgraded). Kept generic to not leak business info.
      embedOwnerUpgradeRequired: "This service is temporarily unavailable. Please try again later.",
      // Owner-side upsell inside the manage panel — creation + preview stay
      // open, but the embed code section shows this instead.
      embedProRequiredTitle: "Embedding on your site is a Pro feature",
      embedProRequiredDescription: "Creating and previewing your bot are open to everyone. To embed the bot on your site you'll need a Pro or Creator plan.",
      embedProRequiredCta: "Upgrade to Pro",
      embedError: "Something went wrong. Please try again.",
    },
    // Pricing Modal
    pricingModal: {
      title: "Don't stop now! 🚀",
      description: "Don't lose your momentum — add tokens or upgrade and keep creating",
      paidDescription: "You've run out of credits. Add tokens or upgrade your plan.",
      viewPlans: "View Plans",
      starterRequiredTitle: "Feature available on Starter+",
      starterRequiredDescription: "Voice cloning and uploading a voice file require a Starter plan or above.",
    },
    // WhatsApp community
    community: {
      eyebrow: "Our community",
      title: "Join our WhatsApp community 💬",
      description: "A quiet group for tips and exclusive discounts.",
      quietNote: "A quiet group, no spam, just real value.",
      joinButton: "Join the community",
      modalTitle: "Your first creation is ready!",
      modalDismiss: "Maybe later",
      footerLink: "WhatsApp community",
      reportButton: "Report to us",
      reportPrefill: "Hi, I ran into an issue on Todo AI:",
    },
    // Payment Result Page
    paymentResult: {
      verifying: "Verifying payment...",
      verifyingDesc: "We're checking your payment. This will take a moment.",
      successTitle: "Payment Successful!",
      successWelcome: "Welcome to plan",
      tokensAdded: "Tokens added to your account",
      startCreating: "Start Creating",
      failedTitle: "Payment Failed",
      cardDeclined: "Your card was declined. Please try a different card.",
      insufficientFunds: "Insufficient funds. Please try a different card.",
      expiredCard: "Your card has expired. Please use a valid card.",
      defaultError: "Payment failed. Please try again or contact support.",
      tryAgain: "Try Again",
      processing: "Processing payment...",
    },
    checkout: {
      heading: "Complete your purchase",
      backToPricing: "Back to pricing",
      iframeTitle: "Secure payment form",
      loadingPayment: "Loading secure payment form...",
      fallbackMessage: "Payment form not loading? You can open it in a new tab instead.",
      openInNewTab: "Open in new tab",
      mobileSummaryTrigger: "Order details",
      summaryTitle: "Order summary",
      summaryItem: "Item",
      summaryBilling: "Billing period",
      summaryCoupon: "Coupon",
      summaryTotal: "Total",
      summaryDueToday: "Due today",
      billingMonthly: "Monthly",
      billingAnnual: "Annual",
      tokensItemLabel: "{count} tokens",
      timelineTitle: "Billing timeline",
      timelineToday: "Today",
      timelineLater: "Later",
      timelineNextBilling: "Next billing",
      timelineFirstMonth: "First month at {discount} off",
      timelineFirstYear: "First year at {discount} off",
      timelineFromNextMonth: "From the next month onwards",
      timelineFromNextYear: "From the next year onwards",
      timelineForRemainingDays: "For {days} remaining days in the current cycle",
      timelineStartingDate: "Starting {date}",
      prorationBreakdownTitle: "How is this calculated?",
      prorationCreditApplied: "Credit for {days} remaining days on {plan} ({price})",
      prorationNewPlanForDays: "{plan} for {days} days",
      prorationDifference: "Difference you pay today",
      whatYouGetTitle: "What you get",
      benefitMonthlyTokens: "{count} tokens per month",
      benefitApproxImagesPerMonth: "≈ {min}–{max} images per month",
      benefitApproxVideosPerMonth: "≈ {min}–{max} short videos per month",
      benefitApproxImagesOneTime: "≈ {min}–{max} images",
      benefitApproxVideosOneTime: "≈ {min}–{max} short videos",
      benefitSecurePayment: "Secure payment via PayPlus (PCI-DSS)",
      benefitTokensCount: "{count} tokens added to your account instantly",
      benefitTokensValidity: "Valid for 2 months and added to your current plan",
      benefitTokensInstant: "Available immediately after payment",
      faqTitle: "Frequently asked",
      faq: {
        secure: {
          q: "Is this payment secure?",
          a: "Yes. The form is loaded directly from PayPlus, a licensed Israeli payment processor that's PCI-DSS compliant. Your card details never touch our servers.",
        },
        cancel: {
          q: "Can I cancel a subscription?",
          a: "Yes. You can cancel any time from your profile; benefits remain active until the end of the current billing period.",
        },
        support: {
          q: "Need help?",
          a: "We're here. Reach us on {link} and we'll get back within one business day.",
          linkText: "WhatsApp",
        },
      },
    },
    // Image Upload Guide
    imageUploadGuide: {
      buttonText: "What image to upload?",
      mainTitle: "For best results – upload the right product image",
      notSuitable: "❌ Not Suitable",
      suitable: "✅ Suitable",
      notSuitableItems: [
        "Weak lighting or shadows",
        "Product not fully captured",
        "Wrinkles, defects or dirt",
        "Small or blurry text",
      ],
      suitableItems: [
        "Clear image with even lighting",
        "Product fully captured",
        "Accurate colors",
        "Sharp and clear text (if any)",
      ],
      notSuitableCaption: "Such a photo may affect result quality",
      suitableCaption: "This way the system can produce accurate results",
      disclaimer1: "* Images are created using AI and may contain minor inaccuracies",
      disclaimer2: "* Products with lots of Hebrew text may have slight text distortion, especially when small or dense",
      notSuitablePhoto: "Not suitable photo",
      properlyPhotographed: "Properly photographed product",
      optionalBadge: "Optional",
      profileSideView: "Profile/Side View",
      notSuitableShort: "Bad lighting|Partial product|Blurry text",
      suitableShort: "Even lighting|Full product|Accurate colors",
      profilePointsList: "More accurate results|Fewer hallucinations|Optional",
      aiDisclaimer: "* This application is AI-based and may make mistakes",
      hebrewTextDisclaimer: "* Hebrew text may appear slightly distorted when unclear or dense",
    },
    // How It Works
    howItWorks: {
      trigger: "How it works?",
      gotIt: "Got it",
      imageGenerator: {
        headline: "From idea to image in seconds",
        step1Title: "Upload an Image",
        step1Desc: "Upload any photo you want to edit",
        step2Title: "Describe the Change",
        step2Desc: "Tell the AI what to change — background, colors, elements",
        step3Title: "Get Your Result",
        step3Desc: "AI generates the edited image in seconds",
      },
      textToVideo: {
        headline: "From concept to video in seconds",
        step1Title: "Describe Your Scene",
        step1Desc: "Write a prompt describing the video you want",
        step2Title: "Add a Reference",
        step2Desc: "Optionally upload an image to guide the style",
        step3Title: "Get Your Video",
        step3Desc: "AI creates your video in seconds",
      },
      framesToVideo: {
        headline: "From frames to motion in seconds",
        step1Title: "Upload Start & End",
        step1Desc: "Upload the first and last frames of your video",
        step2Title: "Describe the Motion",
        step2Desc: "Tell the AI how to animate between the frames",
        step3Title: "Get Your Video",
        step3Desc: "AI creates the transition video",
      },
      productCatalog: {
        headline: "From one photo to a full catalog",
        step1Title: "Upload Your Product",
        step1Desc: "A clear, well-lit photo of your product",
        step2Title: "Get Your Catalog",
        step2Desc: "AI generates professional angles and variations",
      },
      directorChat: {
        headline: "Create images through conversation",
        step1Title: "Start a Conversation",
        step1Desc: "Chat with AI about the image you want",
        step2Title: "AI Generates Options",
        step2Desc: "Get multiple image options to choose from",
        step3Title: "Refine & Iterate",
        step3Desc: "Ask for changes until it's perfect",
      },
    },
    // Lightbox
    lightbox: {
      backToStudio: "Back to Studio",
      options: "Options",
      editImage: "Edit Image",
      regenerate: "Regenerate",
      regenerateDisabled: "No reference image was used — regeneration is unavailable",
      animate: "Animate",
      download: "Download",
      share: "Share",
      imageDetails: "Image Details",
      videoDetails: "Video Details",
      creationDate: "Creation Date",
      sourceImage: "Source Image",
      prompt: "Prompt",
      resolution: "Quality",
      clickToUseSource: "Click to use",
      clickToUseImage: "Click to use this image",
      aspectRatio: "Aspect Ratio",
      pipeline: "Creation Type",
      pipelineAd: "Ad",
      pipelineEdit: "Edit",
      pipelineDirector: "Image Director",
      pipelineTextToVideo: "Text to Video",
      pipelineFramesToVideo: "Frames to Video",
      model: "Model",
      duration: "Duration",
      secondsShort: "s",
      showMore: "Show more",
      showLess: "Show less",
      fullscreen: "Full Screen",
      advancedSettings: "Advanced settings",
    },
    // Not Found Page
    notFound: {
      title: "404",
      message: "Oops! Page not found",
      returnHome: "Return to Home",
    },
    // Public share page (/s/:id) — opened when someone clicks a branded share link
    share: {
      loading: "Loading creation...",
      ctaLine1: "Made with TodoAI",
      ctaLine2: "Create yours — free",
      ctaButton: "Start creating",
      notFoundTitle: "This creation isn't available",
      notFoundBody: "The creator may have removed it, or the link is wrong.",
      goHome: "Enter TodoAI",
    },
    // Credits Display
    creditsDisplay: {
      credits: "credits",
    },
    // Photo Guidelines
    photoGuidelines: {
      title: "How to photograph your product",
      subtitle: "For best results",
      frontView: "Front-facing shot",
      cameraHeight: "Camera at product height",
      frontViewTitle: "Front-facing shot",
      frontViewDesc: "Product facing camera horizontally, not at an angle from above/below",
      cameraHeightTitle: "Camera at product height",
      cameraHeightDesc: "Lens in a straight line with product center to prevent distortion",
      goodExample: "Good Example",
      howToPhoto: "How to photograph?",
      howToPhotoTitle: "How to photograph a product correctly?",
      correctPhoto: "Correct Photo",
      evenLighting: "Even, accurate lighting",
      completeProduct: "Complete, visible product",
      accurateColors: "Accurate colors",
      cleanBackground: "Clean background",
      incorrectPhoto: "Incorrect Photo",
      poorLighting: "Poor lighting/shadows",
      partialProduct: "Cut off/partial product",
      unclearText: "Unclear text",
      distractingBg: "Distracting background",
      tip: "💡 Tip: Photograph your product on a white or neutral background with natural lighting for best results.",
      moreAccurate: "More accurate results",
      lessHallucinations: "Less hallucinations",
      optional: "Optional",
    },
    // Image Delete
    imageDelete: {
      deleteFailed: "Delete failed",
      imageDeleted: "Image deleted",
      removedFromGalleries: "Image removed from all galleries",
      deleteError: "An error occurred",
    },
    // Mask Canvas
    maskCanvas: {
      title: "Draw on the image",
      brush: "Brush",
      eraser: "Eraser",
      brushSize: "Size",
      clear: "Clear",
      confirm: "Confirm",
      instructions: "Draw on the area you want to edit. When done click \"Confirm\" and the mask will be used as an editing guide.",
    },
    // Image Director Chat
    director: {
      pageTitle: "Image Director Chat",
      subtitle: "Tell me what you want — I'll create studio images for you",
      greeting: "Hello! I'm your creative agent 🎨 Describe briefly what you'd like to create — I'll ask a few short questions to understand exactly what you're looking for.",
      newChat: "New Chat",
      conversationHistory: "Conversation history",
      useReferenceImages: "Use reference images",
      referenceOn: "ON",
      referenceOff: "OFF",
      referenceAck: "Thanks for uploading the image 🙏 The image will be used as a reference only.",
      quantity: "Quantity:",
      quality: "Quality:",
      ratio: "Ratio:",
      inProgress: "In progress:",
      generateBtn: "Generate {count} images ({cost} credits)",
      helperKeepAnswering: "Continue answering questions or click 'Generate' to create now",
      helperModifyPrompt: "You can modify the prompt by sending another message, or click 'Generate'",
      allAgentImages: "All Agent Images",
      processing: "Processing...",
      clickToOpen: "Click to open",
      noImagesYet: "No images created with the agent yet",
      startCreating: "Start a conversation with the agent to create images",
      error: "Error",
      aiCommError: "An error occurred communicating with the AI",
      oneMoreStep: "One more step",
      oneMoreStepDesc: "Describe what you want and answer at least one question, then click 'Generate'.",
      proRequired: "PRO subscription required",
      proRequiredDesc: "4K quality is only available for PRO subscribers",
      generationInProgress: "Generation in progress",
      maxConcurrent: "Maximum 4 concurrent generations",
      parallelPro: "Parallel generation is available in PRO",
      imagesCreated: "Images created!",
      imagesCreatedDesc: "Successfully created {count} images",
      generationFailed: "Generation failed",
      generationFailedDesc: "An error occurred generating the images",
      failedRefunded: "Failed - Refunded",
      generationFailedWithRefund: "Generation failed. Credits refunded.",
      viewingHistory: "Viewing history - click 'New Chat' to continue",
      describePlaceholder: "Describe the image you want to create...",
      referenceCount: "Reference",
      generate: "Generate",
      promptReady: "Prompt ready! Click Generate to create your images",
      promptNotReady: "Answer the questions to prepare the prompt",
      defaultTitle: "Image Director Chat",
    },
    // Explore Page
    explore: {
      title: "Explore Community",
      subtitle: "Real results from our community — get inspired for your next creation",
      tabImages: "Images",
      tabVideos: "Videos",
      filterAll: "All",
      filterAds: "Ads",
      filterEdits: "Edits",
      ctaTitle: "Want to create results like these?",
      ctaSubtitle: "Start creating for free now",
      ctaButton: "Start Creating",
      noImagesTitle: "No images yet",
      noImagesSubtitle: "Be the first to create!",
      noVideosTitle: "No videos yet",
      noVideosSubtitle: "Be the first to create a video!",
      badgeEdit: "Edit",
      badgeAd: "Ad",
      badgeVideo: "Video",
      privacyBannerTitle: "Your content appears here",
      privacyBannerSubtitle: "On the free plan, your creations are shown in the community gallery. Upgrade for full privacy.",
      privacyBannerUpgrade: "Upgrade for Privacy",
    },
    // Lightbox Delete
    lightboxDelete: {
      deleteBtn: "Delete",
      confirmTitle: "Delete this image?",
      confirmDesc: "This will permanently delete the image from all galleries. This action cannot be undone.",
      cancel: "Cancel",
    },
    // Dual Reference Upload
    dualReferenceUpload: {
      title: "Upload Product Images",
      detectedRatio: "Detected:",
      uploadProduct: "Upload Product Image",
      dragOrClick: "Click or drag an image here",
      mainImage: "Main Image",
      addMore: "Add more images for improved accuracy (up to 5)",
    },
    // PRO Feature Modal
    proModal: {
      title: "This feature is for PRO subscribers only",
      description: "Upgrade to PRO plan to get access to 4K quality and all additional benefits",
      upgrade: "Upgrade to PRO",
      notNow: "Not now",
    },
    // Chat Input Bar
    chatInput: {
      placeholder: "Describe the image you want to create...",
      addReference: "Add reference image",
      dropToAttach: "Drop to attach image",
      fileTooLarge: "File too large",
      fileTooLargeDesc: "Maximum file size is 10 MB",
    },
    // History Panel
    historyPanel: {
      title: "Conversation History",
      loading: "Loading...",
      empty: "No conversation history yet",
      untitled: "Untitled conversation",
      resume: "Resume",
    },
    // Agent Mode Selector
    agentMode: {
      prompt: "What would you like to do?",
      newCharactersTitle: "Create New Characters",
      newCharactersDesc: "No reference — completely new characters",
      referenceTitle: "Use Reference Image",
      referenceDesc: "Product/face — maintain consistency",
    },
    // Scroll to Bottom Button
    scrollButton: {
      newMessages: "{count} new",
      backToBottom: "Back to bottom",
    },
    // Contact Page
    contact: {
      title: "Contact Us",
      subtitle: "Have a question? We'd love to help! Fill out the form and we'll get back to you soon.",
      fullName: "Full Name",
      namePlaceholder: "Enter your name",
      email: "Email",
      messageLabel: "Message",
      messagePlaceholder: "Tell us how we can help...",
      sending: "Sending...",
      sendMessage: "Send Message",
      emailLabel: "Email",
      responseTime: "Response Time",
      responseHours: "Sun-Thu, 09:00-18:00",
      faqTitle: "FAQ",
      faqSubtitle: "Before reaching out, the answer might already be here",
      faqButton: "Go to FAQ",
      successToast: "Message sent successfully",
      successDesc: "We'll get back to you as soon as possible",
    },
    // Help Page
    help: {
      title: "Help Center",
      subtitle: "Find answers to the most common questions. Can't find what you're looking for? Contact us.",
      stillNeedHelp: "Still need help?",
      teamHere: "Our team is here for you. We're happy to help with any question or issue.",
      sendMessageBtn: "Send a Message",
      // Categories
      catAll: "All",
      catGettingStarted: "Getting Started",
      catImages: "Image Creation",
      catVideos: "Video Creation",
      catEditing: "Image Editing",
      catCredits: "Credits & Payment",
      catAccount: "Account",
      catTechnical: "Technical",
      // FAQ questions
      // Getting Started
      faq1Q: "How do I get started with TodoAI?",
      faq1A: "Sign up for a free account — no credit card needed. Upload a photo of your product and choose what you want to create: an ad image, a studio photo, or a short video. The AI handles the rest and delivers results in under a minute.",
      faq2Q: "Do I need any technical knowledge or design experience?",
      faq2A: "Not at all. TodoAI is built for business owners, not designers. If you can upload a photo, you can use the platform. No software to install, no tutorials to watch — just upload and create.",
      faq3Q: "What file types and sizes can I upload?",
      faq3A: "We support PNG, JPG, and WEBP formats up to 10 MB. For the best results, use a clear, well-lit photo. A smartphone photo in good lighting works great.",
      faq4Q: "Is TodoAI available in Hebrew?",
      faq4A: "Yes! The entire interface supports Hebrew with full right-to-left layout. You can switch between English and Hebrew anytime from the menu.",
      // Image Creation
      faq5Q: "How long does it take to create an image?",
      faq5A: "Most images are ready in 20–30 seconds. The Product Studio gives you 4 variations per generation so you can pick the best one. Higher resolutions may take a few seconds longer.",
      faq6Q: "What is aspect ratio and which one should I pick?",
      faq6A: "Aspect ratio is the shape of your image. Use 1:1 for Instagram posts, 9:16 for Stories and Reels, and 16:9 for banners or website headers. Not sure? Choose 'Auto' and the system picks the best fit.",
      faq7Q: "What's the difference between resolution options?",
      faq7A: "HD works well for social media. 2K is a great all-rounder — sharp quality with fast processing. 4K is ideal for print or large-format use. All plans, including the free plan, include access to 4K.",
      // Video Creation
      faq8Q: "What's the difference between Kling 2.6 and Kling 2.5 Turbo?",
      faq8A: "Kling 2.6 generates a video from a single image with natural motion and optional sound effects. Kling 2.5 Turbo gives you more control by letting you set both a start and end image for precise transitions.",
      faq9Q: "Can I add sound or music to my videos?",
      faq9A: "Kling 2.6 has a built-in Sound option that adds ambient sound effects and English speech to your video. For background music or voiceovers, you can add audio after downloading using any video editing app.",
      faq10Q: "How long can my videos be?",
      faq10A: "You can create videos of 5 or 10 seconds. Short clips work best for social media ads, product teasers, and Instagram/TikTok content.",
      // Editing
      faq11Q: "What can I do with the image editor?",
      faq11A: "The editor lets you change backgrounds, add or remove objects, adjust colors, and apply creative effects — all powered by AI. For example, you can swap a plain white background for a lifestyle scene in seconds. Just describe the change you want.",
      faq12Q: "Any tips for writing good editing instructions?",
      faq12A: "Be specific. Instead of 'make it better', try 'change the background to a wooden table with soft natural lighting'. The clearer your description, the closer the result will be to what you imagine.",
      // Tokens & Pricing
      faq13Q: "How many tokens does each action cost?",
      faq13A: "Token costs depend on the model and resolution you choose. Images typically cost between 4 and 25 tokens. Videos range from about 20 tokens for a short clip to several hundred for longer, higher-quality options. You'll always see the exact token cost before confirming any generation.",
      faq14Q: "What happens when I run out of tokens?",
      faq14A: "You can upgrade your plan for more monthly tokens, or purchase one-time token packs to keep creating.",
      faq15Q: "Do my tokens renew every month?",
      faq15A: "Yes! On the Starter, Pro, and Creator plans your tokens renew every billing cycle. Unused tokens do not carry over. You can also buy token packs anytime for a one-time boost.",
      faq16Q: "What happens if a generation fails? Do I lose my tokens?",
      faq16A: "No. If a generation fails for any reason, your tokens are automatically refunded. You only pay for results you actually receive.",
      // Account
      faq17Q: "How do I update my account details?",
      faq17A: "Head to the Profile page from the menu. There you can update your display name, profile picture, and other account details.",
      faq18Q: "How do I cancel my subscription?",
      faq18A: "You can cancel anytime from your account settings — no hoops to jump through. After canceling, you keep full access until the end of your current billing period.",
      // Technical
      faq19Q: "Why does the AI image look different from my original photo?",
      faq19A: "The AI interprets your photo creatively rather than copying it pixel-for-pixel. For results closer to the original, upload a high-quality image with good lighting and a clean background. Adding a detailed description also helps guide the AI.",
      faq20Q: "Hebrew text in my image looks distorted — what can I do?",
      faq20A: "AI models sometimes struggle with small or dense Hebrew text. For best results, use images with large, clear text — or add text after creation using the image editor.",
      faq21Q: "What image quality and resolution will I get?",
      faq21A: "All plans — including the free plan — let you generate images up to 4K resolution with no watermarks. The exact output size depends on the aspect ratio and resolution you select before generating.",
    },
    // Terms of Service
    terms: {
      title: "Terms of Service",
      lastUpdated: "Last updated: February 2026",
      section1Title: "1. Agreement to Terms",
      section1Content: "By accessing or using TodoAI services (the \"Service\"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please refrain from using the Service. You must be at least 18 years old to use the Service. By using the Service, you represent and warrant that you are 18 years of age or older and that you have the legal capacity to enter into these terms.",
      section2Title: "2. Service Description",
      section2Content: "TodoAI provides an AI-powered platform for creating images, videos, upscaling resolution, and editing visual content. The Service utilizes third-party AI providers (including but not limited to OpenAI, Kling AI, and NanoBanana) for content processing. Features, available models, and capabilities may change from time to time.",
      section3Title: "3. User Account",
      section3Content: "You must provide accurate and up-to-date information when creating an account. You are solely responsible for maintaining the confidentiality of your access credentials and for all activity that occurs under your account. You must notify TodoAI immediately of any unauthorized use of your account. TodoAI is not responsible for any loss or damage arising from unauthorized use of your account.",
      section4Title: "4. Credits and Payments",
      section4Content: "Using the Service requires credits. All purchases are final — purchased credits are non-refundable, non-transferable, and cannot be exchanged for cash. Prices may change from time to time; changes will apply to future purchases only. Unused credits do not accrue interest and may expire in accordance with the applicable package terms. TodoAI is not responsible for payment failures caused by your payment provider.",
      section5Title: "5. Intellectual Property Rights",
      section5Content: "Subject to your compliance with these terms, you retain rights in content created through the Service for personal and commercial use. However, TodoAI retains all rights in the platform, technology, models, algorithms, and source code. TodoAI may use anonymized and aggregated content for service improvement, model training, and marketing purposes, without personally identifying you. You represent and warrant that you have all necessary rights to any content you upload to the Service.",
      section6Title: "6. AI-Generated Content Disclaimer",
      section6Content: "Content generated through artificial intelligence is provided \"as is\" without any warranty of accuracy, quality, or fitness for a particular purpose. AI outputs may include unexpected results, inaccuracies, or content that may resemble real people, brands, or copyrighted material. You are solely responsible for reviewing, verifying, and ensuring the lawful use of all generated content. TodoAI is not liable for any claims arising from your use of AI-generated content.",
      section7Title: "7. Prohibited Use",
      section7Content: "You may not use the Service to create content that is: illegal, harmful, threatening, abusive, harassing, defamatory, or racist; infringing upon third-party intellectual property or privacy rights; impersonating real people (including deepfakes) without their consent; pornographic, and in particular any content exploiting minors (CSAM); fraudulent, deceptive, or constituting misrepresentation; designed to circumvent safety filters or Service restrictions; spam, malware, or phishing. TodoAI reserves the right to remove content, suspend, or terminate accounts that violate these terms, at its sole discretion and without prior notice.",
      section8Title: "8. Content Moderation & Takedowns",
      section8Content: "TodoAI reserves the right (but is not obligated) to review, monitor, and remove any content created through the Service. If you believe that content infringes your copyright, please contact us with details of the alleged infringement, including: a description of the copyrighted work, identification of the infringing content, and your contact information. TodoAI will process complaints and remove infringing content in accordance with applicable law. Repeat infringers may have their accounts permanently terminated.",
      section9Title: "9. Third-Party Services",
      section9Content: "The Service uses third-party AI providers and services (including OpenAI, Kling AI, NanoBanana, and others) for content processing and generation. These third-party services are subject to their own terms and privacy policies. TodoAI is not responsible for the availability, accuracy, or performance of third-party services. Changes to or discontinuation of third-party services may affect Service features and capabilities.",
      section10Title: "10. Service Availability",
      section10Content: "TodoAI strives to provide continuous service but does not guarantee uninterrupted availability. The Service may be unavailable due to maintenance, updates, technical issues, or circumstances beyond our control. TodoAI may modify, suspend, or discontinue any part of the Service at any time, with or without prior notice. You shall have no claim for temporary or permanent service interruptions.",
      section11Title: "11. Termination",
      section11Content: "TodoAI may suspend or terminate your account at any time, for any reason, at its sole discretion, including but not limited to violation of these terms. Upon account termination: unused credits will be forfeited and will not be refunded; your access to the Service and generated content will cease; TodoAI may delete your data and content. You may close your account at any time through account settings or by contacting us.",
      section12Title: "12. Limitation of Liability",
      section12Content: "The Service is provided \"as is\" and \"as available\" without any warranty, express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement. In no event shall TodoAI, its directors, employees, or partners be liable for indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, reputation, or business losses. TodoAI's total aggregate liability to you shall be limited to the amount you paid for the Service in the 12 months preceding the claim.",
      section13Title: "13. Indemnification",
      section13Content: "You agree to indemnify, defend, and hold harmless TodoAI, its directors, employees, and partners from any claims, damages, losses, liabilities, costs, and expenses (including attorneys' fees) arising from: (a) your use of the Service; (b) content you created or uploaded; (c) your breach of these terms; (d) your infringement of any third-party rights.",
      section14Title: "14. Governing Law & Jurisdiction",
      section14Content: "These terms shall be governed by and construed in accordance with the laws of the State of Israel, without regard to conflict of law principles. Any dispute arising from or relating to these terms shall be subject to the exclusive jurisdiction of the courts of Tel Aviv-Jaffa, Israel. The parties agree to attempt to resolve disputes amicably before resorting to litigation.",
      section15Title: "15. Changes to Terms",
      section15Content: "TodoAI may update these terms from time to time. We will notify of material changes via a notice on the website or by email. Continued use of the Service after an update constitutes agreement to the updated terms. If you do not agree to the updated terms, you must discontinue use of the Service.",
      section16Title: "16. Contact Us",
      section16Content: "For questions regarding these Terms of Service, you can contact us through the Contact page on the website.",
    },
    // Privacy Policy
    privacy: {
      title: "Privacy Policy for TodoAI",
      lastUpdated: "Last Updated: February 2026",
      intro: "This Privacy Policy explains how TodoAI, operated by Todo AI Technologies Ltd. (\"we,\" \"us,\" or \"our\"), collects, uses, discloses, and safeguards your information when you use our platform and related services (collectively, the \"Service\").",
      agreement: "By accessing or using the Service, you acknowledge that you have read and understand this Privacy Policy. If you do not agree, please do not use the Service.",
      keyPointsTitle: "Key Points",
      keyPoints: [
        "**You own** all content you generate through our AI tools",
        "**We don't sell** your personal information",
        "**Your images and prompts** are sent to third-party AI providers to generate your content",
        "**We don't train** on your outputs for other users",
        "**You can request** deletion of your data and account at any time",
        "**Your data** is processed in Israel (EU-adequate) and may be processed in other countries where our AI providers operate",
      ],
      section1Title: "1. Information We Collect",
      section1Sub1Title: "Information You Provide:",
      section1Sub1Items: [
        "Name and email address",
        "Profile preferences and language setting",
        "Billing and payment information (processed securely by our payment provider — we never see or store your card details)",
        "Images you upload, text prompts you write, and the images and videos generated for you",
      ],
      section1Sub2Title: "Information Collected Automatically:",
      section1Sub2Items: [
        "IP address, browser type, operating system, device type",
        "Pages visited, features used, session duration",
        "Cookies and similar technologies (see Section 4)",
      ],
      section1Sub3Title: "Information from Third Parties:",
      section1Sub3Items: [
        "If you sign in via Google: name, email, and profile picture as provided by Google",
      ],
      section2Title: "2. How We Use Your Information",
      section2Items: [
        "Provide, maintain, and improve our Service",
        "Process your images and prompts through AI models and deliver generated outputs",
        "Process payments and send transaction confirmations",
        "Communicate with you (support, updates, security alerts)",
        "Send marketing and promotional communications (only with your opt-in consent)",
        "Analyze usage patterns to improve the Service",
        "Display free-plan creations in the Community Gallery (see Section 3)",
        "Maintain the security of the Service",
        "Comply with legal obligations",
      ],
      section3Title: "3. Sharing Your Information",
      section3Content: "We do not sell your personal information. We share data only in these situations:",
      section3Items: [
        "**AI providers:** Your uploaded images and prompts are sent to the third-party AI providers powering the feature you use, in order to generate your outputs. Each provider's own privacy policy also applies. We select providers that commit to not using API customer data for model training, but we cannot guarantee their internal practices",
        "**Service providers:** Cloud hosting, payment processing, analytics, and email communications",
        "**Community Gallery:** Images generated on the free plan are displayed publicly in our Explore gallery. Only the generated image and your display name are shown — never your email, account details, or original uploads. You can remove your content from the gallery at any time through your account settings",
        "**Legal requirements:** When required by law, court order, or by the Israel Privacy Protection Authority (PPA)",
        "**Business transfers:** In connection with a merger, acquisition, or sale of assets — with prior notice to you",
        "**With your consent:** For any purpose not described in this Policy",
      ],
      section3Outro: "We may share non-personally-identifiable, aggregated data for analytics and improvement purposes. For a current list of sub-processors or more details, contact team@todowith.ai.",
      section4Title: "4. Cookies and Analytics",
      section4Content: "We use cookies and similar technologies to personalize your experience and understand usage patterns:",
      section4Items: [
        "**Essential cookies** — Required for the Service to function (authentication, session management, and language preferences). These cannot be disabled.",
        "**Analytics cookies (PostHog)** — Help us understand how visitors use the Service, including page views, feature usage, and performance. We may also collect your user ID, email, display name, and subscription type for analytics purposes. You can opt in or out of analytics cookies at any time via the cookie consent banner.",
      ],
      section4Outro: "When you first visit, we display a cookie consent banner where you can accept, reject, or customize your preferences. You can change your cookie settings at any time via the \"Manage Cookies\" link in the footer. Declining analytics cookies does not affect core functionality.",
      section5Title: "5. Security",
      section5Content: "We implement appropriate technical and organizational measures to protect your personal data, including encryption in transit and at rest, access controls, and monitoring.\n\nNo system is perfectly secure, and we cannot guarantee absolute security. In the event of a data breach, we will notify the Israel Privacy Protection Authority and affected users as required by the Protection of Privacy Law.",
      section6Title: "6. Data Retention",
      section6Items: [
        "**Account data:** Retained while your account is active",
        "**Uploaded images and generated content:** Retained while your account is active; deleted within 30 days of account deletion",
        "**Financial records:** 7 years as required by Israeli tax law (held by our payment provider)",
        "**Usage and analytics data:** Up to 24 months, then anonymized",
        "**Server logs:** 90 days",
      ],
      section6Outro: "You may request deletion of your data at any time by contacting us. Some data may be retained where required by law.",
      section7Title: "7. Your Rights",
      section7Content: "Under the Protection of Privacy Law, 5741-1981 (as amended by Amendment No. 13) and, where applicable, the GDPR, you have the right to:",
      section7Items: [
        "Access, correct, or delete your personal data",
        "Restrict or object to certain processing",
        "Request data portability",
        "Withdraw consent for non-essential processing",
        "Lodge a complaint with the Israel Privacy Protection Authority (PPA): 66 Kanfei Nesharim St., Jerusalem; Phone: *3450",
      ],
      section7Outro: "Providing your information is voluntary. However, without an email and name you cannot create an account, and without uploading images the AI generation features cannot function.\n\nContact team@todowith.ai to exercise your rights. We respond within 30 days.",
      section8Title: "8. AI Content and Ownership",
      section8Sub1Title: "Ownership:",
      section8Sub1Content: "You own the images and videos you generate through our AI tools. We do not claim ownership of your content.",
      section8Sub2Title: "How it works:",
      section8Sub2Content: "When you use our generation features, your uploaded images and text prompts are sent to third-party AI model providers to generate your requested output. The results are returned to our servers and delivered to you.",
      section8Sub3Title: "Your content is yours:",
      section8Sub3Content: "Your images, prompts, and generated outputs are not used to train AI models for other users. We may use anonymized, aggregated usage statistics for platform improvement.",
      section8Sub4Title: "No automated decisions:",
      section8Sub4Content: "We do not use automated decision-making for decisions that produce legal or similarly significant effects on you. AI is used solely to generate content at your request.",
      section9Title: "9. International Data Transfers",
      section9Content: "TodoAI is operated from Israel. Your data is primarily processed in Israel, and may also be processed in other countries where our service providers and AI providers operate.\n\nIsrael has been recognized by the European Commission as providing adequate data protection (Decision 2011/61/EU). For transfers to countries without an adequacy decision, we rely on contractual safeguards as implemented by our service providers.",
      section10Title: "10. Children's Privacy",
      section10Content: "Our Service is intended for users who are at least 16 years old. We do not knowingly collect information from children under 16. If we discover we have collected such data, we will delete it promptly. Contact team@todowith.ai if you believe a child has provided us with personal information.",
      section11Title: "11. California Privacy Rights (CCPA/CPRA)",
      section11Content: "California residents have additional rights: the right to know what personal information we collect, the right to delete it, and the right to opt out of its sale. We do not sell personal information or share it for cross-context behavioral advertising. We will not discriminate against you for exercising these rights. Contact team@todowith.ai to exercise your California privacy rights.",
      section12Title: "12. Links to Other Sites",
      section12Content: "Our Service may contain links to third-party websites. We are not responsible for the privacy practices or content of those sites. We encourage you to review the privacy policies of any third-party sites you visit.",
      section13Title: "13. Email Communications",
      section13Content: "By signing up, you may receive marketing and promotional emails from us. You can unsubscribe at any time via the link in any email. Transactional emails (receipts, credit notifications, security alerts) will continue regardless.",
      section14Title: "14. Changes to This Policy",
      section14Content: "We may update this policy from time to time. We will notify you of significant changes via email or a notice on the Service. Continued use after changes constitutes acknowledgment of the updated policy.",
      section15Title: "15. Contact",
      section15Content: "Todo AI Technologies Ltd.\nRamat Gan, Israel\nWebsite: app.todowith.ai\nEmail: team@todowith.ai",
    },
    // Accessibility Statement
    accessibility: {
      title: "Accessibility Statement",
      lastUpdated: "Last updated: February 2026",
      section1Title: "1. Commitment to Accessibility",
      section1Content: "TodoAI is committed to making its website and services accessible to the entire population, including people with disabilities. We invest significant resources to ensure that every user can browse the site comfortably and equally.",
      section2Title: "2. Accessibility Standard",
      section2Content: "This website meets the requirements of Israeli Standard 5568 and Web Content Accessibility Guidelines WCAG 2.1 at AA level. The standard defines how to make web content accessible for people with various disabilities.",
      section3Title: "3. Accessibility Plugin",
      section3Content: "The website has an accessibility plugin (Enable) installed that allows various accessibility adjustments, including: text size changes, color contrast, animation pausing, link highlighting, and more. The plugin can be accessed via the accessibility icon on the site.",
      section4Title: "4. Adjustments Made",
      section4Content: "As part of making the site accessible, the following adjustments were made: hierarchical and semantic heading structure, alternative descriptions for images, keyboard navigation support, screen reader compatibility, sufficient color contrast, and text size adjustment support.",
      section5Title: "5. Known Limitations",
      section5Content: "Despite our efforts to make all pages and content accessible, some content may not yet be fully accessible. In particular, AI-generated images may not include complete alternative descriptions. We continue to work on improving accessibility on an ongoing basis.",
      section6Title: "6. Reporting Accessibility Issues",
      section6Content: "If you encounter an accessibility issue on the website, we'd love to hear from you. You can contact us through the Contact page and describe the issue you encountered. We are committed to addressing accessibility inquiries within 7 business days.",
    },
    // Admin
    admin: {
      title: "Admin",
      pricingTab: "Pricing",
      featureRequestsTab: "Feature Requests",
      totalRevenue: "Revenue",
      totalCost: "Cost",
      overallMargin: "Margin",
      totalGenerations: "Generations",
      revenueVsCost: "Revenue vs Cost (Daily)",
      marginByModel: "Margin by Model",
      revenue: "Revenue",
      cost: "Cost",
      margin: "Margin %",
      noData: "No data to display",
      last7Days: "7 days",
      last30Days: "30 days",
      last90Days: "90 days",
      dateRange: "Date Range",
      // Customers (per-user profitability) tab
      customersTab: "Customers",
      payingUsers: "Paying Users",
      totalProfit: "Profit",
      avgProfit: "Avg Profit",
      providerCost: "Provider Cost",
      profitByCustomer: "Profit by Customer",
      searchByEmail: "Search by email",
      exportCsv: "Export CSV",
      colCustomer: "Customer",
      colPlan: "Plan",
      colPaid: "Paid",
      colGenerations: "Generations",
      colCreditsUsed: "Credits",
      colProviderCost: "Provider Cost",
      colProfit: "Profit",
      colMargin: "Margin %",
      noCustomers: "No paying customers yet",
      measuredCost: "measured",
    },
    // Onboarding Tour
    onboardingTour: {
      studioTabsTitle: "Studio Tabs",
      studioTabsContent: "Choose between Images and Videos flows, and pick your creation tool",
      sourceUploadTitle: "Source Upload",
      sourceUploadContent: "Upload your image here to get started",
      promptAreaTitle: "Prompt Area",
      promptAreaContent: "Describe what you want to change",
      enhanceSuggestionsTitle: "Enhance & Suggestions",
      enhanceSuggestionsContent: "Use AI enhance or quick suggestions",
      generationBarTitle: "Generation Bar",
      generationBarContent: "Customize model, aspect ratio, resolution, quantity",
      generateButtonTitle: "Generate Button",
      generateButtonContent: "Click here to generate!",
      creationsGalleryTitle: "Creations Gallery",
      creationsGalleryContent: "Your creations appear here",
      next: "Next",
      back: "Back",
      skip: "Skip",
      finish: "Finish",
      close: "Close",
      nextLabelWithProgress: "Next (Step {step} of {steps})",
      open: "Open the dialog",
    },
    // SEO — per-route <title> + meta description. Keyed by `SeoKey` in
    // src/config/seo.ts. Shown to English-language users at runtime.
    seo: {
      home: {
        title: "TodoAI Studio — AI Visual Production for Brands & E-Commerce",
        description:
          "TodoAI Studio — Israeli AI platform to generate images, videos, talking avatars and product shots. Hebrew-first. Start free with 100 credits, no card.",
      },
      productCatalog: {
        title: "AI Product Photography for E-Commerce · TodoAI Studio",
        description:
          "TodoAI Studio — upload one product photo and get 4 studio-grade AI shots. Built for online stores, brands and marketplaces. No photographer, no studio. Start free.",
      },
      productCreative: {
        title: "AI Product Visuals & Ad Creative · TodoAI",
        description:
          "Turn a product photo into a professional ad visual with AI — clean backdrop, cinematic mood, no prompt-writing. Ready for ads and social.",
      },
      imageGenerator: {
        title: "AI Image Generator — Text to Image · TodoAI Studio",
        description:
          "TodoAI Studio — generate stunning images from text with AI. Built-in editor, 4K, no watermark. For brands, creators and e-commerce. Hebrew + English. Start free.",
      },
      profilePhoto: {
        title: "AI Profile Photos & Headshots · TodoAI",
        description:
          "Upload a selfie and get a professional LinkedIn-style profile photo made with AI. Pick a style and hairstyle — ready in under a minute.",
      },
      talkingAvatar: {
        title: "Hebrew Talking Avatar — Photo to Talking Video · TodoAI Studio",
        description:
          "TodoAI Studio — turn one photo into a Talking Avatar video with automatic lip-sync. Hebrew script support, made in Israel. For creators and small businesses. Start free.",
      },
      baseballTrend: {
        title: "Baseball Trend — Viral Video from a Photo · TodoAI",
        description:
          "Upload one photo and star in the viral baseball trend — a short clip of the camera catching you in the stands. Made with AI.",
      },
      textToVideo: {
        title: "AI Text to Video Generator · TodoAI",
        description:
          "Describe a scene in text and AI creates the video. Top-tier video models with no complex setup — one click.",
      },
      framesToVideo: {
        title: "Animate a Photo — Image to Video AI · TodoAI",
        description:
          "Turn a still photo into an animated video with AI. Upload an image and the system adds lifelike motion — great for products and social.",
      },
      imageDirector: {
        title: "Creative Director Chat — Create with AI · TodoAI",
        description:
          "Chat with TodoAI's smart creative director and let AI generate and edit images around your idea.",
      },
      pricing: {
        title: "Pricing — Plans & Credits · TodoAI Studio",
        description:
          "TodoAI Studio — transparent pricing in ILS. Start free with 100 credits. Starter (₪35), Pro (₪95), Creator (₪190) per month. Cancel anytime, no credit card for free tier.",
      },
      help: {
        title: "Help Center & FAQ · TodoAI",
        description:
          "Answers to common questions about TodoAI — getting started, supported files, generation times, support and more.",
      },
      contact: {
        title: "Contact Us · TodoAI",
        description:
          "Need help or want to talk to us? Get in touch with the TodoAI team and we'll get back to you shortly.",
      },
      terms: {
        title: "Terms of Service · TodoAI",
        description:
          "The terms of service for using the TodoAI image and video generation platform.",
      },
      privacy: {
        title: "Privacy Policy · TodoAI",
        description:
          "How TodoAI collects, uses and protects your information when you use the platform.",
      },
      accessibility: {
        title: "Accessibility Statement · TodoAI",
        description:
          "TodoAI's accessibility statement and our commitment to making the platform usable for everyone.",
      },
      // Comparison pages — title/description embed the competitor name so AI
      // engines match the page to "X vs TodoAI" intent immediately.
      compareMidjourney: {
        title: "Midjourney vs TodoAI — Which AI Image Generator Wins? | TodoAI",
        description:
          "Side-by-side comparison of Midjourney and TodoAI in 2026: pricing, Hebrew support, ease of use, included flows, and where each tool wins. Updated May 2026.",
      },
      compareHeygen: {
        title: "HeyGen vs TodoAI Talking Avatar — Side-by-Side | TodoAI",
        description:
          "Compare HeyGen and TodoAI's Talking Avatar in 2026: pricing, Hebrew lip-sync, ease of use, credits model, and which is right for small businesses. Updated May 2026.",
      },
      compareKling: {
        title: "Kling AI vs TodoAI Text-to-Video — Which Wins? | TodoAI",
        description:
          "Compare Kling AI and TodoAI's Text-to-Video in 2026: Hebrew support, pricing in shekels, ease of use, output quality, and which is better for solo creators. Updated May 2026.",
      },
    },
    // Referral program
    referral: {
      landingTitle: "{name} invited you to Todo AI",
      landingTitleGeneric: "You've been invited to Todo AI",
      landingSubtitle: "Create stunning AI images and videos in seconds. Subscribe to any paid plan and you and your friend each get bonus credits.",
      landingBadge: "Subscribe to a paid plan → you both get {credits} bonus credits",
      landingCta: "Sign up to get started",
      landingAlreadyMember: "You're already a member 🙂",
      landingAlreadyMemberCta: "Go to Refer & Earn",
      cardTitle: "Invite friends — you both earn {refereeCredits} credits",
      cardSubtitle: "When a friend subscribes to a paid plan, you each get bonus credits — {refereeCredits} for them, {referrerCredits} for you.",
      cardLinkLabel: "Your invite link",
      copy: "Copy",
      copied: "Link copied!",
      shareWhatsapp: "Share on WhatsApp",
      share: "Share",
      statsJoined: "joined",
      statsSubscribed: "subscribed",
      statsEarned: "credits earned",
      cardEmpty: "No invites yet. Share your link to start earning.",
      shareMessage: "I'm creating AI images and videos with Todo AI. Join with my link — subscribe to a paid plan and we each get {credits} bonus credits: {link}",
      bonusToast: "🎁 {name} invited you! Subscribe to a paid plan and you'll both get {credits} bonus credits.",
      bonusToastGeneric: "🎁 You're invited! Subscribe to a paid plan to unlock {credits} bonus credits.",
      earnedToast: "🎉 A friend subscribed! You earned {credits} credits.",
      refereeRewardToast: "🎉 Welcome bonus! You earned {credits} referral credits.",
      subscribeBannerText: "🎁 Subscribe to any paid plan and you and {name} each get {credits} bonus credits.",
      subscribeBannerTextGeneric: "🎁 Subscribe to any paid plan and you and your friend each get {credits} bonus credits.",
      loadError: "Couldn't load your referral info. Please try again.",
      retry: "Try again",
    },
    featureRequest: {
      dialogTitle: "Got an idea?",
      dialogDescription: "We read every one. Your first idea gets you {count} free credits.",
      titleLabel: "Title",
      titlePlaceholder: "In one sentence, what would you add?",
      descriptionLabel: "Tell us more",
      descriptionPlaceholder: "How would it work? Which flow does it fit in? Why does it matter to you?",
      categoryLabel: "Category",
      phoneLabel: "Phone (optional)",
      phonePlaceholder: "",
      category: {
        newFlow: "New flow / feature",
        improveFlow: "Improve an existing flow",
        pricing: "Pricing",
        account: "Account / profile",
        other: "Other",
      },
      notifyOnShip: "Email me when this ships",
      submit: "Send idea",
      submitting: "Sending...",
      submitSuccess: "Thanks! We got your idea.",
      submitSuccessWithCredits: "Thanks! You just earned +{count} credits.",
      submitError: "Couldn't send your idea. Please try again.",
      descriptionMinHint: "need {min}+ chars",
      validation: {
        titleTooShort: "Add a short title (at least {min} characters).",
        descriptionTooShort: "Tell us a bit more, at least {min} characters.",
      },
      status: {
        new: "New",
        underReview: "Under review",
        planned: "Planned",
        inProgress: "In progress",
        shipped: "Shipped",
        declined: "Declined",
      },
      profileCard: {
        heading: "Got an idea?",
        subtitle: "Tell us what to build next. Your first request gets you +{count} credits.",
        cta: "Suggest a feature",
        yourIdeasTitle: "Your submitted ideas",
        empty: "No requests yet.",
        loadError: "Couldn't load your ideas.",
      },
      postGen: {
        prompt: "Wish this could do something else?",
        cta: "Tell us",
        dismiss: "Dismiss",
      },
      galleryBadge: {
        cta: "Suggest an idea",
      },
      admin: {
        title: "Feature requests",
        empty: "No feature requests.",
        filterLabel: "Filter by status",
        filterAll: "All",
        colUser: "User",
        colTitle: "Title",
        colCategory: "Category",
        colStatus: "Status",
        colSource: "Source",
        colCreatedAt: "Submitted",
        adminNotesLabel: "Admin notes",
        adminNotesPlaceholder: "Internal note (not sent to the user)",
        save: "Save",
        saving: "Saving...",
        saved: "Saved",
        saveError: "Save failed",
        loadError: "Couldn't load requests.",
      },
    },
  },
} as const;

export type Language = keyof typeof translations;

/**
 * Get the current translations object based on the language stored in localStorage.
 * Useful for non-React contexts (e.g. utility functions) that can't use useLanguage().
 */
export function getCurrentTranslations() {
  const lang = localStorage.getItem("flowly-language") === "he" ? "he" : "en";
  return translations[lang];
}
